import { Component, HostListener, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FeeManagementService } from './feesmanage.service';
import { FormValidator } from '../form.validator';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { AppSettings } from '../../config/config';
import { GroupService } from '../groups/groups.service';
import { AdmissionService } from '../admission/admission.service';
import { GroupsComponent } from '../groups/groups.component';
import { HeaderComponent } from '../header/header.component';
import { TransportService } from '../transport/transport.service';
import { ScriptLoader } from '../script-loader';
import * as registrationStrings from "../stringFiles/registration.json";
import { first, firstValueFrom, Subscription } from 'rxjs';
import * as feesStrings from "../stringFiles/fees.json";
import { EditStudentPopupComponent } from "../edit-student-popup/edit-student-popup.component"
import { EventManager } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { BrandService } from '../brand/brand.service';
import * as XLSX from 'xlsx-js-style';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

declare let $: any;
declare let jquery: any;
declare let d3: any;
declare let customToastr: any;
declare let momentJs: any;
declare let moment_js: any;
declare let jQuery: any;

@Component({
  selector: 'app-feesmanage',
  templateUrl: './feesmanage.component.html',
  styleUrls: ['./../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/wizard/wizard.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    /*'./../../assets/js/core/timepicker/timepicker.css',*/
    './../../_crop/css/style.css',
    './../../_crop/css/style-example.css',
    './feesmanage.component.css'],

  encapsulation: ViewEncapsulation.None,
  providers: [FeeManagementService, LoginService, FormValidator, HeaderService, Offcanvas, GroupService, AdmissionService,
    GroupsComponent, HeaderComponent, TransportService, ScriptLoader, EditStudentPopupComponent],
})


export class FeesManagementComponent implements OnInit {
  @ViewChild('requestConfirmModal') requestConfirmModal: ElementRef;
  brand = this.brandService.brand;
  constructor(private feeService: FeeManagementService, private router: Router, private loginservice: LoginService,
    private formValidator: FormValidator, private headerservice: HeaderService,
    private offcanvas: Offcanvas, public groupsComponent: GroupsComponent, public headerComponent: HeaderComponent,
    public editStudentPopupComponent: EditStudentPopupComponent,
     private messageService: MessageService,
    private admissionservice: AdmissionService, private scriptLoader: ScriptLoader, private translate : TranslateService,
    private brandService: BrandService) {
    this.strings = registrationStrings;
    this.feesStrings = feesStrings;
  }
  paymentGateways: any[] = [];
  private langChangeSub: Subscription;
  sequenceFeeCollection : boolean = true;
  strings: any;
  showOldMerchantAccountPayment = false;
  isGatewayEnable: boolean = false
  showPopup = false;
  selectedGateway: any;
  authToken = localStorage.getItem('usertoken');
  schoolId = localStorage.getItem('schoolinfo');
  feesStrings: any;
  isStudentActiveForDiscount = true;
  adminType = localStorage.getItem('adminType');
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  backupStudentFeeDashDetails = {
    student: { studentId: null, studentName: '', parentName: '', classNumber: '', classDivision: '', rollNumber: '', classId: null },
    TermFees: { TermAmount: 0, Paid: 0, Discount: 0, Balance: 0, feeStrutureId: null },
    TypeFees: { FeeTypeAmount: 0, Paid: 0, Discount: 0, Balance: 0 }
  };
  studentFeeDashDetails = JSON.parse(JSON.stringify(this.backupStudentFeeDashDetails));
  academicInfo = {
    current_academic: '',
    current_academic_state: '',
    current_tab: 'OVERVIEW',
    year: '',
    academicList: []
  };
  schoolAcademicId = '';
  newStudentFeeList = { termFees: [], typeFees: [], feeSetting: { isFeesModuleEnable: '' }, otherFeeTerms: [] };
  studentFeeList = JSON.parse(JSON.stringify(this.newStudentFeeList));
  isSearchActive = true;
  resultsExist = false;
  submitText = 'Submit';
  feesTermConfigButtonSubmitText = 'Save';
  feesTermConfigCancelButtonSubmitText = 'Cancel';
  feePaymentProceedText = 'proceed Payment';
  feeDashDetails: any = {};
  totalLateFeesPaid = null;

  // Raw response.body from getSchoolWiseFeesOverview — kept around so
  // switching studentStatusFilter can re-derive the Overview stat cards
  // without another API call (the endpoint returns total/active/deactive
  // slices in one response). Replaces the old getFeeDashDetails() +
  // getPaidLateFeeCount() combo, which only ever covered the school-wide total.
  private feesOverviewByStatus: { total: any; active: any; deactive: any } | null = null;
  private classWiseFeesData: any[] = [];
  studentStatusFilter: 'total' | 'active' | 'inactive' = 'total';

  // Called directly from the All/Active/Inactive toggle buttons' (click),
  // each with a literal value — always reassigns and re-derives the stat
  // cards for the clicked filter (no need to compare against the previous
  // value first).
  setStudentStatusFilter(filter: 'total' | 'active' | 'inactive'): void {
    this.studentStatusFilter = filter;
    this.applyFeesOverviewForCurrentStatus();
    if (this.isShowFeeDetailsOverview) {
      this.applyClassWiseFeesForCurrentStatus();
    }
  }

  // 'inactive' (UI naming) maps to the API's 'deactive' response key.
  private applyFeesOverviewForCurrentStatus(): void {
    if (!this.feesOverviewByStatus) {
      return;
    }
    const slice = this.studentStatusFilter === 'inactive'
      ? this.feesOverviewByStatus.deactive
      : this.feesOverviewByStatus[this.studentStatusFilter];
    this.feeDashDetails = {
      TotalAmount: Number(slice?.totalExpectedCollection) || 0,
      CollectedAmount: Number(slice?.totalCollectedAmount) || 0,
      DiscountAmount: Number(slice?.totalDiscountAmount) || 0,
      PendingAmount: Number(slice?.totalPendingAmount) || 0,
    };
    this.totalLateFeesPaid = Number(slice?.totalLateFees) || 0;
  }
  standardFeeDetails = [];
  schoolFinancialTermFeeOverviewList = [];
  schoolFinancialTermFeeOverviewListProcessing = false;

  classStanderds = [];
  classStanderdsNotInFeesBoard = [];
  classSectionsNotInFeesBoard = [];
  classSections = [];
  classStandards = [];
  feeBoardData = [];
  termFeeConfigurations = [];
  termList = [];
  feeComponentList = [];
  feeComponentListAddFeeBoard = [];
  feeStructureName = null;
  standardsFeeTable = null;
  termFeeConfigurationTable = null;
  classFeeTable = null;
  feeComponentTable = null;
  feeHistoryTable = null;
  feeUpdateHistoryTable = null;
  feeBoardTable = null;
  feesBoardTabTable = null;
  feeTermTable = null;
  lateFeeTable = null;
  deletedLateFeeTable = null;
  waivedOffLateFeeTable = null;
  paidLateFeeTable = null;
  applyLateFee = true;
  loaded = false;
  current = null;
  standardsTableInitial = null;
  now = null;
  element = null;
  selectedClass: any = { classNumber: '', classDivision: '' };
  academicList = [];

  feeTermList = [];

  studentList = [];
  initialDataCreateFeeType = { Name: '', includeInTerm: false, academicId: '', AppliesTo: 'ALL_STUDENTS', duedate: '' };
  initialDataCreateFeeTerm = { TermName: '', academicId: '', duedate: '' };
  createFeeComponent = JSON.parse(JSON.stringify(this.initialDataCreateFeeType));
  editFeeComponent = JSON.parse(JSON.stringify(this.initialDataCreateFeeType));
  createFeeTerm = JSON.parse(JSON.stringify(this.initialDataCreateFeeTerm));

  initialDataCreateLateFee = { lateDays: '', academicId: '', lateFees: '' };
  createLateFee = JSON.parse(JSON.stringify(this.initialDataCreateLateFee));
  lateFeeList = [];
  deletedLateFeeList = [];
  waivedOffLateFeeList = [];
  paidLateFeeList = [];
  selectedLateFeeData = { id: null };

  selectedClassSectionFeeBoard: any = { feeTypes: [], classId: null };
  editTermFeeConfig: any = { fkClassId: '', pkFeesTypeId: '', termFees: [], Amount: 0 };


  selectedPayment = [];
  payableAmount = 0;
  payableLateFee = 0;
  paymentMode = '';
  selectedPaymentType = '';
  finalPaymentList = [];
  classIdForFee = [];
  feeReceipt = [];
  feeCollectionHistoy = [];
  feeCollectionUpdateHistoy = [];
  feeReceiptStd: any;
  lastSelectedStudent: any;
  editTermData: any = { DueDate: null };
  feeHistoryPageNumber = 1;
  isLastPageExist = true;
  appliedDiscountStudentList = [];
  discountlist = [];
  termlist = [];
  typelist = [];

  selectedclassId = '';
  selectedStudent = '';
  selectedSectionId = '';
  sectionId = '';
  discount = { pkSchoolDiscountId: '' };
  addDiscount = {
    feeStructuresId: 'general',
    discountName: '',
    discountReason: '',
    discountAmount: '',
    discountAmountType: 'AMOUNT',
    compdisc: [{ fkFeesTermId: '', fkFeesTypeId: '' }]
  };
  newAddNewStudentCategory = { name: '', description: '', remainingDescriptionLength: 300 };
  addNewStudentCategory = JSON.parse(JSON.stringify(this.newAddNewStudentCategory));
  deleteStudentCategoryDetails = JSON.parse(JSON.stringify(this.newAddNewStudentCategory));
  newAddNewFeeStructure = { name: '', description: '', remainingDescriptionLength: 300, studentCategoryId: 0 };
  addNewFeeStructure = JSON.parse(JSON.stringify(this.newAddNewFeeStructure));
  newAddNewOtherFee = { name: '', amount: 0, oldName: '', oldAmount: 0 };
  addNewOtherFee = JSON.parse(JSON.stringify(this.newAddNewOtherFee));
  selectedOtherFee = { Name: '', pkOtherFeesId: null, studentsCount: 0, amount: 0 };
  studentCategoryList = [];
  otherFeeList = [];
  studentsInOtherFee = [];
  newOtherFeeTerm = { pkOtherFeeTermId: null, termName: '', termAmount: 0, termDueDate: '', paidAmount: 0 };
  otherFeeTermsList = JSON.parse(JSON.stringify([this.newOtherFeeTerm]));
  deletedOtherFeeTermsList = JSON.parse(JSON.stringify([]));
  fetchOtherFeesTermsProgress = false;
  discountStudentList = [];
  applyDiscountStatus = [];
  classFeesSettings = [];
  onlinePaymentPurposes = [];
  paymentLimits: any = {};
  feesSettingsInfo = [];
  createPurpose = '';
  deletePurposeInfo = null;
  instamojoUser = {
    userId: '',
    username: '',
    emailId: '',
    phoneNumber: '',
    bankHolderName: '',
    bankAccountNumber: '',
    bankIFSCCode: '',
    schoolImage: ''
  };
  merchantAcccSts = '';
  createMerchant = { username: '', email: '', phone: '', password: '', confirmPassword: '' };
  loginInstamojo = { username: '', password: '' };
  bankDetailsUpdate = { bankHolderName: '', accountNumber: '', iFSCCode: '', userId: '' };
  academicPermissions: any = {
    SCHOOL_FEES_DASHBOARD: '',
    FEES_BOARD: '',
    FEES_COLLECTION: '',
    FEES_DISCOUNT: '',
    FEES_SETTINGS: '',
    SCHOOL_ADMIN_FEE_COLLECTION_VIEW: '',
    OTHER_FEES: '',
    DELETE_COLLECTED_FEE: ''
  };
  schoolImage = '';
  isProcessing = false;
  schoolClasses = [];
  studentCategorySearchStudentResults = [];
  otherFeeSearchStudentResults = [];
  searchStudentListForCategoryTable = null;
  existingCategoryStudentListTable = null;
  searchStudentListForCategorySelectedCount = 0;
  searchStudentListForOtherSelectedCount = 0;
  selectAllStudentCategorySearchStudentResultsCheckedValue = false;
  selectAllStudentOtherFeeSearchStudentResultsCheckedValue = false;
  selectedCategoryToMove = 0;
  selectedStudentIdToMove = 0;
  selectedStudentCategoryMemberId = 0;
  selectedClassDetails = {};
  feeBoardDataHeader = [];
  getClassIdForFeeBoard = '0';
  feeBoardStatus = false;
  termConfigStatus = false;
  termConfigHistoryStatus = false;
  feeBoardHistoryStatus = false;
  feeBoardTableList = false;
  selectClassForFeeDetail = true;
  structureList = [];
  feeBoardDataStructureName = [];
  getStructureId = '';
  getClassId = '';
  isTermConfigchanged = false;
  isFeeBoardchanged = false;
  feeConfigStrucName = [];
  termConfigData = [];
  feesBoardDataAllClasses = [];
  feesBoardDataAllClassesStrList = [];
  isOldFee = false;
  isLateFee = false;
  getFeeBoardHistoryForView = [];

  feeCollectionAllFeeList = [];
  feeCollectionOtherFeeTermFeeList = [];
  feesCollectionHistoryListTable;
  includeLateFeeInTransportFee: number = 1;


  // termHistorydetailsforupdate
  getTermConfigHistoryForView = [];
  getFeeTypeId = '';
  getFeeStructureId = '';
  getFeeTermConfigLocalTime = '';

  // For reports
  startDateForFeeCollection = '';
  endDateForFeeCollection = '';

  // For reports
  startDateForFeeReports = '';
  endDateForFeeRepors = '';

  processingNwCall = false;
  selectedFeeToDelete = null;
  deleteFeeStep = 1;
  updateFeeReasonsList = [];
  selectedReasonToDeleteFee = '0';
  passwordToDeleteFee = '';
  newReasonToDeleteFee = '';
  totalPayableAmount;
  allFeeNames = { typeList: [], termList: [], busTermList: [] };
  feeStructureListForSelect = [];
  processingNW = false;
  selectedDiscount: any = { fkFeeStructuresId: null, pkStudentsCategoryId: null, createdOn: null, pkSchoolDiscountId: null };
  classSectionsInStudentCategory = [];
  applyDiscountStudentsList = null;
  selectDeleteAppliedDiscountAllVal = false;
  changePopupState = null;
  collectionByAdmin = [];
  feesCollectionModesWise: any;
  totalSelectedAmount = 0;
  deletingFeeList = [];
  fetchAdminCollectedFeeisLoading = false;
  fetchTermFeeBreakupisLoading = false;
  feeComponentsInTerm = [];
  termFeeBreakups = [];
  selectedAdminName = '';
  adminCollectedFees = { allFeeNames: [], data: [] };
  adminCancelledFees = [];
  newConfigurationGroupName = '';
  createGroupFormState = false;
  feeConfigGroupListLoading = true;
  currentYear;
  feeReceiptSetting = { isFeesModuleEnable: '' };
  otherFeeTable = null;
  feesCollectionHistoryTableColumns = [];
  feesCollectionHistoryTableAjaxInput = {};
  selectedOverdueStudentsCount = 0;
  selectedOverdueStudentsList = [];
  openSendSMSView = false;
  isLateFeeIncluded: boolean = false;
  isLateFeeIncludedForReport: boolean = false;
  errorStudentFeeCollectionProcess = {
    message: 'There was an error while fetching Student fee details,<br> Please click on <b>Re-Fetch Details</b> to fetch again.',
    isError: false,
    title: 'OOP\'s',
    buttonText: 'Re-Fetch Details',
    prefixMessage: '<b>We Are Sorry,</b><br><br>'
  };

  feeReceiptOpenedFrom;
  openStudentTransportOptionSettingsPopup = false;
  reasonId = null;
  reason = null;
  currType = '';

  // token auth
  loginMode = '';
  studentAllAcademicFee = [];
  studentAllSiblings = [];
  allStudentAllFee = [];
  headerFeeName = [];
  busDetail = [];
  studentCollectedAmount = [];
  studentBusFeeCollection = [];

  studentFeeStatus = false;
  studentFeeDetailTable = false;

  strListOnce = true;
  dataFetching = true;

  feeBoardDataDetails = [];

  getStructureName = '';

  getTypeName = '';
  getClassIdForHistory = '';

  tab1Status = false;
  tab2Status = false;
  paymentStatus = false;
  modePayStatus = false;
  allLateFees : any;
  breakupFeeTermName = '';

  once = true;

  previewPaymentDetailsData = null;


  startDate = '';
  endDate = '';
  FeeCollection = [];
  FeeTotalCollection = [];
  cardCashAmount = [];
  collectionModes = [];
  feeHistorytotalAmnt;
  feeHistorytotalAmntCash;
  feeHistorytotalAmntCard;
  feeHistorytotalAmntOnline;
  feeHistorytotalAmntCheque = 0;
  feeHistorytotalAmntDD = 0;
  feeHistorytotalAmntDiscount = 0;
  feeHistoryNumberOfStudents = 0;
  feeHistoryNumberOfStudentsForCard = 0;
  feeHistoryNumberOfStudentsForCash = 0;
  feeHistoryNumberOfStudentsForOnline = 0;
  feeHistorytotalAmntForStu;

  openStudentBasicInfoPopup = false;
  openStudentContactInfoPopup = false;

  getCatIdForFees = '';
  isStudentDeactiveStatusChecked: boolean = true;
  isStudentDeactivated = false;
  isActivateDeactivateButtonVisible = true;
  selectedStructureId;
  feeCollectionTimestamp;
  paymentLoader: boolean = false;
  loader: boolean = false;
  gateWayRequestLoader: boolean = false;
  discountLoader: boolean = false;
  supportedCurrencyList : any = []
  isShowFeeDetailsOverview: boolean = false;
  classWiseFeesCurrentPage: number = 1;
  classWiseFeesMaxPage: number = 0;
  openEditStudentPopup = false;
  currentPage: number = 1;
  maxPage: number = 0;
  isShowFeeBoard = false;
  classListForFee = [];
  selectedClassIdForFeeCopy = null;
  originalFeeBoardConfig = [];
  isFeeBoardDataCopied = false
  selectedClassForFeeBoard = null;
  originalFeeTermConfig = [];
  selectedClassIdForFeeTerm = null;
  selectedClassForTermInfo = null;
  isLateFeeIncludedInCurrentMonth: boolean = false;
  showLateFeeAddComponent : boolean = false;
  lateFeesDays : string = "";
  lateFeesAmount : string = "";
  selectedLateFeesId = "";
  isAddingLateFees = false;
  transportList = [];
  termFeeList = []
  feesList = [];
  isLoadingLateFees = true;  
  selectAllFees: boolean = false;
  selectAllTermFees: boolean = false;
  selectAllTypeFees: boolean = false;
  selectAllTransportFees: boolean = false;
  expandedItems: boolean[] = [];
    loadTranslations() {
    this.translate.get('lateFeesPopUp').subscribe(res => {
      this.allLateFees = res;
    });
  }

  ngOnInit() {
    this.loadTranslations();

    // reload when language changes
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTranslations();
    });
    this.selectAllFees = false;
    this.selectAllTermFees = false;
    this.selectAllTypeFees = false;
    this.selectAllTransportFees = false;
     this.resetTransportFeesIfDisabled();
  // }


    // tslint:disable-next-line:max-line-length
    /* $('body').append('<script async type="text/javascript" src="https:// d1hk2frk8zkww3.cloudfront.net/jquery/datatable/dataTables.buttons.min.js"></script>' +
       '<script async type="text/javascript" src="https:// d1hk2frk8zkww3.cloudfront.net/jquery/datatable/buttons.flash.min.js"></script>' +
       '<script async type="text/javascript" src="https:// d1hk2frk8zkww3.cloudfront.net/jquery/datatable/buttons.html5.min.js"></script>' +
       '<script async type="text/javascript" src="https:// d1hk2frk8zkww3.cloudfront.net/jquery/datatable/buttons.print.min.js"></script>' +
       '<script async type="text/javascript" src="https:// d1hk2frk8zkww3.cloudfront.net/jquery/datatable/buttons.colVis.min.js"></script>');
 */
    
    this.loginMode = localStorage.getItem('loginMode');
    this.currType = localStorage.getItem('currency') || 'INR';
    this.scriptLoader.loadScript($, 'ACADEMICS');
    if (this.loginMode === 'STAFF') {
      this.router.navigate(['/exams']);
    }
    this.feesCollectionHistoryTableColumns = [
      { name: 'Student Name', data: 'studentName' },
      { name: 'Parent Name', data: 'parentName' },
      { name: 'Mobile', data: 'mobileNumber' },
      { name: 'Amount', other: this.currType, data: 'Amount' },
      { name: 'Class', data: 'className' },
      { name: 'Fee Name', data: 'feeName' },
      { name: 'Fee Type', data: 'feeType' },
      { name: 'Date', data: 'collectionDate' },
      { name: 'Payment Mode', data: 'ModeOfPayment' }
    ];
    this.feesCollectionHistoryTableAjaxInput = { startDate: '', endDate: '', academicId: null };
    const currentTime = new Date();
    this.currentYear = currentTime.getFullYear();
    this.textWrappingForTermName(this.schoolId);
    this.textWrappingForTermNamestruc(this.schoolId);

    this.openEnabledTabs(false);

    this.isValidToken();
    /*$.getScript( "assets/js/core/timepicker/timepicker.js", function( data, textStatus, jqxhr ) {

    });*/
    $("body").append("<script  async src='assets/js/core/timepicker/timepicker.js'></script>")
    $('body').append(`<script>
    $("body").find('#print-fee-form').on('click', function () {
        $(".hide-while-print").hide();
           let DocumentContainer = document.getElementById('fee-receipt-print-container');
           let name = $("#receipt-student-name").text()+" - "+$("#receipt-student-class").text()+" - "+
           $("#receipt-id-receipt").text();
           let WindowObject = window.open(DocumentContainer.innerHTML, "Receipt",
           "width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no");
           WindowObject.document.writeln(DocumentContainer.innerHTML);
           WindowObject.document.close();
           WindowObject.focus();
           WindowObject.open();
           WindowObject.print();
           WindowObject.close();
        $(".hide-while-print").show();
    });

    $("body").find('#print-fee-consession-form').on('click', function () {
      $(".hide-while-print").hide();
         let DocumentContainer = document.getElementById('fee-consession-print-container');
         let name = $("#receipt-student-name").text()+" - "+$("#receipt-student-class").text()+" - "+
         $("#receipt-id-receipt").text();
         let WindowObject = window.open(DocumentContainer.innerHTML, "Receipt",
         "width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no");
         WindowObject.document.writeln(DocumentContainer.innerHTML);
         WindowObject.document.close();
         WindowObject.focus();
         WindowObject.open();
         WindowObject.print();
         WindowObject.close();
      $(".hide-while-print").show();
  });

    </script>`);

    $('#device-breakpoints').remove();
    this.standardsTableInitial = $('#datatable100').clone();
    this.now = new Date().toISOString();

    // Fee history
    $('#startdate').datepicker({ autoclose: true, endDate: new Date() });
    $('#enddate').datepicker({ autoclose: true, endDate: new Date() });

    // Fee reports
    $('#rstartdate').datepicker({ autoclose: true, endDate: new Date() });
    $('#renddate').datepicker({ autoclose: true, endDate: new Date() });

    const h = this;
    $('body').on('click', '#editTerm', function () {
      let self = h.getSelf();
      self.offcanvas.handleOffcanvasOpen('#offcanvas-manage-termFee');
      self.editTermData = JSON.parse($(this).attr('termData'));
      if (self.editTermData.DueDate) {
        const d = new Date(self.editTermData.DueDate);
        self.editTermData.DueDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
        $('#dueDate_term').val(self.editTermData.DueDate);
      }
      $('#dueDate_term').datepicker({ autoclose: true });
    });
    $('body').on('click', '#removeterm', function () {
      $('#delete_data_popup').trigger('click');
      const termData = JSON.parse($(this).attr('termData'));
      this.translate.get('areYouSureYouWantToDelete').subscribe((translatedText: string) => { $('#delete_text').text(translatedText); });
      $('#delete_data_popup').attr('data_id', termData.pkFeesTermId);
      $('#delete_data_popup').attr('data_type', 'term');
    });
    $('#term').click(() => {
      $('.term-item').show();
      $('.typeComponent').hide();
    });
    $('#type').click(() => {
      $('.typeComponent').show();
      $('.term-item').hide();
    });
    $('body').on('click', '#removelatefee', function () {
      const lateFeeData = JSON.parse($(this).attr('lateFeeData'));
      h.selectedLateFeeData.id = lateFeeData.pkLateFeesId;
      $('#delete_lateFeeData_popup').trigger('click');
      $('#delete_late_text').text(lateFeeData.lateDays);
    });

    $('#previous_add_fee').on('click', () => {
      $('#open_step_1_add_fee_board').trigger('click');
    });

    $('#add-class-setting-online-button').on('click', () => {
      $('#add-class-setting-online-div').show();
    });

    $('#add-class-setting-online-cancel').on('click', () => {
      $('#add-class-se' +
        'tting-online-div').hide();
    });

    $('body').find('#search-reg-id').on('click', function () {
      $('.filter-active').removeClass('filter-active');
      $(this).addClass('filter-active');
      $('#groupbutton10').val('');
      $('#groupbutton10').attr('placeholder', 'Search Student By Registration Number');
      h.studentList = [];
    });

    $('body').find('#search-by-name').on('click', function () {
      $('.filter-active').removeClass('filter-active');
      $(this).addClass('filter-active');
      $('#groupbutton10').val('');
      $('#groupbutton10').attr('placeholder', 'Search Student By Student Name');
      h.studentList = [];
    });

    $('body').find('#search-by-mobile').on('click', function () {
      $('.filter-active').removeClass('filter-active');
      $(this).addClass('filter-active');
      $('#groupbutton10').val('');
      $('#groupbutton10').attr('placeholder', 'Search Student By Mobile Number');
      h.studentList = [];
    });

    $('#confirm-student-details-updated').on('click', () => {
      h.searchStudent('NO');
    });
    this.feeCollectionTimestamp = moment_js().valueOf();
        this.langChangeSub = this.translate.onLangChange.subscribe(async (event: LangChangeEvent) => {
           this.destroyDataTable('datatable100');
           this.destroyDataTable('components-fee');
             this.destroyDataTable('term-component-table');
             this.destroyDataTable('late-fee-component-table');
             this.destroyDataTable('school-other-fee-list');
                   this.destroyDataTable('student-category-list');
                   this.destroyDataTable('fee-structure-list');
                     this.destroyDataTable('fee-discounts-table');
                     this.destroyDataTable('appliedStudentList');
                     this.initializeDataTable_withLowPageLength('appliedStudentList',7)
             
             this.initializeDataTable('school-other-fee-list')
             this._initializeDataTable('fee-discounts-table')
            
             this.initializeDataTable('fee-structure-list');
            this.initializeDataTable('student-category-list');
           this.standardsFeeTable = null;
           this.feeComponentTable = null;
           this.feeTermTable = null;
           this.lateFeeTable = null;
          this.applyStandardsFeeTable(); 
          this.applyFeeComponentTable();
          this.applyFeesTermTable();
          this.applyLateFeesTable();
          this.initDataTableServerProcess('fee-collection-history-table', this.schoolId, this.authToken,
        this.startDateForFeeCollection, this.endDateForFeeCollection);
    });

  }
  getSelf() {
    return this;
  }

  onIncludeLateFeeInTransportFeeChange(value: number) {
  this.includeLateFeeInTransportFee = value;
  this.resetTransportFeesIfDisabled();
}

resetTransportFeesIfDisabled() {
  if (this.includeLateFeeInTransportFee === 0) {
    // Uncheck the select all checkbox
    this.selectAllTransportFees = false;
    
    // Uncheck all individual transport fees
    if (this.transportList && this.transportList.length > 0) {
      this.transportList.forEach(fee => {
        fee.isFeeSelected = false;
      });
    }
  }
}


  onSelectAllTermFeesChange() {
    if (this.feesList && this.feesList.length > 0) {
      this.feesList.forEach(fee => {
        fee.isFeeSelected = this.selectAllTermFees;
      });
    }
    this.checkSelectAllStatus();
  }

  // Method to select/deselect all type fees
  onSelectAllTypeFeesChange() {
    if (this.termFeeList && this.termFeeList.length > 0) {
      this.termFeeList.forEach(fee => {
        fee.isFeeSelected = this.selectAllTypeFees;
      });
    }
    this.checkSelectAllStatus();
  }

  // Method to select/deselect all transport fees
  onSelectAllTransportFeesChange() {
    if (this.transportList && this.transportList.length > 0) {
      this.transportList.forEach(fee => {
        fee.isFeeSelected = this.selectAllTransportFees;
      });
    }
    this.checkSelectAllStatus();
  }

  // Check if all term fees are selected
  checkSelectAllTermStatus() {
    if (this.feesList.length === 0) {
      this.selectAllTermFees = false;
      return;
    }
    this.selectAllTermFees = this.feesList.every(fee => fee.isFeeSelected);
  }

  // Check if all type fees are selected
  checkSelectAllTypeStatus() {
    if (this.termFeeList.length === 0) {
      this.selectAllTypeFees = false;
      return;
    }
    this.selectAllTypeFees = this.termFeeList.every(fee => fee.isFeeSelected);
  }

  // Check if all transport fees are selected
  checkSelectAllTransportStatus() {

   if (this.transportList && this.transportList.length > 0) {
    this.selectAllTransportFees = this.transportList.every(fee => fee.isFeeSelected);
  }
    // if (this.transportList.length === 0) {
    //   this.selectAllTransportFees = false;
    //   return;
    // }
    // this.selectAllTransportFees = this.transportList.every(fee => fee.isFeeSelected);
  }



  onSelectAllFeesChange() {
  if (this.feesList && this.feesList.length > 0) {
    this.feesList.forEach(fee => {
      fee.isFeeSelected = this.selectAllFees;
    });
  }

  if (this.termFeeList && this.termFeeList.length > 0) {
    this.termFeeList.forEach(fee => {
      fee.isFeeSelected = this.selectAllFees;
    });
  }

  // if (this.transportList && this.transportList.length > 0) {
  //   this.transportList.forEach(fee => {
  //     fee.isFeeSelected = this.selectAllFees;
  //   });
  // }

   if (this.transportList && this.transportList.length > 0 && this.includeLateFeeInTransportFee === 1) {
    // Only select transport fees if late fee is included
    this.transportList.forEach(fee => {
      fee.isFeeSelected = this.selectAllFees;
    });
  }

  // Update individual category checkboxes
  this.selectAllTermFees = this.selectAllFees && this.feesList.length > 0;
  this.selectAllTypeFees = this.selectAllFees && this.termFeeList.length > 0;

  // this.selectAllTransportFees = this.selectAllFees && this.transportList.length > 0;

    if (this.includeLateFeeInTransportFee === 1) {
    this.selectAllTransportFees = this.selectAllFees && this.transportList.length > 0;
  }
}

  checkSelectAllStatus() {
  const hasAnyItems = this.feesList.length > 0 || this.termFeeList.length > 0 || this.transportList.length > 0;

  if (!hasAnyItems) {
    this.selectAllFees = false;
    return;
  }

  const feesListSelected = this.feesList.length > 0 ? this.feesList.every(fee => fee.isFeeSelected) : true;
  const termFeeListSelected = this.termFeeList.length > 0 ? this.termFeeList.every(fee => fee.isFeeSelected) : true;
  // const transportListSelected = this.transportList.length > 0 ? this.transportList.every(fee => fee.isFeeSelected) : true;

  const transportListSelected = this.transportList.length > 0 && this.includeLateFeeInTransportFee === 1
  ? this.transportList.every(fee => fee.isFeeSelected)
  : true;

  const allExistingSelected = feesListSelected && termFeeListSelected && transportListSelected;

  this.selectAllFees = hasAnyItems && allExistingSelected;
  
  // Also update individual category select all statuses
  this.checkSelectAllTermStatus();
  this.checkSelectAllTypeStatus();
  this.checkSelectAllTransportStatus();
}


  
  openEnabledTabs(isOldAcademicId) {
    this.isShowFeeBoard = false
    this.feesBoardDataAllClasses = [];
    const adminPermissionlist = localStorage.getItem('adminPermissionlist');
    if (adminPermissionlist) {
      this.academicPermissions = JSON.parse(adminPermissionlist);

      if (this.academicPermissions.SCHOOL_FEES_DASHBOARD !== 'ENABLED') {
        $('body').find('#overview_tab').removeClass('active');
        $('body').find('#overview').removeClass('active');
        this.academicInfo.current_tab = 'OVERVIEW';
        if (!isOldAcademicId) {
          if (this.academicPermissions.FEES_BOARD === 'ENABLED') {
            $('body').find('#feeboard_tab').addClass('active');
            $('body').find('#feeboard').addClass('active');
            this.academicInfo.current_tab = 'FEES_BOARD';
            // this.openFeeBoardTab();
            
          } else if (this.academicPermissions.FEES_COLLECTION === 'ENABLED' ||
            this.academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW === 'ENABLED') {
            $('body').find('#fee_collection_tab').addClass('active');
            $('body').find('#fee-collections').addClass('active');
            this.academicInfo.current_tab = 'FEE_COLLECTION';
            this.feesCollectionTabClicked();
          } else if (this.academicPermissions.FEES_DISCOUNT === 'ENABLED') {
            $('body').find('#discount_tab').addClass('active');
            $('body').find('#discount').addClass('active');
            this.academicInfo.current_tab = 'DISCOUNTS';
            this.discountDetails();
          } else if (this.academicPermissions.FEES_SETTINGS === 'ENABLED') {
            $('body').find('#fee_settings_tab').addClass('active');
            $('body').find('#fees-settings').addClass('active');
            this.openFeesSettingsTab();
          }
        } else {
          if (this.academicPermissions.FEES_COLLECTION === 'ENABLED' ||
            this.academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW === 'ENABLED') {
            $('body').find('#fee_collection_tab').addClass('active');
            $('body').find('#fee-collections').addClass('active');
            this.academicInfo.current_tab = 'FEE_COLLECTION';
            this.feesCollectionTabClicked();
          } else if (this.academicPermissions.FEES_DISCOUNT === 'ENABLED') {
            $('body').find('#discount_tab').addClass('active');
            $('body').find('#discount').addClass('active');
            this.academicInfo.current_tab = 'DISCOUNTS';
            this.discountDetails();
          } else if (this.academicPermissions.FEES_SETTINGS === 'ENABLED') {
            $('body').find('#fee_settings_tab').addClass('active');
            $('body').find('#fees-settings').addClass('active');
            this.openFeesSettingsTab();
          }
        }
      }
    }
  }

  tootip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  isValidToken() {
    let isValidToken = false;
    let isValidSchool = 0;
    this.loginservice.isValidToken(this.authToken)
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if (data.errorcode === 10010) {
            this.router.navigate(['/suspended']);
          } else if (isValidToken === true) {

            this.loginservice.isValidSchoolId(this.schoolId)
              .subscribe(
                (validData: any) => {
                  isValidSchool = validData.schoolExist;
                  if (isValidSchool !== 1) {
                    this.router.navigate(['/login']);
                  } else if (this.loginMode === 'STAFF') {
                    this.router.navigate(['/exams']);
                  } else {
                    this.initializeAcademicData();

                  }
                },
                error => {
                }
              );
          } else {
            this.router.navigate(['/login']);
          }
        },
        error => {
        }
      );
  }

  initializeAcademicData() {
    this.feeService.fetchAcademicList()
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            data = data.academicList;
            this.academicList = [];
            if (data && data.length > 0) {
              this.academicInfo.academicList = data;
              let indexOfCurrent = null;
              for (let i = 0; i < this.academicInfo.academicList.length; i++) {
                this.academicInfo.academicList[i].current = false;
                this.academicInfo.academicList[i].notstarted = false;
                this.academicInfo.academicList[i].completed = false;
                if (this.academicInfo.academicList[i].InActive === 0) {
                  indexOfCurrent = i;
                  this.academicInfo.academicList[i].current = true;
                  this.academicInfo.current_academic = this.academicInfo.academicList[i].pkAcademicId;
                  this.academicInfo.year = this.academicInfo.academicList[i].Year;
                  this.schoolAcademicId = this.academicInfo.current_academic;
                  this.academicInfo.current_academic_state = this.academicInfo.academicList[i].current ?
                    'RUNNING' : this.academicInfo.academicList[i].completed ? 'COMPLETED' : 'NOT_STARTED';
                } else if (this.academicInfo.academicList[i].InActive === 1) {
                  const sDate = new Date(this.academicInfo.academicList[i].StartDate);
                  const eDate = new Date(this.academicInfo.academicList[i].EndDate);
                  if (eDate < new Date()) {
                    this.academicInfo.academicList[i].completed = true;
                  } else {
                    this.academicInfo.academicList[i].notstarted = true;
                  }
                }
              }
              /*if(indexOfCurrent !== null){
                let _indexOfCurrent = indexOfCurrent === 0 ? 0 : indexOfCurrent-1;
                this.academicInfo.academicList = this.academicInfo.academicList.slice(_indexOfCurrent,indexOfCurrent+2);
              }*/
            }
            this.getFeeDashDetails();
            this.getClassStandards(true);
            this.getPaidLateFeeCount();
          }
        },
        error => {

        }
      );
  }

  academicChanged() {
    for (const item of this.academicInfo.academicList) {
      if (item.pkAcademicId === this.academicInfo.current_academic) {
        this.academicInfo.year = item.Year;
        this.academicInfo.current_academic_state = item.current ? 'RUNNING' : item.completed ? 'COMPLETED' : 'NOT_STARTED';

        this.getStudentCategoryList(null, item.pkAcademicId);

        this.feeService.newFetchLateFeeConfig(item.pkAcademicId).subscribe(
          (response: any) => {
            if (!response.errorcode) {
              this.lateFeeList = response.lateFeeList;
              this.isLateFeeIncludedInCurrentMonth = response.isLateFeeIncludedInCurrentMonth == 1 ? true : false;

              if (this.academicInfo.current_tab === 'FEES_BOARD') {
                this.isShowFeeBoard = true;
                this.feesBoardDataAllClasses = [];
                this.currentPage = 1;
                this.openFeeBoardTab();
              }
            }
          },
          (error) => {
            console.error("Late Fee API Error:", error);
          }
        );


        this.feeService.fetchSchoolFeeTerms(item.pkAcademicId).subscribe(
          (response: any) => {
            if (!response.errorcode) {
              this.feeTermList = response;

              // If the Terms table exists, refresh it immediately
              if (this.feeTermTable) {
                this.feeTermTable.clear();
                const rows = [];
                const h = this;
                this.feeTermList.forEach(tr => {
                  const due = new Date(tr.DueDate);
                  const t = due.getDate() + '-' + h.months[due.getMonth()] + '-' + due.getFullYear();
                  const html = '<dtv><a style="cursor: pointer" id="editTerm" class="section-manage">' +
                    '<i class="fa fa-edit fa-lg manage-term"></i></a> &nbsp;&nbsp;&nbsp;' +
                    ' <a style="cursor: pointer" id="removeterm" class="section-manage hide"><i class="fa fa-trash fa-lg"></i></a>' +
                    '</div>';
                  const htmlDom = $(html);
                  $(htmlDom.find('#editTerm')).attr('termData', JSON.stringify(tr));
                  $(htmlDom.find('#removeterm')).attr('termData', JSON.stringify(tr));
                  rows.push([tr.TermName, t, htmlDom[0].outerHTML]);
                });
                this.feeTermTable.rows.add(rows).draw();
              }
            }
          },
          (error) => {
            console.error("Fee Terms API Error:", error);
          }
        );

        this.feeService.fetchFeeStructure(this.academicInfo.current_academic).subscribe(
          (data: any) => {
            this.structureList = data;

            // Destroy if already initialized
            const table = $('#fee-structure-list').DataTable();
            if ($.fn.DataTable.isDataTable('#fee-structure-list')) {
              table.destroy();
            }

            // Reinitialize after destroying
            this.initializeDataTable('fee-structure-list');
          },
          (error) => {
            console.error("Error fetching fee structure:", error);
          }
        );

        this.destroyDataTable('school-other-fee-list');
        this.feeService.getOtherFee(this.academicInfo.current_academic)
          .subscribe(
            (data: any) => {
              this.otherFeeList = data;
              this.initializeDataTable('school-other-fee-list');
            },
            error => {
              this.otherFeeList = [];
            }
          );


        this.feeService.feeComponentList(item.pkAcademicId)
          .subscribe(
            (data: any) => {
              const h = this;


              if (data.errorcode) {
              } else {
                this.feeComponentList = data;


                if (this.feeComponentTable) {
                  this.feeComponentTable.clear();


                  const rows = [];
                  this.feeComponentList.forEach(item => {
                    const isIncludedInTerm = item.isIncludedInTerm ? 'YES' : 'NO';
                    let appliesTo = item.AppliesTo;
                    if (appliesTo === 'ALL_STUDENTS') {
                      appliesTo = 'All Students';
                    } else if (appliesTo === 'NEW_STUDENTS') {
                      appliesTo = 'New Students';
                    } else if (appliesTo === 'OLD_STUDENTS') {
                      appliesTo = 'Old Students';
                    } else if (appliesTo === 'BUS_FACILITY_STUDENTS') {
                      appliesTo = 'Students Using Bus Facility';
                    }
                    if (item.DueDate) {
                      const due = new Date(item.DueDate);
                      item.DueDate = due.getDate() + '-' + h.months[due.getMonth()] + '-' + due.getFullYear();
                    } else {
                      item.DueDate = isIncludedInTerm === 'NO' ? '-' : 'NA';
                    }
                    const html = '<a class="section-manage">' +
                      '<i style="cursor: pointer" class="fa fa-edit fa-lg manage-component edit-fee-component-list"></i></a> ' +
                      '<a href="#" class="section-manage" *ngIf="false"><i class="fa fa-remove fa-lg"></i></a>';
                    const html2 = $(html);
                    html2.find('.edit-fee-component-list').attr('component', JSON.stringify(item));
                    html2.find('.edit-fee-component-list');
                    rows.push([item.Name, item.DueDate, isIncludedInTerm, appliesTo, html2[0].outerHTML]);
                  });
                  this.feeComponentTable.rows.add(rows).draw();


                  // ✅ Move the click handler inside the if block
                  $('body').find('.edit-fee-component-list').off('click').on('click', function () {
                    $('#editFeeComponentIncludeTerm').attr('disabled', false);
                    h.offcanvas.handleOffcanvasOpen('#offcanvas-manage-feeComponent');
                    const component = JSON.parse($(this).attr('component'));


                    let dueDate = null;


                    if (component.isIncludedInTerm) {
                      dueDate = '';
                    } else {
                      if (component.DueDate && component.DueDate !== '0000-00-00' && component.DueDate !== '-') {
                        const due = new Date(component.DueDate);
                        let month = '' + (due.getMonth() + 1);
                        if (parseInt(month, 10) < 10) {
                          month = '0' + month;
                        }
                        dueDate = due.getDate() + '/' + month + '/' + due.getFullYear();
                      } else {
                        dueDate = '';
                      }
                    }


                    h.editFeeComponent = {
                      feesTypeId: component.pkFeesTypeId,
                      Name: component.Name,
                      includeInTerm: component.isIncludedInTerm === 1,
                      academicId: component.fkAcademicId,
                      AppliesTo: component.AppliesTo,
                      duedate: dueDate
                    };
                    if (component.isIncludedInTerm === 1) {
                      $('#editFeeComponentIncludeTerm').attr('checked', 'checked');
                    } else {
                      $('#editFeeComponentIncludeTerm').removeAttr('checked');
                    }
                    $('#editFeeComponentIncludeTerm').attr('disabled', true);
                    $('#editFeeComponentName').val(component.Name);
                    setTimeout(() => {
                      $('#editFeeComponentDueDate').datepicker({ autoclose: true });
                    }, 100);
                  });
                }
              }
            },
            error => {
              console.error("Fee Component API Error:", error);
            }
          );

        break;
      }
    }
    this.isStudentDeactiveStatusChecked = true;
    this.isStudentDeactivated = false
    this.isShowFeeBoard = false;
    if (this.academicInfo.current_tab === 'OVERVIEW') {
      this.getFeeDashDetails();
      // this.fetchFeeDetailOfStandard();
      this.getPaidLateFeeCount();
    } else if (this.academicInfo.current_tab === 'FEES_BOARD') {
      if (this.academicInfo.current_academic_state === 'COMPLETED') {
        $('#_fee_collection_tab').trigger('click');
        this.academicInfo.current_tab = "FEE_COLLECTION"
      } else {
        this.openFeeBoardTab();
        this.feesBoardDataAllClasses = [];
      }
    }
    else if (this.academicInfo.current_tab === 'FEE_COLLECTION') {
      this.feesCollectionTabClicked();
      this.searchStudent("NO");
    } else if (this.academicInfo.current_tab === 'DISCOUNTS') {
      this.discountDetails();
    } else if (this.academicInfo.current_tab === 'SETTINGS') {
      this.openFeesSettingsTab()
    } else {
      if (this.academicInfo.current_academic_state === 'COMPLETED') {
        $('#_fee_collection_tab').trigger('click');
        this.academicInfo.current_tab = "FEE_COLLECTION"
      } else {
        this.feesSettingsInfo = [];
        this.openFeesSettingsTab()
        this.getOtherFeeList()
        this.openTermsTab()
        this.getClassFeesSettings();
      }
      // this.getFeesSettings('yes')
    }
  }

  viewFeeDeails(){
    this.isShowFeeDetailsOverview = true;
    this.fetchFeeDetailOfStandard()
  }

  // 'total'/'active'/'inactive' (UI naming) maps to the export API's
  // studentStatus values: All/Active/Inactive.
  private get studentStatusForExport(): string {
    if (this.studentStatusFilter === 'active') { return 'Active'; }
    if (this.studentStatusFilter === 'inactive') { return 'Deactive'; }
    return 'All';
  }

  async exportStandardFeeDetailsToExcel() {
    const stdId = $('#selectStandard').val();
    try {
      const response: any = await firstValueFrom(this.feeService.exportClassWiseFeesOverview({
        academicId: this.academicInfo.current_academic,
        classStandardId: stdId || 'All',
        studentStatus: this.studentStatusForExport,
        lang: 'en'
      }));
      if (response && response instanceof Blob && response.size > 0) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Fees Details.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || await firstValueFrom(this.translate.get('failedtoexportreport'));
      customToastr(errorMessage, 'error');
    }
  }

  // Interval is always 'SUMMARY' now ($('#selectInterval') is hidden and
  // hardcoded to that option), so this always pulls the class-wise overview
  // for either the selected standard or 'All'. Resets to page 1 — called
  // fresh from "VIEW FEE DETAILS" and whenever the standard filter changes.
  fetchFeeDetailOfStandard() {
    this.classWiseFeesCurrentPage = 1;
    this.loadClassWiseFeesPage(1);
  }

  loadClassWiseFeesPage(page: number) {
    const stdId = $('#selectStandard').val();
    this.loaded = false;
    this.feeService.getClassWiseFeesOverview({
      academicId: this.academicInfo.current_academic,
      pageNumber: page,
      pageLimit: 10,
      classStandardId: stdId || 'All',
      lang: 'en'
    }).subscribe(
      (res: any) => {
        this.classWiseFeesCurrentPage = page;
        this.classWiseFeesMaxPage = res?.status && res?.body ? (Number(res.body.maxPageNumber) || 0) : 0;
        this.classWiseFeesData = res?.status && res?.body ? (res.body.classWiseFeesData || []) : [];
        this.applyClassWiseFeesForCurrentStatus();
      },
      error => {
        this.classWiseFeesMaxPage = 0;
        this.classWiseFeesData = [];
        this.applyClassWiseFeesForCurrentStatus();
      }
    );
  }

  previousClassWiseFeesPage() {
    if (this.classWiseFeesCurrentPage > 1) {
      this.loadClassWiseFeesPage(this.classWiseFeesCurrentPage - 1);
    }
  }

  nextClassWiseFeesPage() {
    if (this.classWiseFeesCurrentPage < this.classWiseFeesMaxPage) {
      this.loadClassWiseFeesPage(this.classWiseFeesCurrentPage + 1);
    }
  }

  // Re-derives the "View Fee Details" table rows from the already-fetched
  // classWiseFeesData for the current All/Active/Inactive filter, without a
  // refetch — mirrors applyFeesOverviewForCurrentStatus() for the stat cards.
  private applyClassWiseFeesForCurrentStatus(): void {
    this.clearIfStandardsTableAvailable();
    this.standardFeeDetails = (this.classWiseFeesData || []).map(c => {
      const slice = this.studentStatusFilter === 'inactive' ? c.deactive : c[this.studentStatusFilter];
      return {
        classId: c.classId,
        classStandardId: c.classStandardId,
        classNumber: c.classNumber,
        classDivision: c.classDivision,
        totalFee: Number(slice?.totalExpectedCollection) || 0,
        discountFee: Number(slice?.totalDiscountAmount) || 0,
        collectedFee: Number(slice?.totalCollectedAmount) || 0,
        pendingFee: Number(slice?.totalPendingAmount) || 0
      };
    });
    const h = this;
    setTimeout(() => {
      h.applyStandardsFeeTable();
    }, 100);
  }

  // Reset to the "All" slice whenever the Overview data is (re)requested —
  // e.g. on a fresh academic-year load — same as switching the tab fresh;
  // getPaidLateFeeCount() below is a no-op now since this one call already
  // covers it, kept only so its existing call sites (always paired with
  // this one) don't need to change.
  getFeeDashDetails() {
    this.studentStatusFilter = 'total';
    this.feeService.getSchoolWiseFeesOverview({ academicId: this.academicInfo.current_academic, lang: 'en' })
      .subscribe(
        (res: any) => {
          this.feesOverviewByStatus = res?.status && res?.body ? res.body : null;
          this.applyFeesOverviewForCurrentStatus();
        },
        error => {
          this.feesOverviewByStatus = null;
        }
      );
  }

  // No-op — getFeeDashDetails() above already fetches late fees as part of
  // the combined getSchoolWiseFeesOverview response. Every existing call
  // site calls both together; kept as a harmless stub rather than touching
  // every call site.
  getPaidLateFeeCount() {}

  getOverviewFeeFinancialTermBasis() {
    this.schoolFinancialTermFeeOverviewListProcessing = true;
    this.feeService.getFinancialTermsOverviewFee(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.schoolFinancialTermFeeOverviewListProcessing = false;
          if (data.errorcode) {
            this.schoolFinancialTermFeeOverviewList = [];
          } else {
            this.schoolFinancialTermFeeOverviewList = data;
          }
        },
        error => {
          this.schoolFinancialTermFeeOverviewListProcessing = false;
          this.schoolFinancialTermFeeOverviewList = [];
        }
      );
  }

  getClassStandards(selectFirst) {
    this.feeService.getClassStandardList('en')
      .subscribe(
        (res: any) => {
          const list = res?.status && res?.body ? res.body.classStandardListData : [];
          this.classStanderds = (list || []).map(std => ({
            pkClassStandardsId: std.classStandardId,
            ClassStandard: std.classStandardName
          }));
        },
        error => {
          this.classStanderds = [];
        }
      );
  }

  getClassSections(classStandardId) {
    this.feeService.getClassSections(classStandardId)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            this.classSections = data[0];
          }
        },
        error => {
        }
      );
  }

  clearIfStandardsTableAvailable() {
    if (this.standardsFeeTable) {
      this.standardsFeeTable.clear().draw();
      this.standardsFeeTable.destroy(false);
      this.standardsFeeTable = null;
    }
  }

  getFeeDetails(dataFor, stdId) {
    this.feeService.getSchoolFee(dataFor, stdId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          const rows = [];
          this.clearIfStandardsTableAvailable();
          if (data.errorcode) {
          } else {
            this.standardFeeDetails = this.recalculateStandardFeePending(data);
          }
          const h = this;
          setTimeout(() => {
            h.applyStandardsFeeTable();
          }, 100);

        },
        error => {
        }
      );
  }

  private recalculateStandardFeePending(details: any[]) {
    return (details || []).map(f => ({
      ...f,
      pendingFee: (Number(f.totalFee) || 0) - (Number(f.discountFee) || 0) - (Number(f.collectedFee) || 0)
    }));
  }

  todayFeeDetailByClass(date, stdId) {
    this.feeService.todayFeeByClass(date, stdId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.clearIfStandardsTableAvailable();

          if (data.errorcode) {
          } else {
            this.standardFeeDetails = this.recalculateStandardFeePending(JSON.parse(JSON.stringify(data)));
          }
          const h = this;
          setTimeout(() => {
            h.applyStandardsFeeTable();
          }, 100);

        },
        error => {
        }
      );
  }

applyStandardsFeeTable() {
  if (this.standardsFeeTable === null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      this.standardsFeeTable = $('#datatable100').DataTable({
        dom: 'Crt',
        paging: false,
        ordering: false,
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        language: {
          emptyTable: translations['dataTables.sEmptyTable'],
          zeroRecords: translations['dataTables.zeroRecords']
        }
      });
    });
  }
}


  applyFeeTermConfigTable() {
    if (this.termFeeConfigurationTable === null) {
      this.termFeeConfigurationTable = $('#termfeeconfiguration_new').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }

  }

  applyFeeHistoryTable() {
    if (this.feeHistoryTable === null) {
      this.feeHistoryTable = $('#feeHistoryTable').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          pagingType: 'full_numbers'
        }
      });
      setTimeout(() => {
        $('#dataTables_info').addClass('hide');
        /*$("#feeHistoryTable_paginate").addClass("hide")*/
      }, 100);
    }

  }

  applyFeeUpdateHistoryTable() {
    if (this.feeUpdateHistoryTable === null) {
      this.feeUpdateHistoryTable = $('#feeUpdateHistoryTable').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
      setTimeout(() => {
        $('#dataTables_info').addClass('hide');
        $('#feeHistoryTable_paginate').addClass('hide');
      }, 100);
    }

  }

  applyClassFeeTable() {
    if (this.classFeeTable === null) {
      this.classFeeTable = $('#datatable03classfee').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

applyFeeComponentTable() {
  // if (this.feeComponentTable !== null) {
  //   this.feeComponentTable.destroy();
  //   $('#components-fee').empty();
  //   this.feeComponentTable = null;
  // }

 if(this.feeComponentTable===null){
   this.translate.get([
    'dataTables.sEmptyTable',
    'dataTables.lengthMenu',
    'dataTables.search',
    'dataTables.paginate.previous',
    'dataTables.paginate.next',
    'dataTables.info',
    'dataTables.zeroRecords'
  ]).subscribe(translations => {
    this.feeComponentTable = $('#components-fee').DataTable({
      dom: 'lCfrtip',
      bLengthChange: false,
      bFilter: true,
      order: [],
      colVis: {
        buttonText: 'Columns',
        overlayFade: 0,
        align: 'right'
      },
      language: {
        emptyTable: translations['dataTables.sEmptyTable'],
        lengthMenu: translations['dataTables.lengthMenu'],
        search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
        info: translations['dataTables.info'],
        zeroRecords: translations['dataTables.zeroRecords'],
        paginate: {
          previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
          next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
        }
      }
    });
  });
 }
}



  applyFeesBoardTable() {
    if (this.feeBoardTable === null) {
      this.feeBoardTable = $('#fee-details').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

 applyFeesTermTable() {
  if (this.feeTermTable === null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      this.feeTermTable = $('#term-component-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        language: {
          emptyTable: translations['dataTables.sEmptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
  }
}


  viewStudentFees(fee) {
    // this.offcanvas.handleOffcanvasOpen("#offcanvas-view-class-fee");
    this.destroyDataTable('classFeeDetailTable');
    this.allStudentAllFee = [];
    this.headerFeeName = [];
    this.busDetail = [];
    this.studentFeeStatus = true;
    this.studentFeeDetailTable = false;
    this.selectedClass = fee;
    this.applyClassFeeTable();
    this.classFeeTable.clear().draw();
    this.feeService.getAllStudentFeeDetails(fee.classId, this.authToken, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.selectedOverdueStudentsCount = 0;
          this.selectedOverdueStudentsList = [];
          this.openSendSMSView = false;
          this.studentFeeStatus = false;
          this.studentFeeDetailTable = true;
          data.studentDetails.sort((s1: any, s2: any) => (s1.rollNumber ?? 0) - (s2.rollNumber ?? 0));
          this.allStudentAllFee = data.studentDetails;
          this.headerFeeName = this.sortFeeNamesAcademicOrder(data.feesNames || []);
          this.busDetail = data.busFee || [];
          this.studentCollectedAmount = data.collectedAmount;
          this.studentBusFeeCollection = data.busCollection;
          const h = this;
          setTimeout(() => {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < h.allStudentAllFee.length; i++) {
              // tslint:disable-next-line:prefer-for-of
              for (let j = 0; j < h.allStudentAllFee[i].fees.length; j++) {
                $('#tdId_' + h.allStudentAllFee[i].studentId + '_' + h.allStudentAllFee[i].fees[j].feesId)
                  .text(h.allStudentAllFee[i].fees[j].TotalAmount);
                if (new Date(h.allStudentAllFee[i].fees[j].DueDate) < new Date(h.allStudentAllFee[i].fees[j].currentDate) &&
                  h.allStudentAllFee[i].fees[j].TotalAmount !== 0) {
                  $('#test_' + h.allStudentAllFee[i].studentId + '_' + h.allStudentAllFee[i].fees[j].feesId).css({ color: 'red' });
                  $('#filter_' + h.allStudentAllFee[i].studentId + '_' + h.allStudentAllFee[i].fees[j].feesId).text('Dues');
                }
              }
            }
            // tslint:disable-next-line:prefer-for-of
            for (let k = 0; k < h.busDetail.length; k++) {
              $('#busFeeId_' + h.busDetail[k].studentId).text(h.busDetail[k].BusFare);
            }
            // Per-student fee / collected / discount aggregation. CollectedAmount already includes
            // the discount (discount is a waiver, not money received), so:
            //   Net Collected = Collected - Discount, Pending = max(0, Total - Collected).
            const sum = (map: any, key: string, v: number) => { map[key] = (map[key] || 0) + (Number(v) || 0); };
            const collByFee: any = {};
            const discByFee: any = {};
            (h.studentCollectedAmount || []).forEach((c: any) => {
              const k = c.fkStudentId + '_' + c.FeesId;
              sum(collByFee, k, c.CollectedAmount);
              sum(discByFee, k, c.discountAmount);
            });
            const totalCollected: any = {};
            const totalDiscount: any = {};
            const totalPending: any = {};
            h.allStudentAllFee.forEach((st: any) => {
              (st.fees || []).forEach((f: any) => {
                const k = st.studentId + '_' + f.feesId;
                const total = Number(f.TotalAmount) || 0;
                const collected = collByFee[k] || 0;
                const pending = Math.max(0, total - collected);
                $('#tdId_' + k).text(pending);
                if (total !== 0 && collected >= total) {
                  $('#test_' + k).css({ color: 'green' });
                  $('#filter_' + k).text('Collected');
                }
                sum(totalCollected, st.studentId, collected);
                sum(totalDiscount, st.studentId, discByFee[k] || 0);
                sum(totalPending, st.studentId, pending);
              });
            });
            const busColl: any = {};
            (h.studentBusFeeCollection || []).forEach((c: any) => {
              sum(busColl, c.fkStudentId, c.CollectedAmount);
              sum(totalDiscount, c.fkStudentId, c.discountAmount);
            });
            (h.busDetail || []).forEach((bd: any) => {
              const total = Number(bd.BusFare) || 0;
              const collected = busColl[bd.studentId] || 0;
              const pending = Math.max(0, total - collected);
              $('#busFeeId_' + bd.studentId).text(pending);
              if (total !== 0 && collected >= total) {
                $('#busFeeColl_' + bd.studentId).css({ color: 'green' });
                $('#busCol_' + bd.studentId).text('Collected');
              }
              sum(totalCollected, bd.studentId, collected);
              sum(totalPending, bd.studentId, pending);
            });
            h.allStudentAllFee.forEach((st: any) => {
              const col = totalCollected[st.studentId] || 0;
              const disc = totalDiscount[st.studentId] || 0;
              $('#collected_' + st.studentId).text(col);
              $('#discount_' + st.studentId).text(disc);
              $('#netcollected_' + st.studentId).text(col - disc);
              $('#pending_' + st.studentId + st.studentId).text(totalPending[st.studentId] || 0);
            });
            h.initializeDataTableWithoutSort('classFeeDetailTable');

          }, 500);

        },
        error => {
        });
  }

  // Academic order: April..March, then Admission Fee, Half Yearly Exam, Annual Exam, then anything else.
  private sortFeeNamesAcademicOrder(list: any[]): any[] {
    const months = ['april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december', 'january', 'february', 'march'];
    const others = ['admission fee', 'half yearly exam', 'annual exam'];
    const rank = (f: any) => {
      const n = String(f?.FeeName || '').trim().toLowerCase();
      const m = months.indexOf(n);
      if (m > -1) { return m; }
      const o = others.indexOf(n);
      return o > -1 ? 100 + o : 1000;
    };
    return list.map((f, i) => ({ f, i })).sort((x, y) => rank(x.f) - rank(y.f) || x.i - y.i).map((x) => x.f);
  }

  filterFees(feeType) {
    let oTable;
    oTable = $('#classFeeDetailTable').dataTable();
    oTable.fnFilter(feeType);
  }

  /* Feeboard related */

  openFeeComponentTab() {
    this.applyFeeComponentTable();
    this.feeComponentTable.clear().draw();
    this.feeService.feeComponentList(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          const h = this;

          if (data.errorcode) {
          } else {
            this.feeComponentList = data;
            const rows = [];
            this.feeComponentList.forEach(item => {
              const isIncludedInTerm = item.isIncludedInTerm ? 'YES' : 'NO';
              let appliesTo = item.AppliesTo;
              if (appliesTo === 'ALL_STUDENTS') {
                appliesTo = 'All Students';
              } else if (appliesTo === 'NEW_STUDENTS') {
                appliesTo = 'New Students';
              } else if (appliesTo === 'OLD_STUDENTS') {
                appliesTo = 'Old Students';
              } else if (appliesTo === 'BUS_FACILITY_STUDENTS') {
                appliesTo = 'Students Using Bus Facility';
              }
              if (item.DueDate) {
                const due = new Date(item.DueDate);
                item.DueDate = due.getDate() + '-' + h.months[due.getMonth()] + '-' + due.getFullYear();
              } else {
                item.DueDate = isIncludedInTerm === 'NO' ? '-' : 'NA';
              }
              const html = '<a class="section-manage">' +
                '<i style="cursor: pointer" class="fa fa-edit fa-lg manage-component edit-fee-component-list"></i></a> ' +
                '<a href="#" class="section-manage" *ngIf="false"><i class="fa fa-remove fa-lg"></i></a>';
              const html2 = $(html);
              html2.find('.edit-fee-component-list').attr('component', JSON.stringify(item));
              html2.find('.edit-fee-component-list');
              rows.push([item.Name, item.DueDate, isIncludedInTerm, appliesTo, html2[0].outerHTML]);
            });
            this.feeComponentTable.rows.add(rows).draw();

          }
          $('body').find('.edit-fee-component-list').on('click', function () {
            $('#editFeeComponentIncludeTerm').attr('disabled', false);
            h.offcanvas.handleOffcanvasOpen('#offcanvas-manage-feeComponent');
            const component = JSON.parse($(this).attr('component'));

            let dueDate = null;

            if (component.isIncludedInTerm) {
              dueDate = '';
            } else {
              if (component.DueDate && component.DueDate !== '0000-00-00' && component.DueDate !== '-') {
                const due = new Date(component.DueDate);
                let month = '' + (due.getMonth() + 1);
                if (parseInt(month, 10) < 10) {
                  month = '0' + month;
                }
                dueDate = due.getDate() + '/' + month + '/' + due.getFullYear();
              } else {
                dueDate = '';
              }
            }

            h.editFeeComponent = {
              feesTypeId: component.pkFeesTypeId,
              Name: component.Name,
              includeInTerm: component.isIncludedInTerm === 1,
              academicId: component.fkAcademicId,
              AppliesTo: component.AppliesTo,
              duedate: dueDate
            };
            if (component.isIncludedInTerm === 1) {
              $('#editFeeComponentIncludeTerm').attr('checked', 'checked');
            } else {
              $('#editFeeComponentIncludeTerm').removeAttr('checked');
            }
            // $("#editFeeComponentIncludeTerm").attr("checked",component.isIncludedInTerm === 1 ? 'checked':'');
            $('#editFeeComponentIncludeTerm').attr('disabled', true);
            $('#editFeeComponentName').val(component.Name);
            setTimeout(() => {
              $('#editFeeComponentDueDate').datepicker({ autoclose: true });
            }, 100);
          });
        },
        error => {
        }
      );
  }

  async editFeeComponentFn(feeType) {

    let dueDate = $('#editFeeComponentDueDate').val();
    feeType.Name = $('#editFeeComponentName').val();

    if (!this.formValidator.validateIsData(feeType.Name)) {
      const pleaseProvideComponentNameTranslation = await firstValueFrom(this.translate.get('pleaseProvideComponentName')); 
      customToastr(pleaseProvideComponentNameTranslation, 'error');
      return;
    }
    if (!feeType.includeInTerm) {
      if (!this.formValidator.validateIsData(dueDate)) {
        const pleaseProvideComponentDueDateTranslation = await firstValueFrom(this.translate.get('pleaseProvideComponentDueDate')); 
        customToastr(pleaseProvideComponentDueDateTranslation, 'error');
        return;
      } else {
        dueDate = $('#editFeeComponentDueDate').val();
        const d = dueDate.split('/');
        dueDate = d[2] + '-' + d[1] + '-' + d[0];
      }
    }
    if (feeType.includeInTerm) {
      dueDate = null;
    }

    this.feeService.updateFeeTypeComponent(feeType.Name, dueDate, feeType.feesTypeId, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {
          if (data.status) {
            const feeComponentSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('feeComponentSuccessfullyUpdated')); 
            customToastr(feeComponentSuccessfullyUpdatedTranslation, 'success');
            $('#close-edit-component-fee-offcanvas').trigger('click');
            this.openFeeComponentTab();
          } else if (data.message) {
            customToastr(data.message, 'error');
          } else {
            const failedToUpdateFeeComponentTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeeComponent')); 
            customToastr(failedToUpdateFeeComponentTranslation, 'error');
          }
        },
        async error => {
          const failedToUpdateFeeComponentTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeeComponent')); 
          customToastr(failedToUpdateFeeComponentTranslation, 'error');
        }
      );
  }

  applyFeesBoardTabTable() {
    if (this.feesBoardTabTable === null) {
      this.feesBoardTabTable = $('#fees-board-tab-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        destroy: true,
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

  openFeeBoardTab() {
    // this.destroyDataTable('fees-board-tab-table');
    if (this.feesBoardTabTable !== null) {
      this.feesBoardTabTable.destroy();
      this.feesBoardTabTable = null;
    }
    const h = this;
    this.dataFetching = true;
    if (this.isShowFeeBoard) {
      this.feeService.getFeeBoardFees_v2(this.academicInfo.current_academic, this.currentPage)
        .subscribe(
          (data: any) => {
            this.dataFetching = false;
            if (data.errorcode) {
              this.feesBoardDataAllClasses = [];
            } else {
              this.feesBoardDataAllClasses = [...this.feesBoardDataAllClasses, ...data.feesData];
              this.maxPage = data.maxPageNumber;

              if (this.strListOnce) {
                this.strListOnce = false;
                this.feesBoardDataAllClassesStrList = data.feesData[1].structures;
              }
              // if (this.feesBoardTabTable !== null) {
              //   this.feesBoardTabTable.destroy();
              //   this.feesBoardTabTable = null;
              // }
              // setTimeout(() => {
              //   h.applyFeesBoardTabTable();
              // }, 100);

            }
          },
          error => {
            this.dataFetching = true;
          }
        );
    }
  }

  loadMore() {
    if (this.currentPage < this.maxPage) {
      this.currentPage++;
      this.openFeeBoardTab();
    }
  }

  showFeeBoardDetailView() {
    this.isShowFeeBoard = true
    this.openFeeBoardTab();
  }
  viewFeeBoardForCategory() {
    this.feeBoardData = [];
    const classStandardId = $('#selectClassCategory').val();
    if (classStandardId !== '') {
      this.getFeeBoard(classStandardId);
    }
  }

  feeBoardDetails(fee) {
    const classStdId = fee.classId;
    $('#feesBoardDetailsClassName, #termFeeConfigClassName').text(fee.classNumber + ' ' + fee.classDivision);
    this.selectClassForFeeDetail = false;
    this.getClassIdForFeeBoard = classStdId;
    this.selectedClassIdForFeeCopy = null;
    this.originalFeeBoardConfig = [];
    this.originalFeeTermConfig = [];
    this.getFeeBoard(classStdId);
    this.getClassListForFee(classStdId);
  }
  handleFeeBordCancel(){
    this.selectedClassIdForFeeCopy = null;
    this.originalFeeBoardConfig = [];
    this.originalFeeTermConfig = [];
    const selectElement = document.getElementById('classForFeeBoard') as HTMLSelectElement;
    if (selectElement) {
      selectElement.value = ''; 
    }
  }
  
  async getClassListForFee(classStdId){
    try {
      const response: any = await firstValueFrom(
        this.feeService.getClassList(classStdId)
    );    
    if(response?.status){
        this.classListForFee = response.body.classListDataForFeesStructure;        
    }
    } catch (error) {
      if (error?.error?.message) {
        customToastr(error?.error?.message, "error");
      }
      else {
        const getApiErrorMessageTranslation = await firstValueFrom(this.translate.get('getApiErrorMessage'));
        customToastr(getApiErrorMessageTranslation, "error");
      }
    }
   
  }
  
  handleOnChangeForClassList(event : any){
    const selectedValue = (event.target as HTMLSelectElement).value;
    const [classInfo, classId] = selectedValue.split('|');
    this.selectedClassIdForFeeCopy = classId;
    this.selectedClassForFeeBoard  = classInfo
  }

  
  handleOnChangeForClassForFeeTerm(event : any){
    const selectedValue = (event.target as HTMLSelectElement).value;
    const [classInfo, classId] = selectedValue.split('|');
    this.selectedClassIdForFeeTerm = classId;
    this.selectedClassForTermInfo  = classInfo
  }

  handleFeeConfigCopy(){
    if(this.isFeeBoardDataCopied){
      const classId = this.selectedClassIdForFeeCopy ? this.selectedClassIdForFeeCopy : this.getClassIdForFeeBoard;
      this.originalFeeBoardConfig = this.feeBoardData;
      this.getFeeBoard(classId);
    }else{
    const classId = this.selectedClassIdForFeeTerm ? this.selectedClassIdForFeeTerm : this.getClassIdForFeeBoard;
      this.originalFeeTermConfig = this.termFeeConfigurations;
      this.getClassTermConfig(classId, this.getStructureId, this.termFeeConfigurations[0]);
    }
    
  }

  handleCopyButton(isFeeBoard){
   this.isFeeBoardDataCopied = isFeeBoard;
    ($('#topModal') as any).modal('show');
  }
  getFeeBoard(classId) {

    this.feeBoardData = [];
    if (this.feeBoardTable !== null) {
      this.feeBoardTable.destroy();
      this.feeBoardTable = null;
    }
    this.feeBoardTableList = false;
    this.feeBoardStatus = true;
    this.feeService.getFeeBoardFees(classId, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {

          this.feeBoardTableList = true;
          this.feeBoardStatus = false;
          if (data.errorcode) {
            this.feeBoardData = [];
          } else if (data.status === false) {
            const feeStructureNotFoundPleaseCreateFeeStructureByClickingOnAddNewStructureTranslation = await firstValueFrom(this.translate.get('feeStructureNotFoundPleaseCreateFeeStructureByClickingOnAddNewStructure')); 
            customToastr(feeStructureNotFoundPleaseCreateFeeStructureByClickingOnAddNewStructureTranslation, 'error');
          } else {
            this.feeBoardData = data;
            this.feeBoardDataDetails = this.feeBoardData;
            this.feeBoardDataHeader = data[0].feeTypes;
            this.feeBoardDataStructureName = data[0].Name;
          }
          const h = this;
          setTimeout(() => {
            h.applyFeesBoardTable();
          }, 100);
        },
        error => {
        }
      );
  }

  addFeeBoardDetails() {
    const criteria = {
      classId: this.getClassIdForFeeBoard,
      feeBoard: this.originalFeeBoardConfig && this.originalFeeBoardConfig.length>0 ? this.originalFeeBoardConfig : this.feeBoardData
    };
    $('#addFeeButton').attr('disabled', true);
    $('#cancelAddFee').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#addFeeButton').text(translatedText); });
    this.feeService.insertAndUpdateFeeBoard(criteria, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {

          const names = [];
          for (const item of data) {
            names.push(item.TermName);
          }

          $('#addFeeButton').attr('disabled', false);
          $('#cancelAddFee').attr('disabled', false);
          $('#addFeeButton').attr('Save');
          if (data.length === 0) {
           const feesBoardDetailsAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('feesBoardDetailsAddedSuccessfully')); 
           customToastr(feesBoardDetailsAddedSuccessfullyTranslation, 'success');
            this.originalFeeBoardConfig = [];
            this.selectedClassIdForFeeCopy = null;
            this.isFeeBoardDataCopied = false;
            this.selectedClassForFeeBoard = null;
            const selectElement = document.getElementById('classForFeeBoard') as HTMLSelectElement;
            if (selectElement) {
              selectElement.value = ''; 
            }
            this.getFeeBoard(this.getClassIdForFeeBoard);
          } else {
            const someStudentAlreadyPaidForTranslation = await firstValueFrom(this.translate.get('someStudentAlreadyPaidFor')); 
            customToastr( someStudentAlreadyPaidForTranslation +' <b>' + names.join(',') + '</b>', 'error');
          }
          
        },
        error => () => {

        }
      );
  }

  configFeeBoard() {
    if (this.originalFeeBoardConfig && this.originalFeeBoardConfig.length > 0 && this.selectedClassIdForFeeCopy) {
      this.originalFeeBoardConfig.forEach((originalBoard) => {
        const copyBoard = this.feeBoardData.find(
          (copy) => copy.pkFeeStructuresId === originalBoard.pkFeeStructuresId
        );

        if (copyBoard) {
          originalBoard.feeTypes.forEach((originalFee) => {
            const matchingFee = copyBoard.feeTypes.find(
              (copyFee) => copyFee.pkFeesTypeId === originalFee.pkFeesTypeId
            );

            if (matchingFee) {
              originalFee.Amount = matchingFee.Amount;
            }
          });
        }
      });
    }
    this.addFeeBoardDetails();
  }

  getFeeBoardDetailView(structureId, classId, structureName) {
    this.getStructureName = structureName;
    this.getFeeBoardHistoryForView = [];
    this.feeBoardHistoryStatus = true;
    this.destroyDataTable('feeboard_new ');


    this.feeService.fetchFeeBoardHistorydetailView(structureId, classId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {


          this.getFeeBoardHistoryForView = data[0];
          this.initializeDataTable('feeboard_new ');
          this.feeBoardHistoryStatus = false;
        },
        error => () => {

        }
      );
  }

  getTermConfigHistoryDetailView(termfee) {
    this.getTypeName = termfee.Name;
    this.getTermConfigHistoryForView = [];
    this.termConfigHistoryStatus = true;

    this.getFeeTypeId = termfee.termFees[0].fkFeesTypeId;
    this.getFeeStructureId = termfee.termFees[0].fkFeeStructuresId;
    this.getClassIdForHistory = termfee.termFees[0].fkClassId;


    this.destroyDataTable('TermConfig_new');

    this.feeService.fetchTermConfigHistorydetailView(this.getFeeStructureId, this.getFeeTypeId, this.getClassIdForHistory,
      this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {

          this.getTermConfigHistoryForView = data;
          this.initializeDataTable('TermConfig_new');
          this.termConfigHistoryStatus = false;
        },
        error => {
        }
      );
  }


  getAcademicList() {
    $('#duedateDatePicker').datepicker({ autoclose: true });
    this.createFeeComponent = JSON.parse(JSON.stringify(this.initialDataCreateFeeType));
    $('#duedateDatePicker').val('');
    this.initialDataCreateFeeType = { Name: '', includeInTerm: false, academicId: '', AppliesTo: 'ALL_STUDENTS', duedate: '' };
    this.feeService.fetchAcademicList()
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            data = data.academicList;
            let started = false;
            const h = this;
            this.academicList = [];
            if (data && data.length > 0) {
              data.forEach(ac => {
                if (ac.InActive === 0) {
                  started = true;
                }
                if (started) {
                  h.academicList.push(ac);
                }
              });
            }
          }
        },
        error => {
        }
      );
  }

  async addFeeType(feeType) {
    feeType.duedate = $('#duedateDatePicker').val();
    let valid = false;
    feeType.academicId = this.academicInfo.current_academic;
    if (feeType.Name !== '' && feeType.academicId !== '') {
      valid = true;
    } else {
      const pleaseProvideFeesComponentNameAcademicYearTranslation = await firstValueFrom(this.translate.get('pleaseProvideFeesComponentNameAcademicYear')); 
      customToastr(pleaseProvideFeesComponentNameAcademicYearTranslation, 'error');
    }
    if (valid) {
      if (feeType.includeInTerm === false) {

        if (feeType.duedate === '') {
          valid = false;
          const pleaseProvideDueDateTranslation = await firstValueFrom(this.translate.get('pleaseProvideDueDate')); 
          customToastr(pleaseProvideDueDateTranslation, 'error');
        } else {
          const d = feeType.duedate.split('/');
          feeType.duedate = d[2] + '-' + d[1] + '-' + d[0];
          valid = true;
        }
      } else {
        valid = true;
      }
    }
    if (feeType.AppliesTo && feeType.AppliesTo === '') {
      feeType.AppliesTo = 'ALL_STUDENTS';
    } else if (!feeType.AppliesTo) {
      feeType.AppliesTo = 'ALL_STUDENTS';
    }

    if (valid) {
      feeType.includeInTerm = feeType.includeInTerm ? 1 : 0;
      if (feeType.duedate === '') {
        feeType.duedate = null;
      }
      this.feeService.addFeeTypeComponent(feeType.Name, feeType.includeInTerm, feeType.academicId, feeType.AppliesTo,
        feeType.duedate, this.academicInfo.current_academic)
        .subscribe(
         async (data: any) => {
            if (data.errorcode) {
             const feesComponentNotCreatePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('feesComponentNotCreatePleaseTryAgain')); 
             customToastr(feesComponentNotCreatePleaseTryAgainTranslation, 'error');
            } else {
              if (data.status) {
                const feesComponentSuccessfullyCreatedTranslation = await firstValueFrom(this.translate.get('feesComponentSuccessfullyCreated')); 
                customToastr(feesComponentSuccessfullyCreatedTranslation, 'success');
                $('#add-new-fee-component-close').trigger('click')
                this.openFeeComponentTab();
              } else if (data.message === 'AlreadyExist') {
                const feesComponentAlreadyExistWithSameNameTranslation = await firstValueFrom(this.translate.get('feesComponentAlreadyExistWithSameName')); 
                customToastr(feesComponentAlreadyExistWithSameNameTranslation, 'error');
              }
            }
          },
          error => {
            console.error('Add fee component error', error);
          }
        );
    }

  }

  openTermsTab() {
    this.applyFeesTermTable();
    this.feeTermTable.clear().draw();
    this.feeService.fetchSchoolFeeTerms(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            const rows = [];
            this.feeTermList = data;
            const h = this;
            this.feeTermList.forEach(tr => {
              const due = new Date(tr.DueDate);
              const t = due.getDate() + '-' + h.months[due.getMonth()] + '-' + due.getFullYear();
              const html = '<dtv><a style="cursor: pointer" id="editTerm" class="section-manage">' +
                '<i class="fa fa-edit fa-lg manage-term"></i></a> &nbsp;&nbsp;&nbsp;' +
                ' <a style="cursor: pointer" id="removeterm" class="section-manage hide"><i class="fa fa-trash fa-lg"></i></a>' +
                '</div>';
              const htmlDom = $(html);
              $(htmlDom.find('#editTerm')).attr('termData', JSON.stringify(tr));
              $(htmlDom.find('#removeterm')).attr('termData', JSON.stringify(tr));
              rows.push([tr.TermName, t, htmlDom[0].outerHTML]);
            });
            this.feeTermTable.rows.add(rows).draw();
          }
        },
        error => {
        }
      );
  }

  openCreateTerm() {
    $('#termDueDate').datepicker({ autoclose: true });
    this.createFeeTerm = JSON.parse(JSON.stringify(this.initialDataCreateFeeTerm));
    this.initialDataCreateFeeTerm = { TermName: '', academicId: '', duedate: '' };
    $('#termDueDate').val('');
    this.getAcademicList();
  }

  async createTerm(createFeeTerm) {
    this.initialDataCreateFeeTerm = { TermName: '', academicId: this.academicInfo.current_academic, duedate: '' };
    createFeeTerm.DueDate = $('#termDueDate').val();
    createFeeTerm.academicId = this.academicInfo.current_academic;

    if (createFeeTerm.TermName !== '' && createFeeTerm.academicId !== '' && createFeeTerm.DueDate !== '') {
      const d = createFeeTerm.DueDate.split('/');
      createFeeTerm.DueDate = d[2] + '-' + d[1] + '-' + d[0];
      this.feeService.createTerm(createFeeTerm, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            if (data.errorcode) {
              const failedToCreateTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateTermPleaseTryAgain')); 
              customToastr(failedToCreateTermPleaseTryAgainTranslation);
            } else {
              if (!data.status) {
                customToastr(data.message, 'error');
              } else {
                $('.modal-backdrop').trigger('click');
                const termSuccessfullyCreatedTranslation = await firstValueFrom(this.translate.get('termSuccessfullyCreated')); 
                customToastr(termSuccessfullyCreatedTranslation, 'success');
                this.openTermsTab();
              }
            }
          },
          error => {
          }
        );
    } else {
      const pleaseProvideAllTermDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllTermDetails'));
       customToastr(pleaseProvideAllTermDetailsTranslation, 'error');
    }
  }

  // Late fee
  openLateFeeTab() {
    this.applyLateFeesTable();
    this.lateFeeTable.clear().draw();
    this.feeService.newFetchLateFeeConfig(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {
            console.error("errorcode ", data.errorcode)
          }
          else {
            const rows = [];
            this.lateFeeList = data.lateFeeList;
            this.isLateFeeIncludedInCurrentMonth = data.isLateFeeIncludedInCurrentMonth == 1 ? true : false;
            const lateFeeCheckbox = document.getElementById('lateFeeForMonth') as HTMLInputElement;
            lateFeeCheckbox.checked = this.isLateFeeIncludedInCurrentMonth
            this.lateFeeList.forEach(tr => {
              const html = '<dtv><a style="cursor: pointer" id="removelatefee" class="section-manage">' +
                '<i class="fa fa-trash fa-lg"></i>' +
                '</a>' +
                '</div>';
              const htmlDom = $(html);
              $(htmlDom.find('#removelatefee')).attr('lateFeeData', JSON.stringify(tr));
              rows.push([tr.lateDays, tr.lateFees, htmlDom[0].outerHTML]);
            });
            this.lateFeeTable.rows.add(rows).draw();
          }
        },
        error => {
          console.error("error ", error);
        }
      );
  }


  async createLateFeeFunction(createLateFee) {
    this.isProcessing = true;
    let initialDataCreateLateFee = { lateDays: null, academicId: null, lateFees: null };
    initialDataCreateLateFee.lateDays = createLateFee.lateDays;
    initialDataCreateLateFee.academicId = this.academicInfo.current_academic;
    initialDataCreateLateFee.lateFees = createLateFee.lateFees;

    if (createLateFee.days !== '' && createLateFee.lateFees !== '') {
      this.feeService.createLateFees(initialDataCreateLateFee)
        .subscribe(
         async (data: any) => {
            this.isProcessing = false;
            if (data.errorcode) {
              const failedToCreateTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateTermPleaseTryAgain')); 
              customToastr(failedToCreateTermPleaseTryAgainTranslation);
            } else {
              if (!data.status) {
                customToastr(data.message, 'error');
              } else {
                if (data.status == "ALREADY_EXISTS") {
                  const lateFeeAlreadyExitsTranslation = await firstValueFrom(this.translate.get('lateFeeAlreadyExits'));
                   customToastr(lateFeeAlreadyExitsTranslation, 'error');
                }
                else {
                  $('.modal-backdrop').trigger('click');
                  const lateFeesSuccessfullyCreatedTranslation = await firstValueFrom(this.translate.get('lateFeesSuccessfullyCreated')); 
                  customToastr(lateFeesSuccessfullyCreatedTranslation, 'success');
                  $('body').find('#close-add-late-fee-popup').trigger('click');
                  this.openLateFeeTab();
                }
              }
            }
          },
          error => {
            this.isProcessing = false;
            console.error("error ", error);
          }
        );
    } else {
      this.isProcessing = false;
      const pleaseProvideAllDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllDetails')); 
      customToastr(pleaseProvideAllDetailsTranslation, 'error');
    }
  }

 applyLateFeesTable() {
  if (this.lateFeeTable === null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      this.lateFeeTable = $('#late-fee-component-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        language: {
          emptyTable: translations['dataTables.sEmptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
  }
}

  selectLateFee (id){
    this.selectedLateFeeData.id = id;
  }

  deleteLateFee() {
    this.isProcessing = true;
    this.feeService.deleteLateFee(this.selectedLateFeeData.id)
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status) {
            this.openLateFeeTab();
            const lateFeeDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('lateFeeDeletedSuccessfully')); 
            customToastr(lateFeeDeletedSuccessfullyTranslation, 'success');
            $('body').find('#close-delete-late-fee-popup').trigger('click');
          } else {
            const failedToDeleteLateFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteLateFeePleaseTryAgain')); 
            customToastr(failedToDeleteLateFeePleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          this.isProcessing = false;
          const failedToDeleteLateFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteLateFeePleaseTryAgain'));
           customToastr(failedToDeleteLateFeePleaseTryAgainTranslation, 'error');
        }
      );
  }

  applyDeletedLateFeeTable() {
    if (this.deletedLateFeeTable === null) {
      this.deletedLateFeeTable = $('#deleted-late-fee-component-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

  getDeletedLateFeeList() {
    this.applyDeletedLateFeeTable()
    this.deletedLateFeeTable.clear().draw();
    this.feeService.fetchDeletedLateFeeList(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          const h = this;
          if (data.errorcode) {
            console.error("errorcode ", data.errorcode)
          }
          else {
            const rows = [];
            this.deletedLateFeeList = data;
            this.deletedLateFeeList.forEach(tr => {
              let date = new Date(tr.modifiedOn);
              let dateToDisplay = date.getDate() + '-' + h.months[date.getMonth()] + '-' + date.getFullYear();
              rows.push([tr.lateDays, tr.lateFees, dateToDisplay, tr.adminName]);
            });
            this.deletedLateFeeTable.rows.add(rows).draw();
          }
        },
        error => {
          console.error("error ", error);
        }
      );
  }

  applyWaivedOffLateFeeTable() {
    if (this.waivedOffLateFeeTable === null) {
      this.waivedOffLateFeeTable = $('#waivedOff-late-fee-component-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

  getWaivedOffLateFeeList() {
    this.applyWaivedOffLateFeeTable()
    this.waivedOffLateFeeTable.clear().draw();
    this.feeService.fetchWaivedOffLateFeeList(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          const h = this;
          if (data.errorcode) {
            console.error("errorcode ", data.errorcode)
          }
          else {
            const rows = [];
            this.waivedOffLateFeeList = data;
            this.waivedOffLateFeeList.forEach(tr => {
              let feeName = tr.TermName ? tr.TermName : tr.FeesTypeName ? tr.FeesTypeName : tr.transport ? tr.transport : ""
              let feeType = tr.fkFeesTermId ? "Term" : tr.fkFeesTypeId ? "Other" : tr.transport ? "Transport" : ""
              let date = new Date(tr.wavedOffDateAndTime);
              let dateToDisplay = date.getDate() + '-' + h.months[date.getMonth()] + '-' + date.getFullYear();
              rows.push([tr.studentName, tr.parentName, tr.registrationId, tr.class, feeName, feeType, tr.amount, dateToDisplay, tr.adminName]);
            });
            this.waivedOffLateFeeTable.rows.add(rows).draw();
          }
        },
        error => {
          console.error("error ", error);
        }
      );
  }

  getClassStandardsNotInFeesBoard() {
    this.feeService.getClassStandardsNotInFeesBoard(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            this.classStanderdsNotInFeesBoard = data;
          }
        },
        error => {
        }
      );
  }

  getClassSectionsNotInFeesBoard(classStandardId) {
    this.feeService.getClassSectionsNotInFeesBoard(classStandardId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          } else {
            this.classSectionsNotInFeesBoard = data;
          }
        },
        error => {
        }
      );
  }

  openAddFeeBoard() {
    this.feeBoardData = [];
    this.selectClassForFeeDetail = false;
    this.feeBoardTableList = false;
    $('#select-class-add-fee').val('0');
    this.addFeeBoardNext();
  }

  standardSelected() {
    const stdId = $('#class_standard_selected').val();
    if (stdId !== '') {
      this.getClassSectionsNotInFeesBoard(stdId);
    }
  }

  addFeeBoardNext() {
    // $("#open_step_2_add_fee_board").trigger("click");
    this.feeService.feeComponentList(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {
          } else {
            this.feeComponentListAddFeeBoard = data;
          }
        },
        error => {
        }
      );
  }

  async addFeeBoard() {
    $('.disable_buttons').attr('disabled', true);
    this.submitText = 'Please Wait';
    const obj = {
      classId: $('#selectSection').val(),
      fkFeesTypeIdList: []
    };

    this.feeComponentListAddFeeBoard.forEach(it => {
      if (!it.Amount) {
        it.Amount = 0;
      }
      obj.fkFeesTypeIdList.push({ feeTypeId: it.pkFeesTypeId, amount: it.Amount });
    });

    if (obj.classId !== '' && obj.fkFeesTypeIdList.length > 0) {
      this.feeService.addFeeBoard(obj, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            $('.disable_buttons').attr('disabled', false);
            $('#previous_add_fee').attr('disabled', false);
            this.submitText = 'Submit';
            if (data.errorcode) {
              const failedToAddFeesToAClassPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToAddFeesToAClassPleaseTryAgain')); 
              customToastr(failedToAddFeesToAClassPleaseTryAgainTranslation, 'error');
            } else {
              const classFeeDetailSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('classFeeDetailSuccessfullyAdded')); 
              customToastr(classFeeDetailSuccessfullyAddedTranslation, 'success');
              $('#close_add_fee_board').trigger('click');
              this.feeComponentListAddFeeBoard = [];
              this.classStanderds = [];
              this.classSections = [];
            }
          },
          error => {
          }
        );
    } else {
      $('.disable_buttons').attr('disabled', false);
      $('#previous_add_fee').attr('disabled', false);
      const invalidDetailsGivenPleaseSelectWhichClassThisFeesBelongsToTranslation = await firstValueFrom(this.translate.get('invalidDetailsGivenPleaseSelectWhichClassThisFeesBelongsTo')); 
      customToastr(invalidDetailsGivenPleaseSelectWhichClassThisFeesBelongsToTranslation, 'error');
    }
  }

  cancelFeeBoardUpdate() {
    $('.backdrop').trigger('click');
  }

  viewStudentOffcanvas() {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-view-student');
  }

  editFeeBoard(fee) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-edit-fee');
    this.feeService.getFeeBoardDetailsOfClassSection(fee.classId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {
          } else {
            fee.AcademicYear = data[0].AcademicYear;
            fee.TotalStudents = data[0].TotalStudent;
            fee.classStandard = data[0].class;
            this.selectedClassSectionFeeBoard = JSON.parse(JSON.stringify(fee));
          }
        },
        error => {
        }
      );
  }

  async updateFeeBoard(updatedInfo) {
    const obj = { classId: this.selectedClassSectionFeeBoard.classId, fkFeesTypeIdList: [] };
    this.selectedClassSectionFeeBoard.feeTypes.forEach(t => {
      if (t.updated) {
        obj.fkFeesTypeIdList.push({
          feeTypeId: t.pkFeesTypeId,
          updateamount: t.Amount,
          Name: t.Name
        });
      }
    });

    if (obj.fkFeesTypeIdList.length > 0) {
      this.feeService.updateFeesBoard(obj, this.academicInfo.current_academic)
        .subscribe(
          (data: any) => {
            if (data.errorcode) {

            } else {
              let textS = '';
              let textF = '';
              for (const item of data.statuses) {
                if (item.status) {
                  textS += '<br> ' + item.name + ' : ' + item.error;
                } else {
                  textF += '<br> ' + item.name + ' : ' + item.error;
                }
              }

              if (textS !== '') {
                customToastr(textS, 'success');
              }

              if (textF !== '') {
                customToastr(textF, 'error');
              } else {
                $('.backdrop').trigger('click');
              }

            }

          },
          error => {
          }
        );
    } else {
      $('.backdrop').trigger('click');
      const nothingToUpdateTranslation = await firstValueFrom(this.translate.get('nothingToUpdate')); 
      customToastr(nothingToUpdateTranslation, 'error');
    }
  }

  openTermConfigTab() {
    // this.applyFeeTermConfigTable();
    this.getClassStandards(false);
    this.termList = [];
  }
  
  getClassTermConfig(classStdId, structureId, fees) {
    this.isTermConfigchanged = false;
    this.termConfigStatus = true;
    this.getStructureId = structureId;
    this.feeConfigStrucName = fees.Name;
    this.termFeeConfigurations = JSON.parse(JSON.stringify([]));
    this.termList = JSON.parse(JSON.stringify([]));
    if (this.getClassIdForFeeBoard !== '') {
      this.feeService.getTermFeeConfig(classStdId, this.getStructureId, this.academicInfo.current_academic)
        .subscribe(
          (data: any) => {
            this.termConfigStatus = false;
            if (data.errorcode) {
            } else {
              if (data && data.length > 0) {
                for (const item of data[0].termFees) {
                  if (!this.termList.some(term => term.pkFeesTermId === item.pkFeesTermId)) {
                    this.termList.push(JSON.parse(JSON.stringify(item)));
                  }
                }
                for (const item of data) {
                  if (!this.termFeeConfigurations.some(
                    config => config.pkFeesTypeId === item.pkFeesTypeId && config.fkClassId === item.fkClassId
                  )) {
                    this.termFeeConfigurations.push(JSON.parse(JSON.stringify(item)));
                  }
                }

                if(!this.isFeeBoardDataCopied && this.originalFeeTermConfig.length > 0){
                  this.replicatefeeTermDateFromSelectedClass();
                }

              } else {
                this.termFeeConfigurations = [];
              }
            }
          },
          error => {
          }
        );
    }
  }


  getTypeTermListWithPaidStatus(classId, feesTypeId, callback) {
    this.feeService.getTypeTermListWithPaidStatus(classId, feesTypeId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          callback(data);
        },
        error => {
        }
      );
  }

  openEditTermConfig(fee) {
    this.offcanvas.handleOffcanvasOpen('#offcanvas-manage-termFeeConfiguration_n');
    this.editTermFeeConfig = JSON.parse(JSON.stringify(fee));
  }

  handleCancelFeeTerm(){
    this.selectedClassIdForFeeTerm = null;
    this.originalFeeTermConfig = [];
    const selectElement = document.getElementById('classSelectForFeeTerm') as HTMLSelectElement;
    if (selectElement) {
      selectElement.value = '';
    }
  }

  async updateTermFeeConfigForStru() {
    const translate = await firstValueFrom(this.translate.get('feeCollectionData'));
    this.feesTermConfigButtonSubmitText = 'Please Wait';
    $('.disable_buttons').attr('disabled', true);
    this.feesTermConfigCancelButtonSubmitText = 'Cancel';
    $('.disable_buttons').attr('disabled', true);
    this.replicatefeeTermDateFromSelectedClass()
    const reqObj = {
      termFeeConfigurations: this.termFeeConfigurations,
      fkFeeStructuresId: this.getStructureId,
    };
    for (const tItem of this.termFeeConfigurations) {
      let totalAmount = 0;
      let allTermAmounts = 0;
      totalAmount += tItem.Amount;
      const feesAmount = tItem.termFees;

      for (const item of feesAmount) {
        allTermAmounts += parseInt(item.PaymentAmount, 10);
      }

      if (totalAmount !== allTermAmounts) {
        customToastr(`${translate.sumOfAll} <b> + ${tItem.Name} +
          '</b> ${translate.termData} to  ₹` + totalAmount, 'error');
        this.feesTermConfigButtonSubmitText = translate.save;
        $('.disable_buttons').attr('disabled', false);
        this.feesTermConfigCancelButtonSubmitText = translate.cancel;
        $('.disable_buttons').attr('disabled', false);
        return;
      }
    }

    if (this.isTermConfigchanged === true) {
      this.feeService.updateTermConfigForStruc(reqObj, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            this.feesTermConfigButtonSubmitText = 'Save';
            $('.disable_buttons').attr('disabled', false);
            this.feesTermConfigCancelButtonSubmitText = 'Cancel';
            $('.disable_buttons').attr('disabled', false);
            if (data.isValidationError) {

              let isDbError = false;
              const names = [];
              for (const item of data.responses) {
                if (item.error === 'DB_ERROR') {
                  isDbError = true;
                } else {
                  names.push(item.tr.TermName);
                }
              }

              if (isDbError) {
                const unableToUpdateTermFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('unableToUpdateTermFeePleaseTryAgain')); 
                customToastr(unableToUpdateTermFeePleaseTryAgainTranslation, 'error');
                this.feesTermConfigButtonSubmitText = 'Save';
                $('.disable_buttons').attr('disabled', false);
                this.feesTermConfigCancelButtonSubmitText = 'Cancel';
                $('.disable_buttons').attr('disabled', false);
              } else {
                const params = { param1: names.join(',')};
                const translation = await firstValueFrom(this.translate.get('unableToUpdateTermFeeSomeStudentsAlreadyPaidFeesFor', params));
                customToastr(translation, 'error');
                this.feesTermConfigButtonSubmitText = 'Save';
                $('.disable_buttons').attr('disabled', false);
                this.feesTermConfigCancelButtonSubmitText = 'Cancel';
                $('.disable_buttons').attr('disabled', false);
              }
            } else {
              $('#offcanvas_updatetermfeeconfig_cancel_button').trigger('click');
             const termConfigurationSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('termConfigurationSuccessfullyUpdated')); 
             customToastr(termConfigurationSuccessfullyUpdatedTranslation, 'success');
              const selectElement = document.getElementById('classSelectForFeeTerm') as HTMLSelectElement;
              if (selectElement) {
                selectElement.value = '';   // Clear selection
              }
              this.feesTermConfigButtonSubmitText = 'Save';
              this.originalFeeTermConfig = []
              this.selectedClassIdForFeeTerm = null;
              this.isFeeBoardDataCopied = false;
              this.selectedClassForTermInfo = null;
              $('.disable_buttons').attr('disabled', false);
              this.feesTermConfigCancelButtonSubmitText = 'Cancel';
              $('.disable_buttons').attr('disabled', false);
              this.getClassTermConfig(this.getClassIdForFeeBoard, this.getStructureId, this.termFeeConfigurations[0]);
              /*this.getFeeBoard(this.getClassIdForFeeBoard);*/
            }

          },
          error => {
            this.feesTermConfigButtonSubmitText = 'Save';
            $('.disable_buttons').attr('disabled', false);
            this.feesTermConfigCancelButtonSubmitText = 'Cancel';
            $('.disable_buttons').attr('disabled', false);
          }
        );
    } else {
      this.feesTermConfigButtonSubmitText = 'Save';
      $('.disable_buttons').attr('disabled', false);
      this.feesTermConfigCancelButtonSubmitText = 'Cancel';
      $('.disable_buttons').attr('disabled', false);
      const noChangesToUpdateTranslation = await firstValueFrom(this.translate.get('noChangesToUpdate')); 
      customToastr(noChangesToUpdateTranslation, 'error');
    }
  }

  replicatefeeTermDateFromSelectedClass() {
    if (this.selectedClassIdForFeeTerm && this.originalFeeTermConfig.length > 0) {
      this.originalFeeTermConfig.forEach(fee => {
        this.termFeeConfigurations.forEach(feeTerm => {
          if (fee.pkFeesTypeId == feeTerm.pkFeesTypeId) {
            fee.termFees = feeTerm.termFees
          }
        });
      });
      this.isTermConfigchanged = true
      this.termFeeConfigurations = this.originalFeeTermConfig;
    }
  }
  
  parseDatewww(dueDate) {
    if (dueDate) {
      const d = new Date(dueDate);
      return '' + d.getDate() + '-' + this.months[d.getMonth()] + '-' + d.getFullYear();
    }
    return '--';

  }

  getFilterBy() {
    const isByName = $('#search-by-name').hasClass('filter-active');
    const isByRegId = $('#search-reg-id').hasClass('filter-active');
    const isByMobile = $('#search-by-mobile').hasClass('filter-active');
    return isByName ? 'STUDENT_NAME' : isByRegId ? 'REGISTRATION_ID' : 'MOBILE_NUMBER';
  }

 async searchStudent(showError) {
    this.errorStudentFeeCollectionProcess.isError = false;
    this.totalSelectedAmount = 0;
    this.isSearchActive = true;
    let text = $('#groupbutton10').val();
    text = text.trim();
    this.studentList = [];
    if (text !== '') {
      const isByName = $('#search-by-name').hasClass('filter-active');
      const filterBy = this.getFilterBy();
      this.feeService.searchNewStudent(text, isByName ? 'YES' : 'NO', filterBy, this.academicInfo.current_academic, this.isStudentDeactivated)
        .subscribe(
          async (data: any) => {
            this.resultsExist = true;
            this.studentList = data?.studentList;
            this.sequenceFeeCollection = data?.isFeeSequenceEnabled === 1 ? data.isFeeSequenceEnabled : false;
            if (!(data?.studentList.length > 0)) {
              const noStudentsFoundForYourSearchTranslation = await firstValueFrom(this.translate.get('noStudentsFoundForYourSearch')); 
              customToastr(noStudentsFoundForYourSearchTranslation, 'error');
            }
          },
          error => {
            this.resultsExist = false;
            this.errorStudentFeeCollectionProcess.isError = true;
            this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
            this.errorStudentFeeCollectionProcess.buttonText = 'Search Again';
            this.errorStudentFeeCollectionProcess.message =
              'Failed to search Students, <br> &nbsp;&nbsp;&nbsp;Please click on <b>' +
              this.errorStudentFeeCollectionProcess.buttonText + '</b> to try again';
          }
        );
    } else {
      if (showError !== "NO") {
        const pleaseEnterStudentNameToSearchTranslation = await firstValueFrom(this.translate.get('pleaseEnterStudentNameToSearch')); 
        customToastr(pleaseEnterStudentNameToSearchTranslation, 'error');
      }
    }
  }

  fetchFeeCollectionInfo(student) {
    this.studentAllSiblings = [];
    const filterBy = this.getFilterBy();
    const searchBoxValue = filterBy === 'STUDENT_NAME' ?
      student.studentName : filterBy === 'REGISTRATION_ID' ? student.registrationId : student.mobileNumber;
    $('#groupbutton10').val(searchBoxValue);

    this.totalSelectedAmount = 0;
    student.isLoading = true;
    this.tab1Status = false;
    this.tab2Status = false;
    this.feeCollectionAllFeeList = [];
    this.feeCollectionOtherFeeTermFeeList = [];
    this.lastSelectedStudent = student;
    this.feeService.getStudentFeeDashInfo(student.studentId, student.classId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          student.isLoading = false;
          this.studentFeeDashDetails = JSON.parse(JSON.stringify(data));
          this.studentFeeDashDetails.student.mobileNumber = student.mobileNumber;
          this.isSearchActive = false;
          this.getStudentFeeList(student);
        },
        error => {
          student.isLoading = false;
          this.studentFeeDashDetails = JSON.parse(JSON.stringify(this.backupStudentFeeDashDetails));
          this.errorStudentFeeCollectionProcess.isError = true;
          this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
          this.errorStudentFeeCollectionProcess.buttonText = 'Re-fetch Details';
          this.errorStudentFeeCollectionProcess.message =
            'Failed to fetch Student fee details, <br> &nbsp;&nbsp;&nbsp;Please click on <b>' +
            this.errorStudentFeeCollectionProcess.buttonText + '</b> to try again';
        }
      );

  }
  

  studentAllAcademicFeeLoading = false;
  fetchStudentPreviousAcademicFees() {
    this.studentAllAcademicFeeLoading = true;
    this.studentAllAcademicFee = [];
    this.feeService.studentAllAcademicFeeStatus(this.studentFeeDashDetails.student.studentId)
      .subscribe(
        async (data: any) => {
          this.studentAllAcademicFeeLoading = false;
          this.studentAllAcademicFee = JSON.parse(JSON.stringify(data.data));
          if (this.studentAllAcademicFee.length > 0) {
            $("#all_previous_academic_fee_trigger").trigger("click");
          }
          else {
           const studentDataNotAvailableInPreviousYearsTranslation = await firstValueFrom(this.translate.get('studentDataNotAvailableInPreviousYears')); 
           customToastr(studentDataNotAvailableInPreviousYearsTranslation, 'error');
          }

        },
        error => {
          this.studentAllAcademicFeeLoading = false;
        }
      );
  }

  studentAllSiblingsLoading = false;
  fetchStudentSiblings(stdDetails) {
    this.studentAllSiblingsLoading = true;
    this.studentAllSiblings = [];
    this.feeService.studentSiblingsFee(stdDetails.studentId, stdDetails.mobileNumber, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {
          this.studentAllSiblingsLoading = false;
          this.studentAllSiblings = JSON.parse(JSON.stringify(data.data));
          if (this.studentAllSiblings.length > 0) {
            $("#student_siblings_trigger").trigger("click");
          }
          else {
            const studentDoesNotHaveAnySiblingsTranslation = await firstValueFrom(this.translate.get('studentDoesNotHaveAnySiblings')); 
            customToastr(studentDoesNotHaveAnySiblingsTranslation, 'error');
          }

        },
        error => {
          this.studentAllSiblingsLoading = false;
        }
      );
  }

  isExpandedTermsPaid(terms) {
    for (const item of terms) {
      if (item.Paid > 0) {
        return true;
      }
    }
    return false;
  }

  getStudentFeeList(student) {
    this.feeService.getStudentFeeList_v2(student.studentId, student.classId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.isSearchActive = false;
          this.studentFeeList = JSON.parse(JSON.stringify(data));
          let allFees = JSON.parse(JSON.stringify(this.studentFeeList.termFees));
          for (const item of allFees) {
            if (item.Paid > 0 && item.Balance > 0) {
              if (!this.isExpandedTermsPaid(item.expandedTerms)) {
                item.feeFault = true;
              }
            } else {
              item.feeFault = false;
            }
          }
          allFees = allFees.concat(JSON.parse(JSON.stringify(this.studentFeeList.typeFees)));
          this.feeCollectionOtherFeeTermFeeList = JSON.parse(JSON.stringify(this.studentFeeList.otherFeeTerms));
          allFees.sort((o1, o2) => {
            if (new Date(o1.DueDate) < new Date(o2.DueDate)) {
              return -1;
            } else if (new Date(o1.DueDate) > new Date(o2.DueDate)) {
              return 1;
            } else {
              return 0;
            }
          });
          this.tab1Status = true;
          this.tab2Status = false;
          this.feeCollectionAllFeeList = allFees;
          if (this.feeCollectionAllFeeList && this.feeCollectionAllFeeList.length > 0) {
            let once1 = true;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.feeCollectionAllFeeList.length; i++) {
              if (this.sequenceFeeCollection === false) {
                this.feeCollectionAllFeeList[i].disabled = false;
              } else {
                if (this.feeCollectionAllFeeList[i].Balance > 0 && once1) {
                  once1 = false;
                  this.feeCollectionAllFeeList[i].disabled = false;
                } else {
                  this.feeCollectionAllFeeList[i].disabled = true;
                }
              }
            }
          }

        },
        error => {
          this.isSearchActive = true;
          this.studentFeeList = JSON.parse(JSON.stringify(this.newStudentFeeList));
          this.errorStudentFeeCollectionProcess.isError = true;
          this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
          this.errorStudentFeeCollectionProcess.buttonText = 'Re-fetch Details';
          this.errorStudentFeeCollectionProcess.message =
            'Failed to fetch Student fee details, <br> &nbsp;&nbsp;&nbsp;Please click on <b>' +
            this.errorStudentFeeCollectionProcess.buttonText + '</b> to try again';
        }
      );
  }

  errorDisplayInTerm(term) {
    this.errorStudentFeeCollectionProcess.isError = true;
    this.errorStudentFeeCollectionProcess.prefixMessage = '<b> Issue with ' + term.TermName + ' receipt,</b></br></br>';
    this.errorStudentFeeCollectionProcess.buttonText = 'Proceed';
    this.errorStudentFeeCollectionProcess.message =
      'We found an issue with <b>' + term.TermName + '</b> fee receipt, Please delete <b>' +
      term.TermName + '</b> fee receipt and &nbsp;&nbsp;&nbsp;collect with same date when the deleted receipt generated, ' +
      '</br>&nbsp;&nbsp;&nbsp;Please click on <b>' + this.errorStudentFeeCollectionProcess.buttonText + '</b> to do same';

  }

  showTermFeeBreakup(term) {
    this.breakupFeeTermName = term.TermName;
    this.termFeeBreakups = [];
    const breakupFee = term.typename.split(',');
    for (const item of breakupFee) {
      const fees = item.split('---');
      this.termFeeBreakups.push({ Name: fees[0], Amount: fees[1] });
    }
  }

  reInitiateStudentFeeCollection() {
    this.feePaymentProceedText = 'proceed Payment';
    this.errorStudentFeeCollectionProcess.isError = false;
    if (this.errorStudentFeeCollectionProcess.buttonText === 'Proceed') {
      $('#collectiontab').find('.step').trigger('click');
      this.getFeeCollectionHistory(this.studentFeeDashDetails.student.studentId, this.studentFeeDashDetails.student.classId, 'YES');
    } else if (this.errorStudentFeeCollectionProcess.buttonText === 'Correct Transport options') {
      this.errorStudentFeeCollectionProcess.isError = false;
      this.openStudentTransportOptionSettingsPopup = true;
    } else {
      this.searchStudent('NO');
    }
  }

  checkIsNextOnePaidOnChecked(index, total, setStatus, arrayName) {
    if ((index + 1) < total) {
      if (this[arrayName][index + 1].Balance <= 0) {
        this.checkIsNextOnePaidOnChecked((index + 1), total, setStatus, arrayName);
      } else {
        this[arrayName][index + 1].disabled = setStatus;
      }
    }
  }

  checkIsPreviousOnePaidOnChecked(index, total, setStatus, arrayName) {
    if ((index - 1) >= 0) {
      if (this[arrayName][index - 1].Balance <= 0) {
        this.checkIsPreviousOnePaidOnChecked((index - 1), total, setStatus, arrayName);
      } else {
        this[arrayName][index - 1].disabled = setStatus;
      }
    }
  }

  checkDisableState(index, total, isSelected, type, arrayName) {
    if (this.sequenceFeeCollection === false) {
      this[arrayName][index].disabled = false;
      if (index - 1 >= 0) {
        this[arrayName][index - 1].disabled = false;
      }
      if (index + 1 < total) {
        this[arrayName][index + 1].disabled = false;
      }
      this.showSelectedAmountFloating();
      return;
    }
  
    if (isSelected) {
      if (index - 1 >= 0) {
        if (this[arrayName][index - 1].Balance <= 0) {
          this.checkIsPreviousOnePaidOnChecked(index - 1, total, true, arrayName);
        } else {
          this[arrayName][index - 1].disabled = true;
        }
      }
      this[arrayName][index].disabled = false;
      if ((index + 1) < total) {
        if (this[arrayName][index + 1].Balance <= 0) {
          this.checkIsNextOnePaidOnChecked((index + 1), total, false, arrayName);
        } else {
          this[arrayName][index + 1].disabled = false;
        }
      }
    } else {
      this[arrayName][index].disabled = false;
      if ((index - 1) >= 0) {
        if (this[arrayName][index - 1].Balance <= 0) {
          this.checkIsPreviousOnePaidOnChecked(index - 1, total, false, arrayName);
        } else {
          this[arrayName][index - 1].disabled = false;
        }
      }
      if ((index + 1) < total) {
        if (this[arrayName][index + 1].Balance <= 0) {
          this.checkIsNextOnePaidOnChecked((index + 1), total, true, arrayName);
        } else {
          this[arrayName][index + 1].disabled = true;
        }
      }
    }
  
    this.showSelectedAmountFloating();
  }
  

  showSelectedAmountFloating() {
    this.isActivateDeactivateButtonVisible = true;
    this.totalSelectedAmount = 0;
    // tslint:disable-next-line:prefer-for-of
    for (let f = 0; f < this.feeCollectionAllFeeList.length; f++) {
      if (this.feeCollectionAllFeeList[f].selected) {
        this.totalSelectedAmount += this.feeCollectionAllFeeList[f].Balance;
      }
    }
    // tslint:disable-next-line:prefer-for-of
    for (let f = 0; f < this.feeCollectionOtherFeeTermFeeList.length; f++) {
      if (this.feeCollectionOtherFeeTermFeeList[f].selected) {
        this.totalSelectedAmount += this.feeCollectionOtherFeeTermFeeList[f].Balance;
      }
    }
  }

  async setMaxLength(data) {

    if (data.Amount > 9999999) {
      const theAmountShouldNotExceed7DigitsTranslation = await firstValueFrom(this.translate.get('theAmountShouldNotExceed7Digits')); 
      customToastr(theAmountShouldNotExceed7DigitsTranslation, 'error');
      data.Amount = $.trim(data.Amount).substring(0, 7);
    }
  }

  async setMaxLengthForTerm(feecomp) {
    if (feecomp.PaymentAmount > 9999999) {
      const theAmountShouldNotExceed7DigitsTranslation = await firstValueFrom(this.translate.get('theAmountShouldNotExceed7Digits')); 
      customToastr(theAmountShouldNotExceed7DigitsTranslation, 'error');
      feecomp.PaymentAmount = $.trim(feecomp.PaymentAmount).substring(0, 7);
    }
  }

  textWrappingForTermName(name) {
    if (name.length > 15) {
      return $.trim(name).substring(0, 15) + '...';
    } else {
      return name;
    }
  }

  textWrappingForTermNamestruc(data) {
    if (data.length > 15) {
      return $.trim(data).substring(0, 15) + '...';
    } else {
      return data;
    }
  }

  textWrappingForStudentName(name) {
    if (name.length > 9) {
      return $.trim(name).substring(0, 9) + '...';
    } else {
      return name;
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvents(event) {
    if (event.key === 'Enter' && event.target.id === 'groupbutton10') {
      this.searchStudent('YES');
    } else if (event.key === 'Enter' && event.target.id === 'groupbutton12') {
      this.searchStudentForCategory();
    }
  }

  async makePayment(type) {
    this.totalSelectedAmount = 0;
    const data = [];
    this.isOldFee = false;
    const h = this;
    let isOldFeeSelected = false;
    if (type === 'ANY') {
      // tslint:disable-next-line:variable-name
      const _this = this;
      this.feeCollectionAllFeeList.forEach(t => {

        if (t.feeFault) {
          _this.errorDisplayInTerm(t);
          return;
        }
        if (t.selected) {
          let lateFee = (!t.waiverFees && t.lateFee && t.lateFee > 0) ? t.lateFee : 0
          let lateFeeId = (!t.waiverFees && t.pkLateFeesId) ? t.pkLateFeesId : null
          if (t.isBusFee) {
            if (t.isOldFee) {
              h.isOldFee = true;
              isOldFeeSelected = true;
            }
            data.push({
              feeType: 'BUS',
              typeId: t.busStopId,
              Name: t.Name,
              Amount: t.feesTypeAmount,
              Balance: t.Balance,
              Discount: t.Discount,
              Paid: t.Paid,
              isBusFee: t.isBusFee,
              busId: t.busId,
              busTermId: t.busTermId,
              isOldFee: t.isOldFee,
              lateFee: lateFee,
              lateFeeId: lateFeeId
            });
          } else if (t.TermName) {
            if (t.isOldFee) {
              h.isOldFee = true;
              isOldFeeSelected = true;
            }
            data.push({
              feeType: 'TERM',
              feeFault: t.feeFault,
              expandedTerms: t.expandedTerms,
              termId: t.fkFeesTermId,
              termTypeId: t.fkFeesTypeId,
              Name: t.TermName,
              Amount: t.feesTermAmount,
              Balance: t.Balance,
              Discount: t.discount,
              Paid: t.Paid,
              isOldFee: t.isOldFee,
              lateFee: lateFee,
              lateFeeId: lateFeeId
            });
          } else {
            if (t.isOldFee) {
              h.isOldFee = true;
              isOldFeeSelected = true;
            }
            data.push({
              feeType: 'OTHER',
              typeId: t.fkFeesTypeId,
              Name: t.Name,
              Amount: t.feesTypeAmount,
              Balance: t.Balance,
              Discount: t.Discount,
              Paid: t.Paid,
              isBusFee: t.isBusFee,
              busId: t.busId,
              busTermId: t.busTermId,
              isOldFee: t.isOldFee,
              lateFee: lateFee,
              lateFeeId: lateFeeId
            });
          }
        }
      });

      if (this.feeCollectionOtherFeeTermFeeList.length > 0) {
        this.feeCollectionOtherFeeTermFeeList.forEach(f => {
          if (f.selected) {
            if (f.isOldFee) {
              h.isOldFee = true;
              isOldFeeSelected = true;
            }
            data.push({
              feeType: 'OTHER-TERM',
              pkOtherFeesId: f.pkOtherFeesId,
              pkOtherFeeTermId: f.pkOtherFeeTermId,
              Name: f.Name,
              Amount: f.termAmount,
              Balance: f.Balance,
              Discount: f.Discount,
              Paid: f.Paid,
              isBusFee: f.isBusFee,
              busId: f.busId,
              busTermId: f.busTermId,
              isOldFee: f.isOldFee
            });
          }
        });
      }

      if (data.length > 0) {
        let leftOldFeeData = false;
        if (isOldFeeSelected) {
          for (const item of data) {
            if (!item.isOldFee) {
              leftOldFeeData = true;
            }
          }
        }
        if (leftOldFeeData) {
          const pleaseSelectOldFeeOptionForAllTheFeesYouSelectedTranslation = await firstValueFrom(this.translate.get('pleaseSelectOldFeeOptionForAllTheFeesYouSelected')); 
          customToastr(pleaseSelectOldFeeOptionForAllTheFeesYouSelectedTranslation, 'error');
          return;
        }
        $('#payment-details').addClass('active');
        $('#paymentDetailTabHeader').addClass('active');
        $('#payment-details').removeClass('');
        $('#mode-of-payment').addClass('');
        $('#payment-mode').addClass('');
        $('#payment-mode').removeClass('active');
        $('#mode-of-payment').removeClass('active');
        $('#transection').find('.step').trigger('click');
        if (this.isOldFee) {
          $('#paidOnDateOldFee_date').datepicker({
            autoclose: true,
            format: 'dd-mm-yyyy',
            //startDate: ,
            endDate: new Date()
          });
          $('#paidOnDateOldFee_time').val('08:00');


          /*$("#paidOnDateOldFee_time").timepicker({
           timeFormat: 'H:i',
           defaultTime:'06:00',
           step:30
           });*/
        }

        this.showPaymentDetails(data, type);
      } else {
        const pleaseSelectFeeSToProceedTranslation = await firstValueFrom(this.translate.get('pleaseSelectFeeSToProceed')); 
        customToastr(pleaseSelectFeeSToProceedTranslation, 'error');
      }
    }

  }

  showPaymentDetails(data, type) {
    this.applyLateFee = true
    this.selectedPayment = data;
    this.selectedPaymentType = type;
    let balance = 0;
    let lateFee = 0
    this.selectedPayment.forEach((t, i) => {
      balance = balance + (t.Balance ? t.Balance : 0);
      lateFee = lateFee + (t.lateFee ? t.lateFee : 0);
    });
    this.isLateFee = lateFee > 0 ? true : false
    this.payableAmount = balance;
    this.payableLateFee = lateFee

    $('#payableAmount').val(this.payableAmount);
    $('#payableLateFeeAmount').val(this.payableLateFee);
    $('#totalAmount').val(this.payableAmount + this.payableLateFee);
    $('#calculatePayableAmount').text(this.payableAmount);
    $('#calculateLateFeeAmount').text(this.payableLateFee);
  }

  calculateTotalToDisplay() {
    let val = parseInt($('#payableAmount').val(), 10)
    let v = $.isNumeric(val) ? val : 0
    $('#totalAmount').val(v + this.payableLateFee);
  }

  checkWaiveOffLateFee() {
    const checkbox = document.getElementById('waiveOffLateFeeCheckbox',) as HTMLInputElement | null;
    if (this.applyLateFee) {
      $('body').find('#confirm-waive-off-late-fee').trigger('click');
    }
    if (checkbox != null) {
      checkbox.checked = this.applyLateFee;
    }
  }

  confirmWaiveOffLateFee() {
    this.isProcessing = true;
    let dataToSend = []
    this.selectedPayment.forEach(t => {
      if (t.lateFee > 0) {
        if (t.feeType === 'TERM') {
          dataToSend.push({
            lateFeesId: t.lateFeeId,
            academicId: this.academicInfo.current_academic,
            studentId: this.studentFeeDashDetails.student.studentId,
            amount: t.lateFee,
            feesTermId: t.termId,
            feesTypeId: null,
            fkBusId: null,
            fkBusStopId: null,
            fkBusTermId: null
          })
        }
        else if (t.feeType === 'OTHER') {
          dataToSend.push({
            lateFeesId: t.lateFeeId,
            academicId: this.academicInfo.current_academic,
            studentId: this.studentFeeDashDetails.student.studentId,
            amount: t.lateFee,
            feesTermId: null,
            feesTypeId: t.typeId,
            fkBusId: null,
            fkBusStopId: null,
            fkBusTermId: null
          })
        }
        else if (t.feeType === 'BUS') {
          dataToSend.push({
            lateFeesId: t.lateFeeId,
            academicId: this.academicInfo.current_academic,
            studentId: this.studentFeeDashDetails.student.studentId,
            amount: t.lateFee,
            feesTermId: null,
            feesTypeId: null,
            fkBusId: t.busId,
            fkBusStopId: t.typeId,
            fkBusTermId: t.busTermId
          })
        }
      }
    });
    this.feeService.waiveOffLateFee({ data: dataToSend })
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status) {
            this.applyLateFee = false
            this.payableLateFee = 0
            this.selectedPayment.forEach(t => {
              if (t.lateFee) {
                t.lateFee = 0;
              }
              if (t.lateFeeId) {
                t.lateFeeId = null
              }
            });
            $('#payableLateFeeAmount').val(this.payableLateFee);
            $('#calculateLateFeeAmount').text(this.payableLateFee);
            $('#totalAmount').val(this.payableAmount + this.payableLateFee);
            const checkbox = document.getElementById('waiveOffLateFeeCheckbox',) as HTMLInputElement | null;
            if (checkbox != null) {
              checkbox.checked = false;
              checkbox.disabled = true
            }
            const lateFeeWaivedOffSuccessfullyTranslation = await firstValueFrom(this.translate.get('lateFeeWaivedOffSuccessfully'));
             customToastr(lateFeeWaivedOffSuccessfullyTranslation, 'success');
            $('body').find('#close-confirm-waive-off-late-fee-popup').trigger('click');
          } else {
           const failedToWaiveOffLateFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToWaiveOffLateFeePleaseTryAgain'));
            customToastr(failedToWaiveOffLateFeePleaseTryAgainTranslation, 'error')
          }
        },
        async error => {
          this.isProcessing = false;
          const failedToWaiveOffLateFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToWaiveOffLateFeePleaseTryAgain')); 
          customToastr(failedToWaiveOffLateFeePleaseTryAgainTranslation, 'error');
        }
      );
  }

  calculatePayableAmount() {
    let balance = 0;
    this.selectedPayment.forEach(t => {
      balance = balance + t.Balance;
    });
    this.payableAmount = balance;
    if (this.once) {
      this.once = false;
      $('#payableAmount').val(this.payableAmount);
    }

    return balance;
  }

  async proceedToPaymentMode() {
    this.modePayStatus = true;
    this.paymentStatus = false;
    let isLateFeeExists = false;
    $('#mode-of-payment-cash').trigger('click');
    const translate = await firstValueFrom(this.translate.get('feeCollectionData'));
    this.changePaymentMode('Cash');
    let oldFeeDate = null;
    if (this.isOldFee) {
      let oldDate = $('#paidOnDateOldFee_date').val();
      let oldTime = $('#paidOnDateOldFee_time').val();
      if (this.formValidator.validateIsData(oldDate) && this.formValidator.validateIsData(oldTime)) {
        const dateInMoment = momentJs();
        oldDate = oldDate.split('-');
        dateInMoment.date(oldDate[0]);
        dateInMoment.month(parseInt(oldDate[1], 10) - 1);
        dateInMoment.year(oldDate[2]);
        if (dateInMoment.isAfter(momentJs()) || dateInMoment.format('DD-MM-YYYY') === momentJs().format('DD-MM-YYYY')) {
          const pleaseSelectPastDateTranslation = await firstValueFrom(this.translate.get('pleaseSelectPastDate')); 
          customToastr(pleaseSelectPastDateTranslation, 'error');
          return;
        }
        oldDate = oldDate[2] + '-' + oldDate[1] + '-' + oldDate[0];
        oldTime = oldTime + ':00';
        oldFeeDate = oldDate + ' ' + oldTime;
      } else {
        const pleaseSelectOldFeeCollectionDateTimeTranslation = await firstValueFrom(this.translate.get('pleaseSelectOldFeeCollectionDateTime')); 
        customToastr(pleaseSelectOldFeeCollectionDateTimeTranslation, 'error');
        return;
      }
    }
    let payAmount = $('#payableAmount').val();
    this.totalPayableAmount = parseInt(payAmount);
    if ($.isNumeric(payAmount)) {
      const paymentList = [];
      const h = this;
      payAmount = parseInt(payAmount, 10);
      if (payAmount > 0 && payAmount <= this.payableAmount) {
        this.selectedPayment.forEach(t => {
          if (t.lateFee > 0 && !isLateFeeExists) {
            isLateFeeExists = true;
          }
          if (payAmount > 0) {
            if (t.Balance >= payAmount) {

              if (t.feeType === 'TERM') {
                const eTerms = t.expandedTerms;

                if (eTerms && eTerms.length > 0) {
                  let lateFeeAmountTerm = t.lateFee;

                  for (const item of eTerms) {
                    let balance = item.feesTermAmount - (item.Paid + item.discount);
                    if (balance >= payAmount) {
                      balance = payAmount;
                    }
                    payAmount = payAmount - balance;

                    if (balance > 0) {
                      paymentList.push({
                        feeType: t.feeType,
                        feeFault: t.feeFault,
                        termId: t.termId,
                        TypeIdInTerm: item.fkFeesTypeId,
                        termTypeId: t.termTypeId,
                        Balance: balance,
                        Discount: 0,
                        isOldFee: t.isOldFee,
                        oldFeeDate,
                        pkLateFeesId: lateFeeAmountTerm == 0 ? null : t.lateFeeId,
                        lateFee: lateFeeAmountTerm
                      });
                      lateFeeAmountTerm = 0
                    }
                  }
                } else {
                  paymentList.push({
                    feeType: t.feeType,
                    feeFault: t.feeFault,
                    termId: t.termId,
                    termTypeId: t.termTypeId,
                    Balance: payAmount,
                    Discount: 0,
                    isOldFee: t.isOldFee,
                    oldFeeDate,
                    pkLateFeesId: t.lateFeeId,
                    lateFee: t.lateFee
                  });
                }
              } else {
                paymentList.push({
                  feeType: t.feeType,
                  feeFault: t.feeFault,
                  typeId: t.typeId,
                  pkOtherFeesId: t.pkOtherFeesId,
                  pkOtherFeeTermId: t.pkOtherFeeTermId,
                  Balance: payAmount,
                  Discount: 0,
                  isBusFee: t.isBusFee,
                  busId: t.busId,
                  busTermId: t.busTermId,
                  isOldFee: t.isOldFee,
                  oldFeeDate,
                  pkLateFeesId: t.lateFeeId,
                  lateFee: t.lateFee
                });
              }

              payAmount = 0;
            } else {
              if (t.feeType === 'TERM') {
                const eTerms = t.expandedTerms;
                if (eTerms && eTerms.length > 0) {
                  let lateFeeAmountTerm = t.lateFee;
                  // tslint:disable-next-line:prefer-for-of
                  for (let i = 0; i < eTerms.length; i++) {
                    const balance = eTerms[i].feesTermAmount - (eTerms[i].Paid + eTerms[i].discount);
                    if (balance > 0) {
                      paymentList.push({
                        feeType: t.feeType,
                        feeFault: t.feeFault,
                        termId: t.termId,
                        TypeIdInTerm: eTerms[i].fkFeesTypeId,
                        termTypeId: t.termTypeId,
                        Balance: balance,
                        Discount: 0,
                        isOldFee: t.isOldFee,
                        oldFeeDate,
                        pkLateFeesId: lateFeeAmountTerm == 0 ? null : t.lateFeeId,
                        lateFee: lateFeeAmountTerm
                      });
                      lateFeeAmountTerm = 0;
                    }
                  }
                } else {
                  paymentList.push({
                    feeType: t.feeType,
                    feeFault: t.feeFault,
                    termId: t.termId,
                    termTypeId: t.termTypeId,
                    Balance: t.Balance,
                    Discount: 0,
                    isOldFee: t.isOldFee,
                    oldFeeDate,
                    pkLateFeesId: t.lateFeeId,
                    lateFee: t.lateFee
                  });
                }
                payAmount = payAmount - t.Balance;
              } else {
                paymentList.push({
                  feeType: t.feeType,
                  feeFault: t.feeFault,
                  typeId: t.typeId,
                  pkOtherFeesId: t.pkOtherFeesId,
                  pkOtherFeeTermId: t.pkOtherFeeTermId,
                  Balance: t.Balance,
                  Discount: 0,
                  isBusFee: t.isBusFee,
                  busId: t.busId,
                  busTermId: t.busTermId,
                  isOldFee: t.isOldFee,
                  oldFeeDate,
                  pkLateFeesId: t.lateFeeId,
                  lateFee: t.lateFee
                });
                payAmount = payAmount - t.Balance;
              }

            }
          }
        });
        this.finalPaymentList = paymentList;
        $('#paymentDetailTabHeader, #payment-details').removeClass('active');
        $('#payment-mode, #mode-of-payment').addClass('active');
      } else if (payAmount <= 0 || payAmount > this.payableAmount) {

        customToastr(translate.payAmountBetween + this.currType + ' 1 to ' + this.currType + ' ' + this.payableAmount, 'error');
      }
    } else {
      const invalidPayableAmountTranslation = await firstValueFrom(this.translate.get('invalidPayableAmount')); 
      customToastr(invalidPayableAmountTranslation, 'error');
    }
    // if(isLateFeeExists){
    //   $("#card-cash-mode").addClass("hide")
    // }
    // else{
    //   $("#card-cash-mode").removeClass("hide")
    // }
  }

  previewPopupTotal(amount, lateFee) {
    amount = parseInt(amount);
    lateFee = lateFee ? parseInt(lateFee) : 0;
    return amount + lateFee;
  }

  backToPaymentDetails() {
    $('#paymentDetailTabHeader, #payment-details').addClass('active');
    $('#payment-mode, #mode-of-payment').removeClass('active');
  }

  changePaymentMode(mode) {
    $('#card_invoice').val('');
    $('#card_cash_invoice').val('');
    $('#card_Amount').val('');
    $('#cash_Amount').val('');
    $('#dd_bankandbranch').val('');
    $('#dd_date').val('');
    $('#dd_number').val('');
    $('#dd_micrcode').val('');
    $('#cheque_bankandbranch').val('');
    $('#cheque_date').val('');
    $('#cheque_number').val('');
    $("#bank_transfer_bankandbranch").val('');
    $("#bank_transfer_date").val('');
    $("#bank_transfer_number").val('');
    $('#qr_invoice').val('')
    $('#dd_amount').val('')
    $('#cheque_amount').val()
    $('#qr_date').val()
    if (mode === 'Bank-transfer') {
      $('#bank_transfer_date').datepicker({ autoclose: true });
      $('#bank-transfer').addClass('show');
      $('#bank-transfer').removeClass('hide');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');
    }
    else if (mode === 'DD') {
      $('#dd_date').datepicker({ autoclose: true });
      $('#payByDD').addClass('show');
      $('#payByDD').removeClass('hide');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');

    } else if (mode === 'Cheque') {
      $('#cheque_date').datepicker({ autoclose: true });
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payBycheque').addClass('show');
      $('#payBycheque').removeClass('hide');
      $('#payByCard').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');
    } else if (mode === 'Card') {
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').removeClass('hide');
      $('#payByCard').addClass('show');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');
    } else if (mode === 'Card&Cash') {
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard_Cash').addClass('show');
      $('#payByCard_Cash').removeClass('hide');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');
    } else if (mode === 'QRCode') {
      $('#qr_date').datepicker({ autoclose: true });
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard').removeClass('show');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('show');
      $('#payByQRCode').removeClass('hide');
    } else {
      $('#payByDD').addClass('hide');
      $('#payByDD').removeClass('show');
      $('#payBycheque').addClass('hide');
      $('#payBycheque').removeClass('show');
      $('#payByCard').removeClass('show');
      $('#payByCard').addClass('hide');
      $('#payByCard_Cash').addClass('hide');
      $('#payByCard_Cash').removeClass('show');
      $('#bank-transfer').addClass('hide');
      $('#bank-transfer').removeClass('show');
      $('#payByQRCode').addClass('hide');
      $('#payByQRCode').removeClass('show');
    }
    this.paymentMode = mode;
  }



  async toggleLateFee() {
    const lateFeeCheckbox = document.getElementById('lateFeeCheckbox') as HTMLInputElement;
    this.startDateForFeeCollection = $('#startdate').val();
    this.endDateForFeeCollection = $('#enddate').val();
    if (this.startDateForFeeCollection == '' || this.endDateForFeeCollection == '') {
      const pleaseSelectTheDateRangeTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheDateRange')); 
      customToastr(pleaseSelectTheDateRangeTranslation, 'error');
      lateFeeCheckbox.checked = false; // Ensure the checkbox remains unchecked
    } else {
      this.isLateFeeIncluded = lateFeeCheckbox.checked
    }
  }

  async proceedToPayment(paymentList) {
    let refNo = null;

    const reqObj = {
      studentDetail: this.studentFeeDashDetails.student,
      discount: 0,
      fkClassId: this.studentFeeDashDetails.student.classId,
      feesArray: [],
      fkStudentId: this.studentFeeDashDetails.student.studentId,
      ModeOfPayment: this.paymentMode,
      BankName: null,
      ModeOfPayDate: null,
      DDNumber: null,
      MICRCode: null,
      ChequeNumber: null,
      ReferenceNumber: refNo,
      fkFeeStructuresId: this.studentFeeDashDetails.TermFees.feeStrutureId || null,
      chequeAmount: null,
      ddAmount: null
    };

  
    if (this.paymentMode === 'Card') {
      reqObj.ReferenceNumber  = $('#card_invoice').val();
      if (!this.formValidator.validateIsData( reqObj.ReferenceNumber )) {
        const pleaseProvideInvoiceReferenceNoTranslation = await firstValueFrom(this.translate.get('pleaseProvideInvoiceReferenceNo')); 
        customToastr(pleaseProvideInvoiceReferenceNoTranslation, 'error');
        return;
      }
    }

    if (this.paymentMode === 'QRCode') {
      reqObj.ReferenceNumber = $('#qr_invoice').val();
      let modeOfPayDate = $('#qr_date').val();
      if (!this.formValidator.validateIsData( reqObj.ReferenceNumber)) {
        const pleaseProvideInvoiceReferenceNoTranslation = await firstValueFrom(this.translate.get('pleaseProvideInvoiceReferenceNo')); 
        customToastr(pleaseProvideInvoiceReferenceNoTranslation, 'error');
        return;
      }

      if (modeOfPayDate) {
        const dateParts = modeOfPayDate.split('/');
        if (dateParts.length === 3) {
          modeOfPayDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
          reqObj.ModeOfPayDate = modeOfPayDate;
          const selectedDate = new Date(modeOfPayDate);
          const currentDate = new Date();
          if (selectedDate > currentDate) {
            const theDateCannotBeInTheFutureTranslation = await firstValueFrom(this.translate.get('theDateCannotBeInTheFuture')); 
            customToastr(theDateCannotBeInTheFutureTranslation, 'error');
            return;
          }
        } else {
          const pleaseProvideAValidDateInTheFormatDdMmYyyyTranslation = await firstValueFrom(this.translate.get('pleaseProvideAValidDateInTheFormatDdMmYyyy')); 
          customToastr(pleaseProvideAValidDateInTheFormatDdMmYyyyTranslation, 'error');
          return;
        }
      } else {
        const pleaseProvideAValidDateTranslation = await firstValueFrom(this.translate.get('pleaseProvideAValidDate')); 
        customToastr(pleaseProvideAValidDateTranslation, 'error');
        return;
      }

    }
    if (this.paymentMode === 'Card&Cash') {
      reqObj.ReferenceNumber  = $('#card_cash_invoice').val();
      let cash = $('#cash_Amount').val();
      let card = $('#card_Amount').val();
      if (this.payableLateFee > parseInt(cash)) {
        const pleaseIncludeTheLateFeeInTheCashAmountOnlyTranslation = await firstValueFrom(this.translate.get('pleaseIncludeTheLateFeeInTheCashAmountOnly')); 
        customToastr(pleaseIncludeTheLateFeeInTheCashAmountOnlyTranslation, 'error');
        return;
      }
      if (!this.formValidator.validateIsData(reqObj.ReferenceNumber )) {
        const pleaseProvideInvoiceReferenceNoTranslation = await firstValueFrom(this.translate.get('pleaseProvideInvoiceReferenceNo')); 
        customToastr(pleaseProvideInvoiceReferenceNoTranslation, 'error');
        return;
      }
      if (this.formValidator.validateIsData(card)) {
        if (this.formValidator.validateIsDataForNumber(card) && !$.isNumeric(card)) {
          const pleaseEnterAValidCardAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidCardAmount')); 
          customToastr(pleaseEnterAValidCardAmountTranslation, 'error');
          return;
        }
      } else {
        const pleaseEnterCardAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterCardAmount')); 
        customToastr(pleaseEnterCardAmountTranslation, 'error');
        return;
      }
      if (this.formValidator.validateIsData(cash)) {
        if (this.formValidator.validateIsDataForNumber(cash) && !$.isNumeric(cash)) {
          const pleaseEnterAValidCashAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidCashAmount')); 
          customToastr(pleaseEnterAValidCashAmountTranslation, 'error');
          return;
        }
      } else {
        const pleaseEnterCashAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterCashAmount')); 
        customToastr(pleaseEnterCashAmountTranslation, 'error');
        return;
      }

      const totalAmountToPay = (parseInt(card, 10) + parseInt(cash, 10));
      if (parseInt((this.totalPayableAmount + this.payableLateFee), 10) !== totalAmountToPay) {
        const pleaseEnterSumOfExactPayableAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterSumOfExactPayableAmount')); 
        customToastr(pleaseEnterSumOfExactPayableAmountTranslation, 'error');
        return;
      }
      const payAmount = this.totalPayableAmount;
      paymentList.forEach(t => {
        if (payAmount > 0) {
          if (t.Balance >= card) {
            t.cardAmount = card;
            t.cashAmount = (t.Balance - parseInt(card, 10));
            card = 0;
            cash = (t.Balance - parseInt(card, 10));
          } else {
            t.cardAmount = t.Balance;
            t.cashAmount = 0;
            card = (parseInt(card, 10) - t.Balance);
          }
        }
      });
    }
    this.feePaymentProceedText = 'Please Wait';
    $('.disable_buttons').attr('disabled', true);
    this.paymentMode = this.paymentMode || 'Cash';
    reqObj.feesArray = JSON.parse(JSON.stringify(paymentList));
    if (this.paymentMode === 'Bank-transfer') {
      const BTBankBranch = $('#bank_transfer_bankandbranch').val();
      let BTDate = $('#bank_transfer_date').val();
      const BTNumber = $('#bank_transfer_number').val();
      if (BTBankBranch !== '' && BTDate !== '' && BTNumber !== '') {
        const d = BTDate.split('/');
        BTDate = d[2] + '-' + d[1] + '-' + d[0];
        reqObj.BankName = BTBankBranch;
        reqObj.ModeOfPayDate = BTDate;
        reqObj.ReferenceNumber = BTNumber;
        this.previewPaymentDetails(reqObj);
      } else {
        const pleaseFillTheBankTransferDetailsTranslation = await firstValueFrom(this.translate.get('pleaseFillTheBankTransferDetails')); 
        customToastr(pleaseFillTheBankTransferDetailsTranslation, 'error');
        this.feePaymentProceedText = 'proceed Payment';
        $('.disable_buttons').attr('disabled', false);
      }
    } else if (this.paymentMode === 'DD') {
      const ddBankBranch = $('#dd_bankandbranch').val();
      let ddDate = $('#dd_date').val();
      const ddNumber = $('#dd_number').val();
      const ddMicrCode = $('#dd_micrcode').val();
      const ddAmount = $('#dd_amount').val();
      if (ddBankBranch !== '' && ddDate !== '' && ddNumber !== '' && ddMicrCode !== '') {
        if (ddAmount && ddAmount <= 0) {
          const pleaseEnterAValidDdAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidDdAmount')); 
          customToastr(pleaseEnterAValidDdAmountTranslation, 'error');
          this.feePaymentProceedText = 'proceed Payment';
          $('.disable_buttons').attr('disabled', false);
        } else {
          const d = ddDate.split('/');
          ddDate = d[2] + '-' + d[1] + '-' + d[0];
          reqObj.BankName = ddBankBranch;
          reqObj.ModeOfPayDate = ddDate;
          reqObj.DDNumber = ddNumber;
          reqObj.MICRCode = ddMicrCode;
          reqObj.ddAmount = ddAmount;
          this.previewPaymentDetails(reqObj);
        }
      }
      else {
        const pleaseFillTheDdDetailsTranslation = await firstValueFrom(this.translate.get('pleaseFillTheDdDetails')); 
        customToastr(pleaseFillTheDdDetailsTranslation, 'error');
        this.feePaymentProceedText = 'proceed Payment';
        $('.disable_buttons').attr('disabled', false);
      }
    } else if (this.paymentMode === 'Cheque') {
      const chequeBankBranch = $('#cheque_bankandbranch').val();
      let chequeDate = $('#cheque_date').val();
      const chequeNumber = $('#cheque_number').val();
      const chequeAmount = $('#cheque_amount').val()
      if (chequeBankBranch !== '' && chequeDate !== '' && chequeNumber !== '') {
        if (chequeAmount && chequeAmount <= 0) {
          const pleaseEnterAValidChequeAmountTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidChequeAmount')); 
          customToastr(pleaseEnterAValidChequeAmountTranslation, 'error');
          this.feePaymentProceedText = 'proceed Payment';
          $('.disable_buttons').attr('disabled', false);
        } else {
          const d = chequeDate.split('/');
          chequeDate = d[2] + '-' + d[1] + '-' + d[0];
          reqObj.BankName = chequeBankBranch;
          reqObj.ModeOfPayDate = chequeDate;
          reqObj.ChequeNumber = chequeNumber;
          reqObj.chequeAmount = chequeAmount;
          this.previewPaymentDetails(reqObj);
        }
      } else {
        const pleaseFillTheChequeDetailsTranslation = await firstValueFrom(this.translate.get('pleaseFillTheChequeDetails')); 
        customToastr(pleaseFillTheChequeDetailsTranslation, 'error');
        this.feePaymentProceedText = 'proceed Payment';
        $('.disable_buttons').attr('disabled', false);
      }
    } else {
      this.previewPaymentDetails(reqObj);
    }
  }

  previewPaymentDetails(reqObj) {
    this.previewPaymentDetailsData = reqObj;
    $('body').find('#fee_payment_preview_open').trigger('click');
  }

  yesProceedPay(reqObj) {
    let time_stamp = moment_js().valueOf();
    let diff = time_stamp - this.feeCollectionTimestamp;
    if (diff < 5000) {
    }
    else {
      let reqId = "REQID_" + this.schoolId + "_" + time_stamp;
      this.feeCollectionTimestamp = time_stamp;
      this.sendPaymentInfo(reqObj, reqId);
    }

  }


  sendPaymentInfo(paymentDetails, reqId) {
    paymentDetails.reqId = reqId;
    this.feeService.sendPaymentInfo(paymentDetails, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.status) {
            this.getFeeReceipt(data.status);
            this.getFeeDashDetails();
            this.fetchFeeDetailOfStandard();
          } else {
            if (!data.isValid && data.reason) {
              this.feePaymentProceedText = 'proceed Payment';
              $('.disable_buttons').attr('disabled', false);
              this.errorStudentFeeCollectionProcess.isError = true;
              this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
              this.errorStudentFeeCollectionProcess.buttonText = 'Correct Transport options';
              this.errorStudentFeeCollectionProcess.message =
                '<div style=\'margin-left: :5px\'>There was an error while paying Student fee<br> <b><u>Reason: </u></b>' +
                data.reason + ', <br> Please click on <b>' + this.errorStudentFeeCollectionProcess.buttonText +
                '</b> to reset the details & try again</div>';
            } else if(!data.status && data.message) {
              this.feePaymentProceedText = 'proceed Payment';
              $('.disable_buttons').attr('disabled', false);
              this.errorStudentFeeCollectionProcess.isError = true;
              this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
              this.errorStudentFeeCollectionProcess.buttonText = 'Reset Details';
              this.errorStudentFeeCollectionProcess.message =
              '<div style=\'margin-left: :5px\'>There was an error while paying Student fee<br> <b><u>Reason: </u></b>' +
              data.message + ', <br> Please click on <b>' +
              this.errorStudentFeeCollectionProcess.buttonText + '</b> to reset the details & try again';
            }else{
              //this.feePaymentProceedText = 'proceed Payment';
              //$('.disable_buttons').attr('disabled', false);
              this.feePaymentProceedText = 'proceed Payment';
              $('.disable_buttons').attr('disabled', false);
              this.errorStudentFeeCollectionProcess.isError = true;
              this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
              this.errorStudentFeeCollectionProcess.buttonText = 'Reset Details';
              this.errorStudentFeeCollectionProcess.message =
                'There was an error while collecting Student fee, <br> &nbsp;&nbsp;&nbsp;Please click on <b>' +
                this.errorStudentFeeCollectionProcess.buttonText + '</b> to reset the details & try again';
            }
          }
        },
        error => {
          this.feePaymentProceedText = 'proceed Payment';
          $('.disable_buttons').attr('disabled', false);
          this.errorStudentFeeCollectionProcess.isError = true;
          this.errorStudentFeeCollectionProcess.prefixMessage = '<b>We Are Sorry,</b><br><br>';
          this.errorStudentFeeCollectionProcess.buttonText = 'Reset Details';
          this.errorStudentFeeCollectionProcess.message =
            'There was an error while collecting Student fee, <br> &nbsp;&nbsp;&nbsp;Please click on <b>' +
            this.errorStudentFeeCollectionProcess.buttonText + '</b> to reset the details & try again';
        }
      );
  }

  onLateFeeToggleChange(){
    const lateFeeCheckbox = document.getElementById('lateFeeForMonth') as HTMLInputElement;
    this.isLateFeeIncludedInCurrentMonth  = lateFeeCheckbox.checked;
    this.updateIsFeeIncludedInCurrentMonth()
  }
  async updateIsFeeIncludedInCurrentMonth(){
    try {
      const body = {
        isLateFeeIncludedInCurrentMonth : this.isLateFeeIncludedInCurrentMonth,
        lang : 'en'
      }
      const response = await firstValueFrom(this.feeService.updateIsLateFeeIncludedInCurrentMonth(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        const lateFeeConfigurationUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('lateFeeConfigurationUpdatedSuccessfully')); 
        customToastr(lateFeeConfigurationUpdatedSuccessfullyTranslation, 'success');
      } else {
        const failedToUpdateLateFeeConfigurationPleaseTryAgainLaterTranslation = await firstValueFrom(this.translate.get('failedToUpdateLateFeeConfigurationPleaseTryAgainLater'));
        customToastr(failedToUpdateLateFeeConfigurationPleaseTryAgainLaterTranslation, this.strings.errorCode);
      }
    } catch (error) {
      this.isLateFeeIncludedInCurrentMonth = false;
    }
  }
  getFeeReceipt(receiptId) {
    $('.hide-while-print').show();
    this.feeService.getFeeReceipt(receiptId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.feeReceipt = data.receiptInfo;
          this.feeReceiptStd = data.receiptInfo[0];
          this.feeReceiptSetting = data.feeSetting || { isFeesModuleEnable: '' };
          this.feePaymentProceedText = 'proceed Payment';
          $('.disable_buttons').attr('disabled', false);
          this.feeReceiptOpenedFrom = "AFTER_PAYMENT";
          $('#openFeeReceipt').trigger('click');
          /* $('#tab1').addClass('active');
           $('#collectFee').trigger('click');
           $('#tab1').removeClass('');
           $('#tab2').addClass('');
           $('#tab2').removeClass('active');
           $('#tab3').addClass('');
           $('#tab3').removeClass('active');
           this.fetchFeeCollectionInfo(this.lastSelectedStudent);*/
        },
        error => {
        }
      );
  }

  validateFeeData(feesArray) {
    if (feesArray && feesArray.length > 0) {
      for (const item of feesArray) {
        if (item.feeType === 'TERM') {
          if (!item.Balance || !item.termId || !item.termTypeId) {
            return { isValid: false, reason: 'Term fee details are not proper, please reload page and make payment.' };
          }
        }
        if (item.feeType === 'OTHER-TERM') {
          if (!item.Balance || !item.pkOtherFeesId || !item.pkOtherFeeTermId) {
            return { isValid: false, reason: 'Other-Term fee details are not proper, please reload page and make payment.' };
          }
        }
        if (item.feeType === 'OTHER') {
          if (!item.Balance || !item.typeId) {
            return { isValid: false, reason: 'Other fee details are not proper, please reload page and make payment.' };
          }
        }
        if (item.feeType === 'BUS') {
          if (!item.Balance || !item.busId || !item.typeId || !item.busTermId) {
            return { isValid: false, reason: 'Transport fee details are not proper, please reload page and make payment.' };
          }
        }
      }
    } else {
      return { isValid: false, reason: '' };
    }
    return { isValid: true };
  }
  getTotalAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.Amount : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.Amount || 0;
      });
    }

    return amount;
  }
  getTotalLateFeeAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.lateFees : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.lateFees || 0;
      });
    }

    return amount;
  }
  getTotalCardAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.cardAmount : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.cardAmount || 0;
      });
    }
    return amount;

  }

  getTotalCashAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.cashAmount : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.cashAmount || 0;
      });
    }
    return amount;
  }

  getActualTotalAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.ActualAmount || 0 : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.ActualAmount || 0;
      });
    }
    return amount;
  }

  getDiscountTotalAmount() {
    let amount = 0;
    if (this.feeReceiptSetting.isFeesModuleEnable === 'ENABLED') {
      this.feeReceipt.forEach(item => {
        amount += item.colExists ? item.DiscountAmount || 0 : 0;
      });
    } else {
      this.feeReceipt.forEach(item => {
        amount += item.DiscountAmount || 0;
      });
    }
    return amount;
  }

  getTotalReceivedAmount() {
    let amount1 = this.getTotalAmount()
    let amount2 = this.getTotalLateFeeAmount()
    return amount1 + amount2
  }

  getChequeNumber() {
    if (this.feeReceipt.length > 0) {
      return this.feeReceipt[0].ChequeNumber || '';
    }
    return '';
  }

  getModeOfPayDate() {
    if (this.feeReceipt.length > 0) {
      return this.feeReceipt[0].ModeOfPayDate || '';
    }
    return '';
  }

  getModeOfPayment() {
    if (this.feeReceipt.length > 0) {
      return this.feeReceipt[0].ModeOfPayment || 'Cash';
    }
    return 'Cash';
  }

  formatDate(date) {
    let d = new Date();
    if (date && date !== '') {
      d = new Date(date);
    }

    return '' + d.getDate() + '-' + this.months[d.getMonth()] + '-' + d.getFullYear();
  }


 async getFeeCollectionHistoryForStudent() {
    this.feesCollectionModesWise = {};
    this.collectionByAdmin = [];
    this.startDateForFeeCollection = $('#startdate').val();
    this.endDateForFeeCollection = $('#enddate').val();

    if (this.startDateForFeeCollection === '' || this.endDateForFeeCollection === '') {
      const pleaseSelectTheDateRangeTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheDateRange')); 
      customToastr(pleaseSelectTheDateRangeTranslation, 'error');
      this.processingNwCall = false;
    } else {
      const d = this.startDateForFeeCollection.split('/');
      this.startDateForFeeCollection = d[2] + '-' + d[1] + '-' + d[0];

      const e = this.endDateForFeeCollection.split('/');
      this.endDateForFeeCollection = e[2] + '-' + e[1] + '-' + e[0];
      $('#feeColl').show();
      $('#lateFeeCollectionHistory').show();
      this.processingNwCall = true;
      this.initDataTableServerProcess('fee-collection-history-table', this.schoolId, this.authToken,
        this.startDateForFeeCollection, this.endDateForFeeCollection);
      this.feeService.getFeeHistoryForStudent(this.startDateForFeeCollection, this.endDateForFeeCollection,
        this.academicInfo.current_academic, this.isLateFeeIncluded)
        .subscribe(
          (data: any) => {
            this.processingNwCall = false;
            this.feesCollectionModesWise = data.collectionModes;
            this.collectionByAdmin = data.adminCollection;
          },
          error => {
            this.processingNwCall = false;
          }
        );

    }
  }

  async getPaidLateFeeList() {
    let startDate = $('#startdate').val();
    let endDate = $('#enddate').val();
    if (startDate !== '' || endDate !== '') {
      this.applyPaidLateFeeTable()
      this.paidLateFeeTable.clear().draw();
      let s = startDate.split('/')
      let e = endDate.split('/')
      startDate = s[2] + '-' + s[1] + '-' + s[0]
      endDate = e[2] + '-' + e[1] + '-' + e[0]
      let params = {
        academicId: this.academicInfo.current_academic,
        stDate: startDate,
        edDate: endDate,
      }
      this.feeService.fetchPaidLateFeeList(params)
        .subscribe(
          (data: any) => {
            const h = this;
            if (data.errorcode) {
            }
            else {
              const rows = [];
              this.paidLateFeeList = data;
              this.paidLateFeeList.forEach(tr => {
                let feeName = tr.TermName ? tr.TermName : tr.FeesTypeName ? tr.FeesTypeName : tr.transport ? tr.transport : ""
                let feeType = tr.fkFeesTermId ? "Term" : tr.fkFeesTypeId ? "Other" : tr.transport ? "Transport" : ""
                let date = new Date(tr.CreatedDate);
                let dateToDisplay = date.getDate() + '-' + h.months[date.getMonth()] + '-' + date.getFullYear();
                rows.push([tr.studentName, tr.parentName, tr.registrationId, tr.class, feeName, feeType, tr.lateFees, dateToDisplay, tr.adminName]);
              });
              this.paidLateFeeTable.rows.add(rows).draw();
            }
          },
          error => {
            console.error("error ", error);
          }
        );
    }
    else {
      const pleaseSelectTheDateRangeTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheDateRange')); 
      customToastr(pleaseSelectTheDateRangeTranslation, 'error');
    }
  }

  applyPaidLateFeeTable() {
    if (this.paidLateFeeTable === null) {
      this.paidLateFeeTable = $('#paid-late-fee-component-table').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: 'There are no details to show'
        },
        language: {
          lengthMenu: '_MENU_ entries per page',
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    }
  }

  overdueStudentSelected(details) {
    if (details.selectedStudent) {
      this.selectedOverdueStudentsList.push(details.studentId);
    } else {
      const index = this.selectedOverdueStudentsList.indexOf(details.studentId);
      if (index !== -1) {
        this.selectedOverdueStudentsList.splice(index, 1);
      }
    }
    this.selectedOverdueStudentsCount = this.selectedOverdueStudentsList.length;
  }

  initDataTableServerProcess(tableid, schoolId, authToken, startDate, endDate) {
    const h = this;
    const utilFun = {
      getText() {
        return 'Fees collection export sheet ' + startDate + ' to ' + endDate;
      }
    };
    const pageLength = 25;
    let lastIndex = 25;

     this.translate.get([
      'dataTables.processing',
      'dataTables.search',
      'dataTables.processing',
      'dataTables.lengthMenu',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.paginate.first',
      'dataTables.paginate.last',
      'dataTables.paginate.next',
      'dataTables.paginate.previous',
      'dataTables.buttons.copy',
      'dataTables.buttons.excel',
      'dataTables.buttons.csv',
      'dataTables.buttons.pdf',
      'dataTables.buttons.colvis',
      'dataTables.buttons.colvisRestore',
      'dataTables.exportTitle',
    ]).subscribe(translations => {

    this.feesCollectionHistoryListTable = $('#' + tableid).DataTable({
      destroy: true,
      language: {
        search: translations['dataTables.search'],
        lengthMenu: translations['dataTables.lengthMenu'],
        info: translations['dataTables.info'],
        infoEmpty: translations['dataTables.infoEmpty'],
        infoFiltered: translations['dataTables.infoFiltered'],
        paginate: {
          first: translations['dataTables.paginate.first'],
          last: translations['dataTables.paginate.last'],
          next: translations['dataTables.paginate.next'],
          previous: translations['dataTables.paginate.previous']
        },
        processing:
          `<h3 style='color: var(--brand-primary-color);font-size: 2em;font-weight: 100;'>${translations['dataTables.processing']}</h3>`,
      },
      processing: true,
      serverSide: true,
      dom: 'lfBrtip',
      lengthMenu: [
        [25, 50, 100, -1],
        ['25', '50', '100', 'Show all']
      ],
      buttons: [
        {
          extend: 'copyHtml5',
          title: utilFun.getText(),
          text: translations['dataTables.buttons.copy']
        },
        {
          extend: 'excelHtml5',
          title: utilFun.getText(),
          text: translations['dataTables.buttons.excel']
        },
        {
          extend: 'csvHtml5',
          title: utilFun.getText(),
          text: translations['dataTables.buttons.csv']
        },
        {
          extend: 'pdfHtml5',
          title: utilFun.getText(),
          text: translations['dataTables.buttons.pdf']
        },
        {
          extend: 'colvis',
          targets: 0,
          columns: ':not(.noVis)',
          postfixButtons: ['colvisRestore'],
          text: translations['dataTables.buttons.colvis']
        }
      ],
      pageLength,
      ajax: {
        beforeSend(request) {
          request.setRequestHeader('Content-Type', 'application/json');
          request.setRequestHeader('authToken', authToken);
        },

        url: AppSettings.API_ENDPOINT + '/feeCollection/feeCollection/byDate_v2/datatable',
        type: 'POST',
        data(d) {
          if (d.length === -1) {
            d.length = lastIndex;
          }
          return JSON.stringify({
            schoolId: localStorage.getItem('schoolinfo'),
            startDate,
            endDate,
            countFrom: d.start,
            lengthOf: d.length,
            academicId: h.academicInfo.current_academic,
            search: d.search.value,
            sort: d.order
          });
        }
      },
      columnDefs: [
        {
          targets: 1,
          className: 'noVis'
        }
      ],
      columns: [
        { data: 'studentName' },
        { data: 'parentName' },
        { data: 'mobileNumber' },
        { data: 'Amount' },
        { data: 'lateFees' },
        { data: 'className' },
        { data: 'feeName' },
        { data: 'feeType' },
        { data: 'collectionDate', class: 'date-format' },
        { data: 'creditDate', class: 'credit-date-format' },
        { data: 'ModeOfPayment' }
      ],
      rowCallback(row, data, index) {
        data.collectionDate = moment_js(data.collectionDate).format('DD-MMM-YYYY hh:mm a');
        $(row).find('.date-format').text(data.collectionDate);
        if (data.creditDate && data.creditDate != '-') {
          data.creditDate = moment_js(data.creditDate).format('DD-MMM-YYYY');
          $(row).find('.credit-date-format').text(data.creditDate);
        }
        else $(row).find('.credit-date-format').text('-');
      },
      initComplete(settings, json) {
        const info = this.api().page.info();
        lastIndex = info.recordsTotal;
      }
    });
  });
  }

  async toggleLateFeeForReport() {
    const lateFeeCheckboxForReport = document.getElementById('lateFeeCheckboxForReport') as HTMLInputElement;
    this.startDateForFeeReports = $('#rstartdate').val();
    this.endDateForFeeRepors = $('#renddate').val();
    if (this.startDateForFeeReports == '' || this.endDateForFeeRepors == '') {
      const pleaseSelectTheDateRangeTranslation = await firstValueFrom(this.translate.get('pleaseSelectTheDateRange')); 
      customToastr(pleaseSelectTheDateRangeTranslation, 'error');
      lateFeeCheckboxForReport.checked = false;
    } else {
      this.isLateFeeIncludedForReport = lateFeeCheckboxForReport.checked
    }
  }

  checkDateRangeSelected() {
    this.startDateForFeeReports = $('#rstartdate').val();
    this.endDateForFeeRepors = $('#renddate').val();

    if (this.startDateForFeeReports == '' || this.endDateForFeeRepors == '') {
      return false;
    }
    else {
      const d = this.startDateForFeeReports.split('/');
      this.startDateForFeeReports = d[2] + '-' + d[1] + '-' + d[0];

      const e = this.endDateForFeeRepors.split('/');
      this.endDateForFeeRepors = e[2] + '-' + e[1] + '-' + e[0];
      return true;
    }
  }

  feeReportType = '';
  headwiseReportsTableTitle = '';
  fetchAdminCollectedFeeHeadwise(adminId, adminName, reportType, tableTitle) {
    this.feeReportType = reportType;
    this.headwiseReportsTableTitle = tableTitle;
    this.fetchAdminCollectedFeeisLoading = true;
    this.selectedAdminName = adminName;
    this.adminCollectedFees = { allFeeNames: [], data: [] };
    this.destroyDataTable('admin_collection_headwise-table');
    this.destroyDataTable('admin_deleted-fee-table');
    const collectFeeTab2 = document.getElementById('collect_fee_tab_2');
    const isHistoryActive = collectFeeTab2.classList.contains('active');
    const isLateFeeIncluded = isHistoryActive ? this.isLateFeeIncluded : this.isLateFeeIncludedForReport
    if (reportType == 'ADMIN_WISE') {
      this.feeService.getFeeHistoryHeadsCollectedByAdmin(this.startDateForFeeCollection, this.endDateForFeeCollection,
        adminId, this.academicInfo.current_academic, isLateFeeIncluded)
        .subscribe(
          (data: any) => {
            this.fetchAdminCollectedFeeisLoading = false;
            this.adminCollectedFees = data;
            this.initializeDataTable('admin_collection_headwise-table');
          },
          error => {
            this.fetchAdminCollectedFeeisLoading = false;
          }
        );
    }
    else if (reportType == 'SINGLE_ACADEMIC') {
      this.feeService.getFeeHistoryHeadsCollectedFYByAdmin(this.startDateForFeeReports, this.endDateForFeeRepors,
        this.academicInfo.current_academic, isLateFeeIncluded)
        .subscribe(
          (data: any) => {
            this.fetchAdminCollectedFeeisLoading = false;
            this.adminCollectedFees = data;
            this.initializeDataTable('admin_collection_headwise-table');
          },
          error => {
            this.fetchAdminCollectedFeeisLoading = false;
          }
        );
    }
    else if (reportType == 'ALL_ACADEMICS') {
      this.feeService.getFeeHistoryHeadsCollectedFY(this.startDateForFeeReports, this.endDateForFeeRepors, isLateFeeIncluded)
        .subscribe(
          (data: any) => {
            this.fetchAdminCollectedFeeisLoading = false;
            this.adminCollectedFees = data;
            this.initializeDataTable('admin_collection_headwise-table');
          },
          error => {
            this.fetchAdminCollectedFeeisLoading = false;
          }
        );
    }
    else if (reportType == 'ACADEMIC_WISE') {
      this.feeService.getFeeHistoryHeadsCollectedAllAcademics(this.startDateForFeeReports, this.endDateForFeeRepors, isLateFeeIncluded)
        .subscribe(
          (data: any) => {
            this.fetchAdminCollectedFeeisLoading = false;
            this.adminCollectedFees = data;
            this.initializeDataTable('admin_collection_headwise-table');
          },
          error => {
            this.fetchAdminCollectedFeeisLoading = false;
          }
        );
    }
  }

  fetchAdminCancelledFee(adminId, adminName) {
    this.fetchAdminCollectedFeeisLoading = true;
    this.selectedAdminName = adminName;
    this.adminCancelledFees = [];
    this.destroyDataTable('admin_deleted-fee-table');
    this.destroyDataTable('admin_collection_headwise-table');
    this.feeService.getAdminCancelledFeeHistory(adminId, this.startDateForFeeCollection,
      this.endDateForFeeCollection, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          // admin_collection_headwise
          this.fetchAdminCollectedFeeisLoading = false;
          this.adminCancelledFees = data;
          this.initializeDataTable('admin_deleted-fee-table');
        },
        error => {
          this.fetchAdminCollectedFeeisLoading = false;
        }
      );
  }

  feeHistorydataHide() {
    this.isActivateDeactivateButtonVisible = false;
    $('#feeColl').hide();
    $('#lateFeeCollectionHistory').hide();
    this.feeCollectionHistoy = [];
    if (this.feeHistoryTable !== null) {
      this.feeHistoryTable.destroy();
      this.feeHistoryTable = null;
    }
    this.applyFeeHistoryTable();
  }

  getFeeCollectionHistory(studentId, classId, resetPage) {
    if (resetPage === 'YES') {
      this.feeHistoryPageNumber = 1;
    }
    if (this.feeHistoryTable !== null) {
      this.feeHistoryTable.destroy();
      this.feeHistoryTable = null;
    }
    this.feeService.getFeeHistory(studentId, classId, this.feeHistoryPageNumber, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (!data.errorcode) {
            this.feeCollectionHistoy = data;
            this.isLastPageExist = data.length === 10;
            $('.fees_history_next').attr('disabled', !this.isLastPageExist);
          } else {
            this.feeCollectionHistoy = [];
          }
          const h = this;
          setTimeout(() => {
            h.applyFeeHistoryTable();
          }, 100);
        },
        error => {

        }
      );
  }

  getFeeCollectionUpdateHistory(studentId, classId, resetPage) {
    $('#fee-update-history').trigger('click');
    if (resetPage === 'YES') {
      this.feeHistoryPageNumber = 1;
    }
    this.feeCollectionUpdateHistoy = [];
    if (this.feeUpdateHistoryTable !== null) {
      this.feeUpdateHistoryTable.destroy();
      this.feeUpdateHistoryTable = null;
    }
    this.feeService.getStudentUpdateFeeHistory(studentId, classId, this.feeHistoryPageNumber, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (!data.errorcode) {
            this.feeCollectionUpdateHistoy = data;
            this.isLastPageExist = data.length === 10;
            $('.fees_history_next').attr('disabled', !this.isLastPageExist);
          } else {
            this.feeCollectionUpdateHistoy = [];
          }
          const h = this;
          setTimeout(() => {
            this.applyFeeUpdateHistoryTable();
          }, 100);
        },
        error => {

        }
      );
  }

  showFeeReceipt(receiptId, h) {
    h.isLoading = true;
    this.feeService.getFeeReceipt(receiptId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          h.isLoading = false;
          this.feeReceipt = data.receiptInfo;
          this.feeReceiptStd = data.receiptInfo[0];
          this.feeReceiptSetting = data.feeSetting || { isFeesModuleEnable: '' };
          this.feeReceiptOpenedFrom = "FEE_HISTORY";
          $('#openFeeReceipt').trigger('click');
        },
        error => {
          h.isLoading = false;
        }
      );
  }

  nextPage() {
    if (this.isLastPageExist) {
      this.feeHistoryPageNumber = this.feeHistoryPageNumber + 1;
      this.getFeeCollectionHistory(this.studentFeeDashDetails.student.studentId, this.studentFeeDashDetails.student.classId,
        this.feeHistoryPageNumber);
    } else {
      $('.fees_history_next').attr('disabled', false);
    }
    if (this.feeHistoryPageNumber >= 1) {
      $('.fees_history_prev').attr('disabled', false);
    }
  }

  previousPage() {
    if (this.feeHistoryPageNumber >= 1) {

      this.feeHistoryPageNumber = this.feeHistoryPageNumber - 1;
      if (this.feeHistoryPageNumber === 0) {
        $('.fees_history_prev').attr('disabled', true);
      } else {
        $('.fees_history_prev').attr('disabled', false);
      }
      this.getFeeCollectionHistory(this.studentFeeDashDetails.student.studentId, this.studentFeeDashDetails.student.classId,
        this.feeHistoryPageNumber);

    } else {
      $('.fees_history_prev').attr('disabled', true);
    }

  }

  async updateTerm(term) {
    const duedate = $('#dueDate_term').val();
    if (term.TermName !== '' && duedate !== '') {
      const d = duedate.split('/');
      const reqObj = {
        name: term.TermName,
        duedate: d[2] + '-' + d[1] + '-' + d[0],
        pkFeesTermId: term.pkFeesTermId
      };
      this.feeService.updateTerm(reqObj, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            if (data.message === 'Success') {
              const termSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('termSuccessfullyUpdated')); 
              customToastr(termSuccessfullyUpdatedTranslation, 'success');
              $('.backdrop').trigger('click');
            } else if (data.message === 'AlreadyExist') {
              const termAlreadyExistsTranslation = await firstValueFrom(this.translate.get('termAlreadyExists')); 
              customToastr(termAlreadyExistsTranslation, 'error');
            } else {
              const feesTermNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('feesTermNotUpdatedPleaseTryAgain')); 
              customToastr(feesTermNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          },
          error => {
          }
        );
    } else {
      const pleaseProvideRequiredDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideRequiredDetails')); 
      customToastr(pleaseProvideRequiredDetailsTranslation, 'error');
    }
  }

  cancelTermUpdate() {
    $('#offcanvas-manage-termFee_open').trigger('click');
    // this.offcanvas.handleOffcanvasOpen("#offcanvas-manage-termFee");
  }

  feesCollectionTabClicked() {
    if (this.academicPermissions.FEES_COLLECTION !== 'ENABLED' && this.academicPermissions.SCHOOL_ADMIN_FEE_COLLECTION_VIEW === 'ENABLED') {
      $('body').find('#collect_fee_tab_1').removeClass('active');
      $('body').find('#fee-collection').removeClass('active');
      $('body').find('#collect_fee_tab_2').addClass('active');
      $('body').find('#fee-collection-history').addClass('active');
      this.feeHistorydataHide();
      this.totalSelectedAmount = 0;
    }
  }

  discountDetails() {
    this.destroyDataTable('fee-discounts-table');
    this.feeService.fetchdiscount(localStorage.getItem('usertoken'), this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {

          this.discountlist = data;

          if (data.length === 0) {
            $('#discountAvail').show();
          } else {
            $('#discountAvail').hide();
          }
          this._initializeDataTable('fee-discounts-table');
        },
        error => {

        }
      );
  }

  getTermTypeBusTerms() {

    this.feeService.getTypeTermBusTerms(localStorage.getItem('usertoken'), this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.allFeeNames = data;
        },
        error => {

        }
      );
  }

  truncateText(text, length) {
    if (text && text.length > length) {
      return text.substr(0, length) + '..';
    }
    return text;
  }

  aplyDiscountpopup(d) {
    this.discount = d;
    $('#applydiscountbutton').attr('disabled', false);
    $('#apply-discount').modal('show');
  }

  async adddiscount(addDiscount) {

    if (
      this.formValidator.validateIsData(addDiscount.discountName) &&
      addDiscount.discountAmount > 0
    ) {

      const components = [];
      if (this.allFeeNames.typeList && this.allFeeNames.typeList.length > 0) {
        this.allFeeNames.typeList.forEach(eachComponent => {
          if (eachComponent.isIncludedInTerm) {
            eachComponent.terms.forEach(eachTerm => {
              if (eachTerm.selected) {
                components.push({ termId: eachTerm.pkFeesTermId, typeId: eachComponent.pkFeesTypeId, busTermId: null });
              }
            });
          } else if (eachComponent.selected) {
            components.push({ termId: null, typeId: eachComponent.pkFeesTypeId, busTermId: null });
          }
        });
      }

      if (this.allFeeNames.busTermList && this.allFeeNames.busTermList.length > 0) {
        this.allFeeNames.busTermList.forEach(eachComponent => {
          if (eachComponent.selected) {
            components.push({ termId: null, typeId: null, busTermId: eachComponent.pkBusStopTermId });
          }
        });
      }

      if (components.length > 0) {
        $('#addDiscountbutton').attr('disabled', true);
        this.feeService.addDiscount(components, addDiscount.discountAmountType, addDiscount.discountName, addDiscount.discountReason,
          addDiscount.discountAmount, addDiscount.feeStructuresId, localStorage.getItem('usertoken'),
          this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              $('#addDiscountbutton').attr('disabled', false);
              if (data.status === true) {
                const discountIsAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('discountIsAddedSuccessfully')); 
                customToastr(discountIsAddedSuccessfullyTranslation, 'success');
                // ............
                $('#popupAddDiscount').trigger('click');
                $('#addDiscountbutton').attr('disabled', false);
                this.discountDetails();

              } else if (data.message) {
                customToastr(data.message, 'error');
              } else {
                const discountIsNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('discountIsNotAddedPleaseTryAgain')); 
                customToastr(discountIsNotAddedPleaseTryAgainTranslation, 'error');
              }

            },
            async error => {
              $('#addDiscountbutton').attr('disabled', false);
              const discountIsNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('discountIsNotAddedPleaseTryAgain'));
               customToastr(discountIsNotAddedPleaseTryAgainTranslation, 'error');;
            }
          );
      } else {
       const pleaseSelectComponentsTermsToProceedTranslation = await firstValueFrom(this.translate.get('pleaseSelectComponentsTermsToProceed')); 
       customToastr(pleaseSelectComponentsTermsToProceedTranslation, 'error');
      }
    } else {
      const pleaseFillAllTheInfoTranslation = await firstValueFrom(this.translate.get('pleaseFillAllTheInfo')); 
      customToastr(pleaseFillAllTheInfoTranslation, 'error');
    }
  }

  openApplyDiscount(discount) {
    this.selectedDiscount = discount;
    this.isStudentActiveForDiscount = true;
    this.getSectionsListFromStudentsCategory(this.selectedDiscount.fkFeeStructuresId);
    if (this.selectedDiscount.fkFeeStructuresId) {
      $('#selectSectionId').val('all');
      this.searchStudentsForApplyDiscount();
    }
  }

  destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }

 initializeDataTable(table) {
  const h = this;
  const utilFun = {
    getText() {
      return 'headwise_fee';
    }
  };
  const buttonCommon = table === 'admin_collection_headwise-table' ? {
    exportOptions: {
      format: {
        body: function (data, row, column, node) {
          return column === 1 ? data.split(' ').join(',') : data;
        }
      }
    }
  } : {};

  setTimeout(() => {
    this.translate.get([
      'dataTables.buttons.copy',
      'dataTables.buttons.excel',
      'dataTables.buttons.csv',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.sEmptyTable',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [],
        dom: 'lfBrtip',
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          emptyTable: translations['dataTables.sEmptyTable'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        },
        buttons: [
          $.extend(true, {}, buttonCommon, {
            extend: 'copyHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.copy'],
          }),
          $.extend(true, {}, buttonCommon, {
            extend: 'excelHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.excel'],
          }),
          $.extend(true, {}, {
            extend: 'csvHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.csv'],
          })
        ]
      });
    });
    // this.scriptInit();
  }, 500);
}


 _initializeDataTable(table) {
  setTimeout(() => {
    this.translate.get([
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.sEmptyTable',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        aaSorting: [],
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          emptyTable: translations['dataTables.sEmptyTable'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
  }, 500);
}


initializeDataTable_withLowPageLength(table, length) {
  setTimeout(() => {
    this.translate.get([
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.sEmptyTable',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [[0, 'asc']],
        pageLength: length,
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          emptyTable: translations['dataTables.sEmptyTable'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
  }, 500);
}


  initializeDataTableWithoutSort(table) {
    const h = this;
    const utilFun = {
      getText() {
        return '' + h.selectedClass.classNumber + '-' + h.selectedClass.classDivision + ' Class fee details';
      }
    };
    const buttonCommon = {
      exportOptions: {
        format: {
          body(data, row, column, node) {
            //  Strip $ from salary column to make it numeric
            const n = $(node);
            if (n.hasClass('data-to-export')) {
              return n.text();
            }

            return n.find('.data-to-export').text();
          }
        },
        columns: ':not(.notexport)'
      }
    };
    setTimeout(() => {
      this.translate.get([
          'dataTables.buttons.copy',  
          'dataTables.buttons.excel',  
          'dataTables.buttons.csv',         
        ]).subscribe(translations => {
      $('#' + table).DataTable({
        order: [[0, 'asc']],
        bSort: false,
        dom: 'lfBrtip',
          language: {
    lengthMenu: this.translate.instant('dataTables.lengthMenu'),
     search: this.translate.instant('dataTables.search'),
      info: this.translate.instant('dataTables.info'),
  paginate: {
    previous: this.translate.instant('dataTables.paginate.previous'),
    next: this.translate.instant('dataTables.paginate.next')
  },
  zeroRecords: this.translate.instant('dataTables.zeroRecords')
  },
        buttons: [
          $.extend(true, {}, buttonCommon, {
            extend: 'copyHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.copy']
          }),
          $.extend(true, {}, buttonCommon, {
            extend: 'excelHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.excel']
          }),
          $.extend(true, {}, buttonCommon, {
            extend: 'csvHtml5',
            title: utilFun.getText(),
            text: translations['dataTables.buttons.csv']
          })
        ]
      });
    });
    }, 500);
  }

  openDeleteDiscount(discount) {
    this.selectedDiscount = discount;
  }

  delete_discount() {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#delete_discount_proceed').text(translatedText); });
    $('#delete_discount_proceed').attr('disabled', true);
    this.feeService.deleteDiscount(this.selectedDiscount.pkSchoolDiscountId, localStorage.getItem('usertoken'),
      this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {
          this.translate.get('DELETE').subscribe((translatedText: string) => { $('#delete_discount_proceed').text(translatedText); });
          $('#delete_discount_proceed').attr('disabled', false);
          if (data.status) {
            const discountSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('discountSuccessfullyDeleted')); 
            customToastr(discountSuccessfullyDeletedTranslation, 'success');
            $('#delete_discount_close').trigger('click');
            this.discountDetails();
          } else {
           const failedToDeleteDiscountPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteDiscountPleaseTryAgain')); 
           customToastr(failedToDeleteDiscountPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          this.translate.get('DELETE').subscribe((translatedText: string) => { $('#delete_discount_proceed').text(translatedText); });
          $('#delete_discount_proceed').attr('disabled', false);
          const failedToDeleteDiscountPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteDiscountPleaseTryAgain')); 
          customToastr(failedToDeleteDiscountPleaseTryAgainTranslation, 'error');
        }
      );
  }

  appliedStudentDiscount(discountId, discount) {
    this.appliedDiscountStudentList = [];
    this.selectedDiscount = discount;

    this.selectDeleteAppliedDiscountAllVal = false;
    this.destroyDataTable('appliedStudentList');
    this.feeService.fetchAppliedDiscountStudent(discountId, localStorage.getItem('usertoken'), this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.appliedDiscountStudentList = data;
          this.initializeDataTable_withLowPageLength('appliedStudentList', 7);
        },
        error => {

        }
      );
  }

  appliedDiscountComponentList = [];
  appliedDiscountStudentDetails: any = {};
  appliedDiscountStudentDate = "";
  appliedStudentDiscountConsessionForm(student) {

    this.appliedDiscountComponentList = [];
    this.appliedDiscountStudentDetails = {};
    this.feeService.fetchAppliedDiscountForStudent(this.selectedDiscount.pkSchoolDiscountId, student.studentId, localStorage.getItem('usertoken'), this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {

          this.appliedDiscountComponentList = data.discountApplied;
          this.appliedDiscountStudentDetails = data.student;
          this.appliedDiscountStudentDate = moment_js(this.appliedDiscountComponentList[0].CreatedDate).format("DD/MM/YYYY")
        },
        error => {
          console.error(error);
        }
      );
  }

  calculateTotalDiscountInApplied() {
    let amount = 0;
    this.appliedDiscountComponentList.forEach((d) => {
      amount = amount + d.DiscountAmount;
    })
    return amount;
  }

  classSection() {
    const id = $('#classStand').val();
    if (id !== '') {
      $('#viewStudent').removeClass('disabled');
      this.getClassSections(id);
    } else {
      $('#viewStudent').addClass('disabled');
    }
  }

  searchStudentsForApplyDiscount() {
    const selectSection = $('#selectSectionId').val();
    this.sectionId = selectSection;
    if (selectSection !== '0') {
      if (this.selectedDiscount.pkStudentsCategoryId) {
        this.studentListforDiscount(selectSection, this.selectedDiscount.pkStudentsCategoryId, true);
      } else if (selectSection !== 'all') {
        this.studentListforDiscount(selectSection, null, false);
      }
    }
  }

  studentListforDiscount(classId, studentsCategoryId, isWithStructure) {
    this.selectedclassId = classId;
    this.discountStudentList = [];
    if (classId === 'all') {
      this.selectedclassId = null;
      classId = null;
    }
    const h = this;
    this.destroyDataTable('searchStudentApplyDiscountTable');
    if (isWithStructure) {
      this.getStudentCategoriesFeeStructureStudentListDiscountApi(studentsCategoryId, classId, h)
    } else {
      this.getStudentListDiscountApi(classId, h)
    }
  }

  async getStudentCategoriesFeeStructureStudentListDiscountApi(studentsCategoryId, classId, h) {
    try {
      const body = {
        studentCategoryId: studentsCategoryId,
        classId: classId,
        academicId: this.academicInfo.current_academic,
        isStudentActive: this.isStudentActiveForDiscount,
        fkSchoolDiscountId: this.selectedDiscount.pkSchoolDiscountId,
        lang: "en"
      };
      this.discountLoader = true;
      const response = await firstValueFrom(this.feeService.getStudentCategoriesFeeStructureStudentListDiscount(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          this.discountStudentList = responseDetails.body;
          setTimeout(() => {
            h.initializeDataTable('searchStudentApplyDiscountTable');
          }, 100);
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.discountLoader = false;
    } catch (error) {
      this.discountStudentList = []
      this.discountLoader = false;
    }
  }
  async getStudentListDiscountApi(classId, h) {
    try {
      const body = {
        classId: classId,
        academicId: this.academicInfo.current_academic,
        isStudentActive: this.isStudentActiveForDiscount,
        fkSchoolDiscountId: this.selectedDiscount.pkSchoolDiscountId,
        lang: "en"
      }
      this.discountLoader = true;
      const response = await firstValueFrom(this.feeService.getStudentListDiscount(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          this.discountStudentList = responseDetails.body;;
          setTimeout(() => {
            h.initializeDataTable('searchStudentApplyDiscountTable');
          }, 100);
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.discountLoader = false;
    } catch (error) {
      this.discountStudentList = []
      this.discountLoader = false;
    }
  }


  selectAll() {
    const isSel = $('#selectAll').prop('checked');
    this.discountStudentList.forEach(st => {
      st.select = isSel;
    });
    this.selectedStudent = 'select';
  }

  async applyDiscountToStudent() {
    const h = this;
    this.destroyDataTable('applyDiscountStatusTable');
    $('#applydiscountbutton').attr('disabled', true);
    const studentIdList = [];
    if (this.discountStudentList && this.discountStudentList.length > 0) {
      for (const item of this.discountStudentList) {
        if (item.select === true) {
          studentIdList.push(item);
        }
      }
    }
    if (studentIdList.length > 0) {
      this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
      if (new Date(this.selectedDiscount.createdOn) >= new Date('2017-07-25')) {
        this.feeService.applyDiscountv2(studentIdList, this.selectedDiscount.pkSchoolDiscountId,
          localStorage.getItem('usertoken'), this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              if (data.status === true) {
                $('#applydiscountbutton').attr('disabled', false);
                this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
                $('#closeApplyDiscountpopup').trigger('click');
                this.applyDiscountStatus = data.statuses;
                setTimeout(() => {
                  $('#applyDiscountStatus_open').trigger('click');
                  h.initializeDataTable_withLowPageLength('applyDiscountStatusTable', 5);
                }, 20);
              } else {
                $('#applydiscountbutton').attr('disabled', false);
                this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
               const discountIsNotAppliedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('discountIsNotAppliedPleaseTryAgain')); 
               customToastr(discountIsNotAppliedPleaseTryAgainTranslation, 'error');
              }
              this.discountDetails()
            },
            error => {
              $('#applydiscountbutton').attr('disabled', false);
              this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
            }
          );
      } else {
        this.feeService.applyDiscount(studentIdList, this.selectedDiscount.pkSchoolDiscountId,
          this.sectionId, localStorage.getItem('usertoken'), this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              if (data.status === true) {
                $('#applydiscountbutton').attr('disabled', false);
                this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
                $('#closeApplyDiscountpopup').trigger('click');
                this.applyDiscountStatus = data.statuses;
                setTimeout(() => {
                  $('#applyDiscountStatus_open').trigger('click');
                  h.initializeDataTable_withLowPageLength('applyDiscountStatusTable', 5);
                }, 20);
              } else {
                $('#applydiscountbutton').attr('disabled', false);
                this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
                const discountIsNotAppliedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('discountIsNotAppliedPleaseTryAgain')); 
                customToastr(discountIsNotAppliedPleaseTryAgainTranslation, 'error');
              }
            },
            error => {
              $('#applydiscountbutton').attr('disabled', false);
              this.translate.get('apply').subscribe((translatedText: string) => { $('#applydiscountbutton').text(translatedText); });
            }
          );
      }

    } else {
      $('#applydiscountbutton').attr('disabled', false);
      const pleaseSelectStudentsToApplyDiscountTranslation = await firstValueFrom(this.translate.get('pleaseSelectStudentsToApplyDiscount')); 
      customToastr(pleaseSelectStudentsToApplyDiscountTranslation, 'error');
    }
  }

  selectDeleteAppliedDiscountAll(isSelected) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.appliedDiscountStudentList.length; i++) {
      this.appliedDiscountStudentList[i].select = isSelected;
    }
  }

  addDiscountpopup() {
    this.getStudentCategoryListFeeStructure();
    this.addDiscount.discountName = null;
    this.addDiscount.discountAmount = null;
    this.addDiscount.discountReason = null;
    this.allFeeNames = { typeList: [], termList: [], busTermList: [] };
    this.getTermTypeBusTerms();
    this.termlist = [];
    this.typelist = [];
    $('#term').prop('checked', false);
    $('#type').prop('checked', false);
  }

  selectAllTermsInComponent(comp, selected) {
    comp.terms.forEach(ter => {
      ter.selected = selected;
    });
  }

  getStudentCategoryListFeeStructure() {
    this.feeService.getFeeStructureList_select(localStorage.getItem('usertoken'), this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data && data.length) {
            this.feeStructureListForSelect = data;
          } else {
            this.feeStructureListForSelect = [];
          }
        },
        error => {
          this.feeStructureListForSelect = [];
        }
      );
  }

  /* Fees settings related */

  openFeesSettingsTab() {
    this.getFeesSettings();
    this.fetchPaymentGateways()
    this.getSupportedCurrency()
  }

  openPopup(gateway: any): void {
    this.selectedGateway = gateway;
    this.showPopup = true;
  }

  closePopup() {
    const modalElement = this.requestConfirmModal.nativeElement;
    if (modalElement) {
      $(modalElement).modal('hide');
    }
  }

  sendRequest(gateway: any): void {
    this.gatewaySendRequestApi(gateway.pkPaymentGatewayId);
  }

  async fetchPaymentGateways() {
    try {
      this.paymentLoader = true;
      const response = await firstValueFrom(this.feeService.gatewayList());
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          this.paymentGateways = responseDetails.body;
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.paymentLoader = false;
    } catch (error) {
      if (error.error.status_code !== 417) {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
          this.strings.errorCode);
      }
      this.paymentLoader = false;
    }
  }

  async gatewaySendRequestApi(pkPaymentGatewayId: number) {
    try {
      this.gateWayRequestLoader = true;
      const body = {
        fkPaymentGatewayId: pkPaymentGatewayId,
        lang: 'en'
      }
      const response = await firstValueFrom(this.feeService.gatewaySendRequest(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          customToastr(responseDetails.body.message, this.strings.successCode);
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.closePopup();
      this.gateWayRequestLoader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslation
        : errorMessageTranslation,
        this.strings.errorCode);
      this.closePopup();
      this.gateWayRequestLoader = false;
    }
  }

  async updatePaymentGatewayStatusApi(pkPaymentGatewayId: number, isActive: boolean) {
    try {
      this.loader = true;
      const body = {
        fkPaymentGatewayId: pkPaymentGatewayId,
        isActive: isActive,
        lang: 'en'
      }
      const response = await firstValueFrom(this.feeService.updatePaymentGatewayStatus(body));
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          customToastr(responseDetails.body.message, this.strings.successCode);
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslation
        : errorMessageTranslation,
        this.strings.errorCode);
      this.loader = false;
    }
  }

  async getSupportedCurrency(){
    try {
      this.loader = true;
      const body = {
        academicId: this.academicInfo.current_academic,
        lang: 'en'
      }
      const response = await firstValueFrom(this.feeService.getSupportedCurrencyListAPI(body));
      const responseDetails = response as any;
      if(responseDetails.status){
        if(responseDetails.body){
          this.supportedCurrencyList = responseDetails.body
        }
      }else {
        this.supportedCurrencyList = []
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.loader = false
    } catch (error) {
      this.supportedCurrencyList = [];
      if(error.error.status_code !== 412){
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
          this.strings.errorCode);
        this.loader = false;
      }
   
    }
  }

  onCheckboxChange(gateway: any): void {
    gateway.loader = true;
    gateway.isActive = gateway.isActive === 1 ? 0 : 1;
    this.updatePaymentGatewayStatusApi(gateway.pkPaymentGatewayId, gateway.isActive).then(() => {
      gateway.loader = false;
    }).catch(() => {
      gateway.loader = false;
    });
  }

  handleSupportedCurrencyChange(selectedCurrency: any): void {
    selectedCurrency.loader = true;
    this.supportedCurrencyList.forEach(currency => {
      currency.isCurrentCurrency = (currency === selectedCurrency) ? 1 : 0;
    })  
    this.updateSupportedCurrency(selectedCurrency)
  }

  async updateSupportedCurrency(selectedCurrency){
    try {
      const body = {
        lang : 'en',
        pkSupportedCurrencyId : selectedCurrency.pkSupportedCurrencyId,
        academicId : this.academicInfo.current_academic
      }
      const response = await firstValueFrom(this.feeService.updateSupportedCurrencyAPI(body));
      const responseDetails = response as any;
      if(responseDetails.status){
        if(responseDetails.body){
          customToastr(responseDetails.body.message, this.strings.successCode)
          localStorage.setItem(this.strings.currency, selectedCurrency.currencyType);
        }
      }else{
        customToastr(responseDetails.message, this.strings.successCode)
      }
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslation
        : errorMessageTranslation,
        this.strings.errorCode);
      this.loader = false;
    }
  }

  getFeesSettings() {
    this.feeService.getFeeModuleSettings(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.feesSettingsInfo = data.feesSettings;
          this.instamojoUser = data.instamojoUser;
          let isFeesModuleEnable = false;
          let isOnlinePaymentEnabled = false;
          for (const item of this.feesSettingsInfo) {
            if (item.isFeesModuleEnable === 'ENABLED' &&
              item.SettingName === 'MOBILE_FEES_MODULE') {
              isFeesModuleEnable = true;
              this.isGatewayEnable = true;
              $('#mobileFeesModule_enable').addClass('active');
              $('#mobileFeesModule_enable').removeClass('not_active');
              $('#mobileFeesModule_disable').addClass('not_active');
              $('#mobileFeesModule_disable').removeClass('active');
            } else if (item.isFeesModuleEnable === 'DISABLED' &&
              item.SettingName === 'MOBILE_FEES_MODULE') {
              this.isGatewayEnable = false;
              $('#mobileFeesModule_enable').removeClass('active');
              $('#mobileFeesModule_enable').addClass('not_active');
              $('#mobileFeesModule_disable').addClass('active');
              $('#mobileFeesModule_disable').removeClass('not_active');
            }

            if (item.isFeesModuleEnable === 'ENABLED' &&
              item.SettingName === 'MOBILE_FEES_PAYMENT') {
              $('#mobileFeesPayment_enable').addClass('active');
              $('#mobileFeesPayment_enable').removeClass('not_active');
              $('#mobileFeesPayment_disable').addClass('not_active');
              $('#mobileFeesPayment_disable').removeClass('active');
              isOnlinePaymentEnabled = true;
            } else if (item.isFeesModuleEnable === 'DISABLED' &&
              item.SettingName === 'MOBILE_FEES_PAYMENT') {
              $('#mobileFeesPayment_enable').removeClass('active');
              $('#mobileFeesPayment_enable').addClass('not_active');
              $('#mobileFeesPayment_disable').addClass('active');
              $('#mobileFeesPayment_disable').removeClass('not_active');
            }

            if (item.isFeesModuleEnable === 'ENABLED' &&
              item.SettingName === 'ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE') {
              $('#onlinePaymentIndependentTo_enable').addClass('active');
              $('#onlinePaymentIndependentTo_enable').removeClass('not_active');
              $('#onlinePaymentIndependentTo_disable').addClass('not_active');
              $('#onlinePaymentIndependentTo_disable').removeClass('active');
              isFeesModuleEnable = true;
            } else if (item.isFeesModuleEnable === 'DISABLED' &&
              item.SettingName === 'ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE') {
              $('#onlinePaymentIndependentTo_enable').removeClass('active');
              $('#onlinePaymentIndependentTo_enable').addClass('not_active');
              $('#onlinePaymentIndependentTo_disable').addClass('active');
              $('#onlinePaymentIndependentTo_disable').removeClass('not_active');
            }

            if (item.isFeesModuleEnable === 'ENABLED' &&
              item.SettingName === 'SHOW_TERM_FEE_BREAKUP') {
              $('#term_fee_breakup_enable').addClass('active');
              $('#term_fee_breakup_enable').removeClass('not_active');
              $('#term_fee_breakup_disable').addClass('not_active');
              $('#term_fee_breakup_disable').removeClass('active');
              isOnlinePaymentEnabled = true;
            } else {
              $('#term_fee_breakup_enable').removeClass('active');
              $('#term_fee_breakup_enable').addClass('not_active');
              $('#term_fee_breakup_disable').addClass('active');
              $('#term_fee_breakup_disable').removeClass('not_active');
            }
          }
          if (isFeesModuleEnable) {
            $('#mobileFeesPaymentdiv').css({ display: 'block' });
            if (isOnlinePaymentEnabled) {
              $('#class_online_paymentdiv, #online_payment_setting_tabs').css({ display: 'block' });
            } else {
              $('#class_online_paymentdiv, #online_payment_setting_tabs').css({ display: 'none' });
            }
          } else {
            $('#class_online_paymentdiv, #mobileFeesPaymentdiv, #online_payment_setting_tabs').css({ display: 'none' });
          }
        },
        error => {
        }
      );
  }

  getInstamojoAcc() {
    this.feeService.getInstamojoUserAccount()
      .subscribe(
        (data: any) => {
          this.instamojoUser = data;
          this.merchantAcccSts = 'SHOW_ACCOUNT';
        },
        error => {
        }
      );
  }

  async changeSetting(settingName, value) {
    if (this.formValidator.validateIsData(settingName)) {
      this.feeService.updateFeeModuleSettings(value, settingName,this.academicInfo.current_academic)
        .subscribe(
         async (data: any) => {
            const settingUpdatedTranslation = await firstValueFrom(this.translate.get('settingUpdated')); 
            customToastr(settingUpdatedTranslation, 'success');
            this.getFeesSettings();
          },
          error => {
          }
        );
    } else {
      const updateSettingFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('updateSettingFailedPleaseTryAgain')); 
      customToastr(updateSettingFailedPleaseTryAgainTranslation, 'error');
    }
  }

  getClassFeesSettings() {
    this.feeService.getClassListWithOnlinePaymentSettings(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.classFeesSettings = [];
          // this.classFeesSettings = data;
          const h = this;
          data.forEach(it => {
            it.selected = it.IsEnabled === 'ENABLED';
            h.classFeesSettings.push(it);
          });
        },
        error => {

        }
      );
  }

  async updateClassFeeSettings() {
    const reqData = [];
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#add-class-setting-online-save').text(translatedText); });
    $('#add-class-setting-online-cancel, #add-class-setting-online-save').attr('disabled', true);
    const updatedList = JSON.parse(JSON.stringify(this.classFeesSettings));
    if (updatedList.length > 0) {
      updatedList.forEach(it => {
        if (it.selected) {
          reqData.push({ isEnabled: 'ENABLED', classId: it.classId, settingId: it.pkClassOnlinePaymentSettingId ,academicId : this.academicInfo.current_academic});
        } else {
          reqData.push({ isEnabled: 'DISABLED', classId: it.classId, settingId: it.pkClassOnlinePaymentSettingId ,});
        }
      });

      this.feeService.addOrRemoveClassOnlinePaySettings(reqData)
        .subscribe(
          async (data: any) => {
            this.translate.get('save').subscribe((translatedText: string) => { $('#add-class-setting-online-save').text(translatedText); });
            $('#add-class-setting-online-cancel, #add-class-setting-online-save').attr('disabled', false);
            if (data.status) {
              const classFeeSettingsUpdatedTranslation = await firstValueFrom(this.translate.get('classFeeSettingsUpdated')); 
              customToastr(classFeeSettingsUpdatedTranslation, 'success');
              $('#add-class-setting-online-cancel').trigger('click');
            } else {
              const updateClassFeeSettingFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('updateClassFeeSettingFailedPleaseTryAgain')); 
              customToastr(updateClassFeeSettingFailedPleaseTryAgainTranslation, 'error');
            }
          },
          error => {
            this.translate.get('save').subscribe((translatedText: string) => { $('#add-class-setting-online-save').text(translatedText); });
            $('#add-class-setting-online-cancel, #add-class-setting-online-save').attr('disabled', false);
          }
        );
    } else {
      this.translate.get('save').subscribe((translatedText: string) => { $('#add-class-setting-online-save').text(translatedText); });
      $('#add-class-setting-online-cancel, #add-class-setting-online-save').attr('disabled', false);
     const looksLikeThereAreNoClassesAvailableTranslation = await firstValueFrom(this.translate.get('looksLikeThereAreNoClassesAvailable')); 
     customToastr(looksLikeThereAreNoClassesAvailableTranslation, 'error');
    }
  }

  async createInstamojoMerchantAccount(username, email, phone, password, confirmPassword) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#create-merchant-button').text(translatedText); });
    $('#create-merchant-button').attr('disabled', true);
    if (this.formValidator.validateIsData(username) &&
      this.formValidator.validateIsEmail(email)
      && this.formValidator.validateIsData(phone) &&
      this.formValidator.validateIsData(password)) {
      if (password !== confirmPassword) {
        this.translate.get('createAnAccount').subscribe((translatedText: string) => { $('#create-merchant-button').text(translatedText); });
        $('#create-merchant-button').attr('disabled', false);
       const passwordAndConfirmPasswordAreMismatchTranslation = await firstValueFrom(this.translate.get('passwordAndConfirmPasswordAreMismatch')); 
       customToastr(passwordAndConfirmPasswordAreMismatchTranslation, 'error');
        return;
      }
      this.feeService.createInstamojoAccount(username, email, phone, password)
        .subscribe(
          async (data: any) => {
            this.translate.get('createAnAccount').subscribe((translatedText: string) => { $('#create-merchant-button').text(translatedText); });
            $('#create-merchant-button').attr('disabled', false);
            if (data === true) {
             const merchantAccountSuccessfullyCreatedTranslation = await firstValueFrom(this.translate.get('merchantAccountSuccessfullyCreated')); 
             customToastr(merchantAccountSuccessfullyCreatedTranslation, 'success');
              this.createMerchant = { username: '', email: '', phone: '', password: '', confirmPassword: '' };
              this.merchantAcccSts = 'SHOW_ACCOUNT';
              this.getInstamojoAcc();
            } else {
              if (data.message) {
                customToastr(data.message, 'error');
              } else {
                for (const key in data) {
                  if (data[key] && data[key].length > 0) {
                    // tslint:disable-next-line:prefer-for-of
                    for (let i = 0; i < data[key].length; i++) {
                      customToastr(data[key][i], 'error');
                    }
                  }
                }
              }
            }
          },
          error => {
            this.translate.get('createAnAccount').subscribe((translatedText: string) => { $('#create-merchant-button').text(translatedText); });
            $('#create-merchant-button').attr('disabled', false);
          }
        );
    } else {
      this.translate.get('createAnAccount').subscribe((translatedText: string) => { $('#create-merchant-button').text(translatedText); });
      $('#create-merchant-button').attr('disabled', false);
      const pleaseProvideAllValidDetailsToCreateMerchantAccountTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllValidDetailsToCreateMerchantAccount')); 
      customToastr(pleaseProvideAllValidDetailsToCreateMerchantAccountTranslation, 'error');
    }
  }

  async logIntoMerchantAccount(username, password) {
    $('#instamojoSignIn').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#instamojoSignIn').text(translatedText); });
    this.bankDetailsUpdate = { bankHolderName: '', accountNumber: '', iFSCCode: '', userId: '' };
    if (this.formValidator.validateIsData(username) && this.formValidator.validateIsData(password)) {
      this.feeService.loginInstamojoAccount(username, password)
        .subscribe(
          async (data: any) => {
            $('#instamojoSignIn').attr('disabled', false);
            this.translate.get('SIGN_IN').subscribe((translatedText: string) => { $('#instamojoSignIn').text(translatedText); });
            if (data.error) {
              const loginFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('loginFailedPleaseTryAgain')); 
              customToastr(loginFailedPleaseTryAgainTranslation, 'error');
            } else {
              const loginSuccessPleaseProvideBankAccountDetailsTranslation = await firstValueFrom(this.translate.get('loginSuccessPleaseProvideBankAccountDetails')); 
              customToastr(loginSuccessPleaseProvideBankAccountDetailsTranslation, 'success');
              this.merchantAcccSts = 'BANK_INFO';
            }
          },
          error => {
            $('#instamojoSignIn').attr('disabled', false);
            this.translate.get('SIGN_IN').subscribe((translatedText: string) => { $('#instamojoSignIn').text(translatedText); });
          }
        );
    } else {
      $('#instamojoSignIn').attr('disabled', false);
      this.translate.get('SIGN_IN').subscribe((translatedText: string) => { $('#instamojoSignIn').text(translatedText); });
      const missingUsernameOrPasswordTranslation = await firstValueFrom(this.translate.get('missingUsernameOrPassword')); 
      customToastr(missingUsernameOrPasswordTranslation, 'error');
    }
  }

  async updateBankDetails(bankHolderName, accountNumber, iFSCCode, userId) {
    userId = this.instamojoUser.userId;
    $('#saveBnakInfo').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#saveBnakInfo').text(translatedText); });

    if (this.formValidator.validateIsData(bankHolderName) && this.formValidator.validateIsData(accountNumber) &&
      this.formValidator.validateIsData(iFSCCode)) {
      this.feeService.addInstamojoBankAccount(bankHolderName, accountNumber, iFSCCode, userId)
        .subscribe(
          async (data: any) => {
            $('#saveBnakInfo').attr('disabled', false);
            this.translate.get('saveInformation').subscribe((translatedText: string) => { $('#saveBnakInfo').text(translatedText); });
            if (data.message === "Request failed with status code 400" || data.error) {
              const bankDetailsAreNotUpdatedPleaseEnterValidDetailsTranslation = await firstValueFrom(this.translate.get('bankDetailsAreNotUpdatedPleaseEnterValidDetails')); 
              customToastr(bankDetailsAreNotUpdatedPleaseEnterValidDetailsTranslation, 'error');
            }
            else {
              const bankDetailsAreSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('bankDetailsAreSuccessfullyUpdated')); 
              customToastr(bankDetailsAreSuccessfullyUpdatedTranslation, 'success');
              this.getInstamojoAcc();
            }
          },
          error => {
            $('#saveBnakInfo').attr('disabled', false);
            this.translate.get('saveInformation').subscribe((translatedText: string) => { $('#saveBnakInfo').text(translatedText); });
          }
        );
    } else {
      $('#saveBnakInfo').attr('disabled', false);
      this.translate.get('saveInformation').subscribe((translatedText: string) => { $('#saveBnakInfo').text(translatedText); });
      const pleaseProvideBankDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideBankDetails'));
       customToastr(pleaseProvideBankDetailsTranslation, 'error');
    }
  }

  getPaymentPurposes() {
    this.createPurpose = '';
    this.feeService.getOnlinePaymentPurposes()
      .subscribe(
        (data: any) => {
          if (data.length > 0) {
            this.onlinePaymentPurposes = data;

          } else {
            this.onlinePaymentPurposes = [];
          }
        },
        error => {

        }
      );
  }

  async addOnlinePaymentPurpose(purpose) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#createPurpose').text(translatedText); });
    $('#createPurpose').attr('disabled', true);
    if (this.formValidator.validateIsData(purpose)) {
      this.feeService.addOnlinePaymentPurpose(purpose)
        .subscribe(
          async (data: any) => {
            this.translate.get('savePurpose').subscribe((translatedText: string) => { $('#createPurpose').text(translatedText); });
            $('#createPurpose').attr('disabled', false);
            if (data.status) {
              const paymentPurposeSuccessfullyAddedTranslation = await firstValueFrom(this.translate.get('paymentPurposeSuccessfullyAdded')); 
              customToastr(paymentPurposeSuccessfullyAddedTranslation, 'success');
              this.getPaymentPurposes();
            } else {
              const paymentPurposeNotAddedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('paymentPurposeNotAddedPleaseTryAgain')); 
              customToastr(paymentPurposeNotAddedPleaseTryAgainTranslation, 'error');
            }
          },
          error => {
            this.translate.get('savePurpose').subscribe((translatedText: string) => { $('#createPurpose').text(translatedText); });
            $('#createPurpose').attr('disabled', false);
          }
        );
    } else {
      this.translate.get('savePurpose').subscribe((translatedText: string) => { $('#createPurpose').text(translatedText); });
      $('#createPurpose').attr('disabled', false);
      const pleaseProvidePaymentPurposeTranslation = await firstValueFrom(this.translate.get('pleaseProvidePaymentPurpose')); 
      customToastr(pleaseProvidePaymentPurposeTranslation, 'error');
    }
  }

  deletePurpose_openPopup(p) {
    this.deletePurposeInfo = p;
  }

  deleteOnlinePaymentPurpose() {
    const purposeId = this.deletePurposeInfo.pkOnlinePayPurposeId;
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#savemovepurposepopup').text(translatedText); });
    $('#savemovepurposepopup, #closeremovepurposepopup').attr('disabled', true);
    this.feeService.deleteOnlinePaymentPurpose(purposeId)
      .subscribe(
        async (data: any) => {
          $('#savemovepurposepopup, #closeremovepurposepopup').attr('disabled', false);
          this.translate.get('DELETE').subscribe((translatedText: string) => { $('#savemovepurposepopup').text(translatedText); });
          if (data.status) {
            $('#closeremovepurposepopup').trigger('click');
            const paymentPurposeSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('paymentPurposeSuccessfullyDeleted')); 
            customToastr(paymentPurposeSuccessfullyDeletedTranslation, 'success');
            this.getPaymentPurposes();
          } else {
            const paymentPurposeNotDeletedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('paymentPurposeNotDeletedPleaseTryAgain')); 
            customToastr(paymentPurposeNotDeletedPleaseTryAgainTranslation, 'error');
          }
        },
        error => {
          $('#savemovepurposepopup, #closeremovepurposepopup').attr('disabled', false);
          this.translate.get('DELETE').subscribe((translatedText: string) => { $('#savemovepurposepopup').text(translatedText); });
        }
      );
  }

  getPaymentLimits() {
    this.feeService.getSchoolOnlineFeePaymentLimits()
      .subscribe(
        (data: any) => {

          if (data.status) {
            this.paymentLimits = data;
          } else {
          }
        },
        error => {

        }
      );
  }

  async updatePaymentLimits(minimum, maximum) {
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#save_payment_limits').text(translatedText); });
    $('#save_payment_limits').attr('disabled', true);
    if ($.isNumeric(minimum) && $.isNumeric(maximum)) {
      const minimumAmount = parseInt(minimum, 10);
      const maximumAmount = parseInt(maximum, 10);
      this.feeService.updateSchoolOnlineFeePaymentLimits(minimumAmount, maximumAmount)
        .subscribe(
          async (data: any) => {
            this.translate.get('saveLimits').subscribe((translatedText: string) => { $('#save_payment_limits').text(translatedText); });
            $('#save_payment_limits').attr('disabled', false);
            if (data.status) {
              const onlinePaymentLimitUpdatedTranslation = await firstValueFrom(this.translate.get('onlinePaymentLimitUpdated')); 
              customToastr(onlinePaymentLimitUpdatedTranslation, 'success');
            } else {
              if (data.message) {
                customToastr(data.message, 'error');
              } else {
               const failedToUpdateOnlinePaymentLimitsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateOnlinePaymentLimitsPleaseTryAgain')); 
               customToastr(failedToUpdateOnlinePaymentLimitsPleaseTryAgainTranslation, 'error');
              }
            }
          },
          error => {
            this.translate.get('saveLimits').subscribe((translatedText: string) => { $('#save_payment_limits').text(translatedText); });
            $('#save_payment_limits').attr('disabled', false);
          }
        );
    } else {
      const pleaseProvideAValidAmountTranslation = await firstValueFrom(this.translate.get('pleaseProvideAValidAmount')); 
      customToastr(pleaseProvideAValidAmountTranslation, 'error');
      this.translate.get('saveLimits').subscribe((translatedText: string) => { $('#save_payment_limits').text(translatedText); });
      $('#save_payment_limits').attr('disabled', false);
    }
  }

  /*  Student category related */

  openCreateStudentCategory() {
    this.addNewStudentCategory = JSON.parse(JSON.stringify(this.newAddNewStudentCategory));
  }

  getStudentCategoryList(categoryId, forList) {
    this.getCatIdForFees = categoryId;
    this.studentCategoryList = [];
    this.destroyDataTable('student-category-list');
    this.feeService.getStudentCategoryList(forList, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.initializeDataTable('student-category-list');
          this.studentCategoryList = data;
          if (categoryId) {
            for (const item of this.studentCategoryList) {
              if (item.pkStudentsCategoryId === this.getCatIdForFees) {
                this.openAssignStudentsToStudentCategory(JSON.parse(JSON.stringify(item)));
              }
            }
          }
        },
        error => {
        }
      );
  }

  async checkDescriptionLength(data, key) {
    if (this.formValidator.validateIsData(data.description)) {
      const length = data.description.length;
      this[key].remainingDescriptionLength = 300 - length;
      if (this[key].remainingDescriptionLength <= 0) {
        this[key].remainingDescriptionLength = 0;
        const only300CharactersAllowedTranslation = await firstValueFrom(this.translate.get('only300CharactersAllowed')); 
        customToastr(only300CharactersAllowedTranslation, 'error');
        this[key].description = this[key].description.substr(0, length - 1);
        return;
      }
    } else {
      this[key].remainingDescriptionLength = 300;
    }
  }

  addStudentCategory(createDetails) {
    const validateaddStudentCategory = this.formValidator.validateFieldName(createDetails.name, "Student Category ")
    if (!validateaddStudentCategory) {
      if (!createDetails.studentCategoryId) {
        this.isProcessing = true;
        this.feeService.createStudentCategory(createDetails.name, createDetails.description, this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              this.isProcessing = false;
              if (data.status) {
                this.getStudentCategoryList(null, null);
                const newStudentCategoryAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newStudentCategoryAddedSuccessfully'));
                 customToastr(newStudentCategoryAddedSuccessfullyTranslation, 'success');
                $('#close-create-category').trigger('click');
              } else if (data.message === 'AlreadyExist') {
                const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                customToastr( '<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
              } else {
                const failedToCreateNewCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewCategoryPleaseTryAgain')); 
                customToastr(failedToCreateNewCategoryPleaseTryAgainTranslation, 'error');
              }
            },
            async error => {
              this.isProcessing = false;
              const failedToCreateNewCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewCategoryPleaseTryAgain')); 
              customToastr(failedToCreateNewCategoryPleaseTryAgainTranslation, 'error');
            }
          );
      } else {
        this.isProcessing = true;
        this.feeService.editStudentCategory(createDetails.name, createDetails.description, createDetails.studentCategoryId,
          this.academicInfo.current_academic)
          .subscribe(
           async (data: any) => {
              this.isProcessing = false;
              if (data.status) {
                const studentCategoryUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentCategoryUpdatedSuccessfully')); 
                customToastr(studentCategoryUpdatedSuccessfullyTranslation, 'success');
                $('#close-create-category').trigger('click');
                this.getStudentCategoryList(null, null);
              } else if (data.message === 'AlreadyExist') {
                const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                customToastr( '<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
              } else {
                const failedToCreateNewCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewCategoryPleaseTryAgain')); 
                customToastr(failedToCreateNewCategoryPleaseTryAgainTranslation, 'error');
              }
            },
            async error => {
              this.isProcessing = false;
              const failedToCreateNewCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewCategoryPleaseTryAgain')); 
              customToastr(failedToCreateNewCategoryPleaseTryAgainTranslation, 'error');
            }
          );
      }
    } else {
      customToastr(validateaddStudentCategory, 'error');
    }
  }

  getOtherFeeList() {
    this.otherFeeList = [];
    this.destroyDataTable('school-other-fee-list');
    this.feeService.getOtherFee(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.otherFeeList = data;
          this.initializeDataTable('school-other-fee-list');
        },
        error => {
          this.otherFeeList = [];
        }
      );
  }

 async addOtherFees(createDetails) {
    if (createDetails.amount && createDetails.amount <= 0) {
      const feeAmountShouldBeMoreThanZeroTranslation = await firstValueFrom(this.translate.get('feeAmountShouldBeMoreThanZero')); 
      customToastr(feeAmountShouldBeMoreThanZeroTranslation, 'error');
      return;
    }
    if (this.formValidator.validateIsData(createDetails.name)) {
      if (!createDetails.pkOtherFeesId) {
        this.isProcessing = true;
        this.feeService.createOtherFee(createDetails.name, createDetails.amount, this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              this.isProcessing = false;
              if (data.message === 'Success') {
                this.getOtherFeeList();
                const otherFeeAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('otherFeeAddedSuccessfully'));
                 customToastr(otherFeeAddedSuccessfullyTranslation, 'success');
                $('#close-add-otherfee').trigger('click');
              } else if (data.message === 'AlreadyExist') {
                const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                customToastr('<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
              } else {
                const failedToAddOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToAddOtherFeePleaseTryAgain')); 
                customToastr(failedToAddOtherFeePleaseTryAgainTranslation, 'error');
              }
            },
            async error => {
              this.isProcessing = false;
              const failedToAddOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToAddOtherFeePleaseTryAgain')); 
              customToastr(failedToAddOtherFeePleaseTryAgainTranslation, 'error');
            }
          );
      } else {

        if (createDetails.name === createDetails.oldName && createDetails.oldAmount === createDetails.amount) {
          const noChangesToUpdateTranslation = await firstValueFrom(this.translate.get('noChangesToUpdate')); 
          customToastr(noChangesToUpdateTranslation, 'warning');
        } else {
          this.isProcessing = true;
          this.feeService.editOtherFee(createDetails.name, createDetails.amount, createDetails.pkOtherFeesId, this.academicInfo.current_academic)
            .subscribe(
              async (data: any) => {
                this.isProcessing = false;
                if (data.message === 'Success') {
                  this.getOtherFeeList();
                  const otherFeeUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('otherFeeUpdatedSuccessfully')); 
                  customToastr(otherFeeUpdatedSuccessfullyTranslation, 'success');
                  $('#close-add-otherfee').trigger('click');
                } else if (data.message === 'AlreadyExist') {
                  const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                  customToastr( '<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
                } else {
                  const failedToUpdateOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateOtherFeePleaseTryAgain')); 
                  customToastr(failedToUpdateOtherFeePleaseTryAgainTranslation, 'error');
                }
              },
              async error => {
                this.isProcessing = false;
                const failedToUpdateOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateOtherFeePleaseTryAgain')); 
                customToastr(failedToUpdateOtherFeePleaseTryAgainTranslation, 'error');
              }
            );
        }
      }
    } else {
      const pleaseGiveAOtherFeeNameTranslation = await firstValueFrom(this.translate.get('pleaseGiveAOtherFeeName')); 
      customToastr(pleaseGiveAOtherFeeNameTranslation, 'error');
    }
  }

  initiateAddOtherFees() {
    this.addNewOtherFee = JSON.parse(JSON.stringify(this.newAddNewOtherFee));
  }

  initiateEditOtherFee(otherFee) {
    const clonedObj = JSON.parse(JSON.stringify(otherFee));
    this.addNewOtherFee = clonedObj;
    this.addNewOtherFee.name = clonedObj.Name;
    this.addNewOtherFee.oldName = clonedObj.Name;
    this.addNewOtherFee.oldAmount = clonedObj.amount;
  }

  openManageOtherFeeTerms(otherFee) {
    this.selectedOtherFee = otherFee;
    this.fetchOtherFeesTermsProgress = true;
    this.feeService.getOtherFeeTerms(this.selectedOtherFee.pkOtherFeesId)
      .subscribe(
        (data: any) => {
          this.fetchOtherFeesTermsProgress = false;
          if (data && data.length > 0) {
            this.otherFeeTermsList = data;
          } else {
            this.otherFeeTermsList = JSON.parse(JSON.stringify([this.newOtherFeeTerm]));
          }
        },
        async error => {
          this.fetchOtherFeesTermsProgress = false;
          const anErrorOccurredWhileFetchingTermsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('anErrorOccurredWhileFetchingTermsPleaseTryAgain')); 
          customToastr(anErrorOccurredWhileFetchingTermsPleaseTryAgainTranslation, 'error');
        }
      );

    this.applyDatePickerToOtherFeeTermDueDate();
  }

  initiateDeleteOtherFee(otherFee) {
    this.selectedOtherFee = otherFee;
  }

  deleteOtherFee() {
    this.isProcessing = true;
    this.feeService.deleteOtherFee(this.selectedOtherFee.pkOtherFeesId)
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status) {
            this.getOtherFeeList();
            const otherFeeDeletedSuccessfullyTranslation = await firstValueFrom(this.translate.get('otherFeeDeletedSuccessfully')); 
            customToastr(otherFeeDeletedSuccessfullyTranslation, 'success');
            $('body').find('#close-delete-other-fee-popup').trigger('click');
          } else {
            const failedToDeleteOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteOtherFeePleaseTryAgain')); 
            customToastr(failedToDeleteOtherFeePleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          this.isProcessing = false;
          const failedToDeleteOtherFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteOtherFeePleaseTryAgain')); 
          customToastr(failedToDeleteOtherFeePleaseTryAgainTranslation, 'error');
        }
      );
  }

  addAnotherTermToOtherFee() {
    this.otherFeeTermsList = this.otherFeeTermsList.concat(JSON.parse(JSON.stringify(this.newOtherFeeTerm)));
    this.applyDatePickerToOtherFeeTermDueDate();
  }

  applyDatePickerToOtherFeeTermDueDate() {
    setTimeout(() => {
      const dueDateDom = $('#otherFeeTermManagement').find('.otherFeeTermDueDate').datepicker({ autoclose: true });
    }, 5000);


    /*setTimeout(function(){
      let dueDateDom = $("#otherFeeTermManagement").find(".otherFeeTermDueDate");
      $(dueDateDom[dueDateDom.length - 1]).datepicker({autoclose:true});
    },100)*/
  }

  removeOtherFee(term, i) {
    if (term.pkOtherFeeTermId) {
      this.deletedOtherFeeTermsList.push(term);
    }
    this.otherFeeTermsList.splice(i, 1);
  }

  otherFeeTermChanged(i, field, term) {
    if (term.pkOtherFeeTermId) {
      this.otherFeeTermsList[i].isUpdated = true;
    }
  }

   async addOtherFeeTerm(otherFeeTermsList) {
    this.isProcessing = true;
    const translate  = await firstValueFrom(this.translate.get('feeCollectionData'));  
    const newOtherFeeTermsList = JSON.parse(JSON.stringify(otherFeeTermsList));
    let totalTermAmount = 0;
    const termsList = [];
    const formValidator = this.formValidator;
    newOtherFeeTermsList.forEach(async (item, index) => {
      let dDate = $('#termDueDate_' + index).val();
      if (
        !(formValidator.validateIsData(item.termName) &&
          formValidator.validateIsDataForNumber(item.termAmount) &&
          formValidator.validateIsData(dDate))
      ) {
        const fillAllTheDetailsToAddUpdateTermsTranslation = await firstValueFrom(this.translate.get('fillAllTheDetailsToAddUpdateTerms')); 
        customToastr(fillAllTheDetailsToAddUpdateTermsTranslation, 'error');
        return;
      }

      totalTermAmount += parseInt(item.termAmount, 10);


      dDate = dDate.split('/');
      dDate = dDate[2].trim() + '-' + dDate[1].trim() + '-' + dDate[0].trim();
      item.termDueDate = dDate;

      if (!item.pkOtherFeeTermId) {
        item.termStatus = 'NEW';
      } else if (item.isUpdated) {
        item.termStatus = 'UPDATE';
      }
      termsList.push(item);
    });
    if (this.deletedOtherFeeTermsList.length > 0) {
      this.deletedOtherFeeTermsList.forEach(d => {
        d.termStatus = 'DELETE';
        termsList.push(d);
      });
    }
    if (this.selectedOtherFee.amount === totalTermAmount) {
      this.feeService.manageOtherFeeTerms(termsList, this.selectedOtherFee.pkOtherFeesId)
        .subscribe(
          async (data: any) => {
            $('#otherFeeTermsManagePopupClose').trigger('click');
            const termsAreSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('termsAreSuccessfullyUpdated')); 
            customToastr(termsAreSuccessfullyUpdatedTranslation, 'success');
            this.isProcessing = false;
            this.getOtherFeeList();
          },
          async error => {
            const updatesWareFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('updatesWareFailedPleaseTryAgain')); 
            customToastr(updatesWareFailedPleaseTryAgainTranslation, 'error');
            this.isProcessing = false;
          }
        );
    } else {
      this.isProcessing = false;
      customToastr(translate.sumOfAll + (newOtherFeeTermsList.length) + translate.termShouldEqualTo +
        this.selectedOtherFee.amount, 'error');
    }
  }

  openAssignStudentsToOtherFee(otherFee) {
    this.destroyDataTable('search-student-list-for-otherfees');
    this.schoolClasses = [];
    this.selectedOtherFee = otherFee;
    this.searchStudentListForOtherSelectedCount = 0;
    this.otherFeeSearchStudentResults = [];
    this.studentsInOtherFee = [];
    this.initializeDataTable('search-student-list-for-otherfees');
    $('#add-students-to-otherfees').attr('otherFeeId', otherFee.pkOtherFeesId);
    this.feeService.getClassListOfSchool()
      .subscribe(
        (data: any) => {
          this.schoolClasses = data;
        },
        error => {
          this.schoolClasses = [];
        }
      );
  }

  async searchStudentForOtherfee() {
    this.searchStudentListForOtherSelectedCount = 0;
    let text = $('#groupbutton12-otherfees').val();
    let classId = $('#select-class-to-search-student-otherfees').val();
    text = text.trim();
    if (classId == 0) {
      classId = null;
    }

    if (!text || text === '') {
      text = null;
    }
    const h = this;
    if (text !== '') {
      this.destroyDataTable('search-student-list-for-otherfees');

      this.feeService.searchStudentToAssignOtherFee(classId, text, this.selectedOtherFee.pkOtherFeesId, this.academicInfo.current_academic)
        .subscribe(
          (data: any) => {
            this.otherFeeSearchStudentResults = data;
            this.initializeDataTable('search-student-list-for-otherfees');
          },
          error => {
            this.otherFeeSearchStudentResults = [];
          }
        );
    } else {
      const pleaseEnterStudentNameToSearchTranslation = await firstValueFrom(this.translate.get('pleaseEnterStudentNameToSearch')); 
      customToastr(pleaseEnterStudentNameToSearchTranslation, 'error');
    }
  }

  selectAllStudentOtherFeeSearchStudentResults(isChecked) {
    this.searchStudentListForOtherSelectedCount = 0;
    const h = this;
    this.otherFeeSearchStudentResults.forEach((data: any) => {

      if (data.paidFees > 0) {
        data.selected = false;
      } else {
        data.selected = isChecked;
      }
      h.searchStudentListForOtherSelectedCount = data.selected ?
        (h.searchStudentListForOtherSelectedCount + 1) : h.searchStudentListForOtherSelectedCount;
    });
  }

  checkOUncheckSelectStdOtherFee(s) {
    this.searchStudentListForOtherSelectedCount = s ?
      (this.searchStudentListForOtherSelectedCount + 1) : (this.searchStudentListForOtherSelectedCount - 1);
  }

  async assignStudentsToOtherFee() {
    const students = [];
    this.otherFeeSearchStudentResults.forEach((data: any) => {
      if (data.selected) {
        students.push(data);
      }
    });

    if (students.length > 0) {
      this.isProcessing = true;
      this.feeService.addStudentsToOtherFee(students, this.selectedOtherFee.pkOtherFeesId)
        .subscribe(
          async (data: any) => {
            this.isProcessing = false;
            if (data.status) {
              const studentsAreSuccessfullyAssignedTranslation = await firstValueFrom(this.translate.get('studentsAreSuccessfullyAssigned')); 
              customToastr(studentsAreSuccessfullyAssignedTranslation, 'success');
              this.selectedOtherFee.studentsCount = this.selectedOtherFee.studentsCount + students.length;
              this.searchStudentForOtherfee();
              this.getOtherFeeList();
            } else {
              const failedToAssignStudentsTranslation = await firstValueFrom(this.translate.get('failedToAssignStudents')); 
              customToastr(failedToAssignStudentsTranslation, 'error');
            }
          },
          async error => {
            this.isProcessing = false;
           const failedToAssignStudentsTranslation = await firstValueFrom(this.translate.get('failedToAssignStudents')); 
           customToastr(failedToAssignStudentsTranslation, 'error');
          }
        );
    } else {
      const youHaveNotSelectedAnyStudentsTranslation = await firstValueFrom(this.translate.get('youHaveNotSelectedAnyStudents')); 
      customToastr(youHaveNotSelectedAnyStudentsTranslation, 'error');
    }
  }

  getStudentsInOtherFee() {
    this.feeService.getStudentsInOtherFee(this.selectedOtherFee.pkOtherFeesId)
      .subscribe(
        (data: any) => {
          this.studentsInOtherFee = data;
        },
        async error => {
          this.studentsInOtherFee = [];
          const failedToFetchStudentsTranslation = await firstValueFrom(this.translate.get('failedToFetchStudents')); 
          customToastr(failedToFetchStudentsTranslation, 'error');
        }
      );
  }

  openEditStudentCategory(category) {
    this.addNewStudentCategory = {
      numberOfStudents: category.totalStudents,
      name: category.Name,
      description: category.Description,
      remainingDescriptionLength: 300,
      studentCategoryId: category.pkStudentsCategoryId
    };
    this.checkDescriptionLength(this.addNewStudentCategory, 'addNewStudentCategory');
  }

  openDeleteStudentCategory(category) {
    this.deleteStudentCategoryDetails = category;
  }

  openAssignStudentsToStudentCategory(category) {
    const searchInput = document.getElementById('groupbutton12') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
    const classId = document.getElementById('select-class-to-search-student') as HTMLInputElement;
    if (classId) {
      classId.value = '';
    }
    this.applyStudentCategorySearchStudentTable();
    this.studentCategorySearchStudentResults = [];
    this.searchStudentForCategory()
    this.schoolClasses = [];
    this.addNewStudentCategory = {
      numberOfStudents: category.totalStudents,
      name: category.Name,
      description: category.Description,
      remainingDescriptionLength: 300,
      studentCategoryId: category.pkStudentsCategoryId
    };

    $('#assign-students-to-category').attr('studentCategoryId', category.pkStudentsCategoryId);
    this.feeService.getClassListOfSchool()
      .subscribe(
        (data: any) => {
          this.schoolClasses = data;
        },
        error => {
        }
      );
    if (this.existingCategoryStudentListTable !== null) {
      this.existingCategoryStudentListTable.destroy();
      this.existingCategoryStudentListTable = null;
    }
    this.applyStudentCategoryListTable();
  }

  deleteStudentCategory(id) {
    this.isProcessing = true;
    this.feeService.deleteStudentCategory(id, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {
          this.isProcessing = false;
          if (data.status) {
            const studentCategorySuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('studentCategorySuccessfullyDeleted')); 
            customToastr(studentCategorySuccessfullyDeletedTranslation, 'success');
            $('#deletebuspopup').trigger('click');
            this.getStudentCategoryList(null, null);
          } else {
            const failedToDeleteCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteCategoryPleaseTryAgain')); 
            customToastr(failedToDeleteCategoryPleaseTryAgainTranslation, 'error');
          }
        },
        async error => {
          const failedToDeleteCategoryPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteCategoryPleaseTryAgain')); 
          customToastr(failedToDeleteCategoryPleaseTryAgainTranslation, 'error');
        }
      );
  }

  async searchStudentForCategory() {
    this.searchStudentListForCategorySelectedCount = 0;
    let text = $('#groupbutton12').val();
    let classId = $('#select-class-to-search-student').val();
    text = text.trim();
    if (classId == 0) {
      classId = null;
    }
    if (!text || text === '') {
      text = null;
    }
    const h = this;
    if (text !== '') {
      if (this.searchStudentListForCategoryTable !== null) {
        this.searchStudentListForCategoryTable.destroy();
        this.searchStudentListForCategoryTable = null;
      }
      this.feeService.searchStudentToAssignCategory(classId, text, this.academicInfo.current_academic)
        .subscribe(
          (data: any) => {
            this.studentCategorySearchStudentResults = data;
            setTimeout(() => {
              h.applyStudentCategorySearchStudentTable();
            }, 100);

          },
          error => {
          }
        );
    } else {
      const pleaseEnterStudentNameToSearchTranslation = await firstValueFrom(this.translate.get('pleaseEnterStudentNameToSearch')); 
      customToastr(pleaseEnterStudentNameToSearchTranslation, 'error');
    }
  }

  selectAllStudentCategorySearchStudentResults(isChecked) {
    this.searchStudentListForCategorySelectedCount = 0;
    const h = this;
    this.studentCategorySearchStudentResults.forEach((data: any) => {
      if (data.paidFees > 0) {
        data.selected = false;
      } else {
        data.selected = isChecked;
      }
      h.searchStudentListForCategorySelectedCount = data.selected ?
        (h.searchStudentListForCategorySelectedCount + 1) : h.searchStudentListForCategorySelectedCount;
    });
  }

  checkOUncheckSelectStd(s) {
    this.searchStudentListForCategorySelectedCount = s ?
      (this.searchStudentListForCategorySelectedCount + 1) : (this.searchStudentListForCategorySelectedCount - 1);
  }

applyStudentCategorySearchStudentTable() {
  if (this.searchStudentListForCategoryTable === null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.info',
      'dataTables.zeroRecords',
      'dataTables.paginate.previous',
      'dataTables.paginate.next'
    ]).subscribe(translations => {
      this.searchStudentListForCategoryTable = $('#search-student-list-for-category').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        language: {
          emptyTable: translations['dataTables.sEmptyTable'],
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i> ' + translations['dataTables.search'],
          info: translations['dataTables.info'],
          zeroRecords: translations['dataTables.zeroRecords'],
          paginate: {
            previous: '<i class="fa fa-angle-left"></i> ' + translations['dataTables.paginate.previous'],
            next: translations['dataTables.paginate.next'] + ' <i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
  }
}


  async assignStudentsToCategory() {
    const students = [];
    this.studentCategorySearchStudentResults.forEach((data: any) => {
      if (data.selected) {
        students.push(data);
      }
    });

    if (students.length > 0) {
      this.isProcessing = true;
      this.feeService.addStudentsToStudentCategory(students, this.addNewStudentCategory.studentCategoryId,
        this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            this.isProcessing = false;
            if (data.status) {
              const studentsAreSuccessfullyAssignedTranslation = await firstValueFrom(this.translate.get('studentsAreSuccessfullyAssigned')); 
              customToastr(studentsAreSuccessfullyAssignedTranslation, 'success');
              this.addNewStudentCategory.numberOfStudents = this.addNewStudentCategory.numberOfStudents + students.length;
              this.searchStudentForCategory();
              this.applyStudentCategoryListTable();
            } else {
              const failedToAssignStudentsTranslation = await firstValueFrom(this.translate.get('failedToAssignStudents')); 
              customToastr(failedToAssignStudentsTranslation, 'error');
            }
          },
          async error => {
            this.isProcessing = false;
            const failedToAssignStudentsTranslation = await firstValueFrom(this.translate.get('failedToAssignStudents')); 
            customToastr(failedToAssignStudentsTranslation, 'error');
          }
        );
    } else {
      const youHaveNotSelectedAnyStudentsTranslation = await firstValueFrom(this.translate.get('youHaveNotSelectedAnyStudents')); 
      customToastr(youHaveNotSelectedAnyStudentsTranslation, 'error');
    }
  }

  applyStudentCategoryListTable() {
    this.isProcessing = false;
    const token = this.authToken;
    const h = this;
    if (this.existingCategoryStudentListTable === null) {
      this.translate.get([
          'dataTables.sEmptyTable',
          'dataTables.lengthMenu',
          
        ]).subscribe(translations => {
      this.existingCategoryStudentListTable = $('#existing-student-list-category').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: translations['dataTables.sEmptyTable']
        },
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          },
          processing: '<h3 style=\'color: var(--brand-primary-color);font-size: 2em;font-weight: 100;\'>Please wait...</h3>'
        },
        destroy: true,
        processing: true,
        serverSide: true,
        ajax: {
          beforeSend(request) {
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('authToken', token);
          },
          url: AppSettings.API_ENDPOINT + '/studentCategories/studentsInCategory',
          type: 'POST',
          data(d) {
            return JSON.stringify({
              schoolId: localStorage.getItem('schoolinfo'),
              current_academic: h.academicInfo.current_academic,
              studentCategoryId: $('#assign-students-to-category').attr('studentCategoryId'),
              countFrom: d.start,
              lengthOf: d.length,
              search: d.search.value,
              sort: d.order
            });
          }
        },
        columns: [
          { data: 'studentName' },
          { data: 'parentName' },
          { data: 'className' },
          { data: 'mobileNumber' },
          { data: 'manage', class: 'manage' }
        ],
        createdRow: (row, data, index) => {
          $(row).find('.manage')
            .append('<a data-toggle="modal" data-target="#remove-student-from-group" ' +
              'class="btn btn-flat ink-reaction btn-default edit-std">' +
              '<i class="fa fa-edit"></i></a><a class="btn btn-flat ink-reaction remove-std hide">' +
              '<i class="fa fa-times"></i></a>');
          $(row).find('.manage').find('.edit-std').on('click', () => {
            h.selectedStudentIdToMove = data.studentId;
            h.selectedStudentCategoryMemberId = data.pkStudentCategoryMembersId;
            h.selectedCategoryToMove = h.addNewStudentCategory.studentCategoryId;
            // $("#remove-student-from-group").modal('show');
          });
        }
      });
    });
    } else {
      this.existingCategoryStudentListTable.ajax.reload();
    }
  }

  onChangeStudentCategorySelection(catId) {
    if (catId !== this.addNewStudentCategory.studentCategoryId) {

    } else {

    }
  }

  async moveStudentToAnotherCategory(studentId, categoryId) {
    if (this.formValidator.validateIsDataForNumber(studentId) && this.formValidator.validateIsDataForNumber(categoryId) &&
      this.formValidator.validateIsDataForNumber(this.selectedStudentCategoryMemberId)) {
      this.isProcessing = true;
      if (this.addNewStudentCategory.studentCategoryId == "0") {
        this.addNewStudentCategory.studentCategoryId = null;
      }
      this.feeService.moveStudentToAnotherStudentCategory(studentId, categoryId, this.selectedStudentCategoryMemberId,
        this.addNewStudentCategory.studentCategoryId, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            this.isProcessing = false;
            if (data.status) {
              const studentHasBeenSuccessfullyMovedTranslation = await firstValueFrom(this.translate.get('studentHasBeenSuccessfullyMoved')); 
              customToastr(studentHasBeenSuccessfullyMovedTranslation, 'success');
              $('body').find('.modal-backdrop').trigger('click');
              // $("#remove-student-from-group").modal('hide');
              this.getStudentCategoryList(this.addNewStudentCategory.studentCategoryId, null);
            } else if (data.message) {
              customToastr(data.message, 'error');
            } else {
              const failedToMoveStudentToAnotherCategoryTranslation = await firstValueFrom(this.translate.get('failedToMoveStudentToAnotherCategory')); 
              customToastr(failedToMoveStudentToAnotherCategoryTranslation, 'error');
            }
          },
          async error => {
            this.isProcessing = false;
            const failedToMoveStudentToAnotherCategoryTranslation = await firstValueFrom(this.translate.get('failedToMoveStudentToAnotherCategory')); 
            customToastr(failedToMoveStudentToAnotherCategoryTranslation, 'error');
          }
        );
    } else {
      const movingStudentToAnotherCategoryFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('movingStudentToAnotherCategoryFailedPleaseTryAgain')); 
      customToastr(movingStudentToAnotherCategoryFailedPleaseTryAgainTranslation, 'error');
    }
  }

  openCreateFeeStructure() {
    this.getStudentCategoryList(null, 'YES');
    this.addNewFeeStructure = JSON.parse(JSON.stringify(this.newAddNewFeeStructure));
  }

  openEditFeeStructure(structure) {
    this.getStudentCategoryList(null, null);
    this.addNewFeeStructure = {
      name: structure.Name,
      description: structure.Description,
      remainingDescriptionLength: 300,
      studentCategoryId: structure.fkStudentsCategoryId,
      feeStructureId: structure.pkFeeStructuresId,
      appliesTo: structure.appliesTo,
      collectedAmount: structure.collectedAmount
    };
    this.checkDescriptionLength(this.addNewFeeStructure, 'addNewFeeStructure');
  }

  async addFeeStructure(createDetails) {
    if (this.formValidator.validateIsData(createDetails.name) &&
      this.formValidator.validateIsDataForNumber(createDetails.studentCategoryId)) {
      if (!createDetails.feeStructureId) {
        this.isProcessing = true;
        this.feeService.createFeeStructure(createDetails.name, createDetails.studentCategoryId,
          createDetails.description, this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              this.isProcessing = false;
              if (data.status) {
                this.getFeeStructure();
                const newFeesStructureAddedSuccessfullyTranslation = await firstValueFrom(this.translate.get('newFeesStructureAddedSuccessfully')); 
                customToastr(newFeesStructureAddedSuccessfullyTranslation, 'success');
                $('#close-create-fee-structure').trigger('click');
              } else if (data.message === 'AlreadyExist') {
                const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                customToastr( '<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
              } else {
                const failedToCreateNewFeeStructurePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewFeeStructurePleaseTryAgain')); 
                customToastr(failedToCreateNewFeeStructurePleaseTryAgainTranslation, 'error');
              }
            },
            async error => {
              this.isProcessing = false;
              const failedToCreateNewFeeStructurePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateNewFeeStructurePleaseTryAgain')); 
              customToastr(failedToCreateNewFeeStructurePleaseTryAgainTranslation, 'error');
            }
          );
      } else {
        const catId = $('#selectStudentCategory').val();
        const criteria = {
          name: createDetails.name,
          description: createDetails.description,
          studentCategoryId: catId,
          feeStructureId: createDetails.feeStructureId
        };

        this.isProcessing = true;
        this.feeService.updateFeeStructure(criteria, this.academicInfo.current_academic)
          .subscribe(
            async (data: any) => {
              this.isProcessing = false;
              if (data.status) {
                this.getFeeStructure();
                const feesStructureUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('feesStructureUpdatedSuccessfully')); 
                customToastr(feesStructureUpdatedSuccessfullyTranslation, 'success');
                $('#close-create-fee-structure').trigger('click');
              } else if (data.message === 'AlreadyExist') {
                const alreadyExistPleaseTryDifferentNameTranlation = await firstValueFrom(this.translate.get('alreadyExistPleaseTryDifferentName'))
                customToastr( '<b>' + createDetails.name + '</b> ' + alreadyExistPleaseTryDifferentNameTranlation, 'error');
              } else {
                const failedToUpdateFeeStructurePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeeStructurePleaseTryAgain')); 
                customToastr(failedToUpdateFeeStructurePleaseTryAgainTranslation, 'error');
              }
            },
            async error => {
              this.isProcessing = false;
              const failedToUpdateFeeStructurePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateFeeStructurePleaseTryAgain')); 
              customToastr(failedToUpdateFeeStructurePleaseTryAgainTranslation, 'error');
            }
          );
      }
    } else {
      const pleaseProvideStructureNameAndStudentsCategoryTranslation = await firstValueFrom(this.translate.get('pleaseProvideStructureNameAndStudentsCategory')); 
      customToastr(pleaseProvideStructureNameAndStudentsCategoryTranslation, 'error');
    }
  }

  openDeleteFeeStructure(structureId) {
    this.selectedStructureId = structureId;
  }

  deleteFeeStructure() {
    $('#deleteStructButton').attr('disabled', true);
    $('#cancelDeletestructButton').attr('disabled', true);
    this.translate.get('pleaseWait').subscribe((translatedText: string) => { $('#deleteStructButton').text(translatedText); });
    this.feeService.deleteFeeStructure(this.selectedStructureId, this.academicInfo.current_academic)
      .subscribe(
        async (data: any) => {
          $('#deleteStructButton').attr('disabled', false);
          $('#cancelDeletestructButton').attr('disabled', false);
          this.translate.get('ok').subscribe((translatedText: string) => { $('#deleteStructButton').text(translatedText); });
          if (data[0].message === 'Success') {
            const selectedFeesStructureIsSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('selectedFeesStructureIsSuccessfullyDeleted')); 
            customToastr(selectedFeesStructureIsSuccessfullyDeletedTranslation, 'success');
            this.getFeeStructure();
            $('#cancelDeletestructButton').trigger('click');
          } else {
           const someStudentAlreadyPaidSoItCannTBeDeletedTranslation = await firstValueFrom(this.translate.get('someStudentAlreadyPaidSoItCannTBeDeleted')); 
           customToastr(someStudentAlreadyPaidSoItCannTBeDeletedTranslation, 'error');
          }
        },
         error => async () => {
          $('#deleteStructButton').attr('disabled', false);
          $('#cancelDeletestructButton').attr('disabled', false);
          this.translate.get('ok').subscribe((translatedText: string) => { $('#deleteStructButton').text(translatedText); });
          const faildToDeleteFeeStructurePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('faildToDeleteFeeStructurePleaseTryAgain')); 
          customToastr(faildToDeleteFeeStructurePleaseTryAgainTranslation, 'error');
        }
      );
  }

  getFeeStructure() {
    this.structureList = [];
    this.destroyDataTable('fee-structure-list');
    this.feeService.fetchFeeStructure(this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          this.structureList = data;
          this.initializeDataTable('fee-structure-list');
        },
        error => () => {

        }
      );
  }

  openDeleteFeePopup(collectedFee, id, method) {
    this.changePopupState = id;
    const deletingFeeList = [];
    this.selectedFeeToDelete = collectedFee;
    if (!this.selectedFeeToDelete.fkStudentId && this.selectedFeeToDelete.studentId) {
      this.selectedFeeToDelete.fkStudentId = this.selectedFeeToDelete.studentId;
    }
    const deletingFees = [];
    for (const item of this.feeCollectionHistoy) {
      if (item.ReceiptNumber === this.selectedFeeToDelete.ReceiptNumber) {
        deletingFeeList.push(item);
      }
    }
    this.deletingFeeList = deletingFeeList;
    this.selectedReasonToDeleteFee = '0';
    this.newReasonToDeleteFee = '';
    this.passwordToDeleteFee = '';
    this.updateFeeReasonsList = [];
    this.deleteFeeStep = 1;
    this.reasonId = null;
    this.reason = null;
    this.feeService.getDeleteFeeCollectionReasons()
      .subscribe(
        (data: any) => {
          this.updateFeeReasonsList = data;
        },
        error => {
          this.updateFeeReasonsList = [];
        }
      );
  }

  async deleteFee(step) {
    $('body').find('#delete-fee-button').text('Delete');
    if (step === 1) {
      if (this.selectedReasonToDeleteFee === 'NEW' && !this.formValidator.validateIsData(this.newReasonToDeleteFee)) {
        const pleaseProvideReasonTranslation = await firstValueFrom(this.translate.get('pleaseProvideReason')); 
        customToastr(pleaseProvideReasonTranslation, 'error');
        return;
      } else if (this.selectedReasonToDeleteFee === '0') {
        const pleaseSelectReasonTranslation = await firstValueFrom(this.translate.get('pleaseSelectReason')); 
        customToastr(pleaseSelectReasonTranslation, 'error');
        return;
      }

      if (this.selectedReasonToDeleteFee === 'NEW' && this.formValidator.validateIsData(this.newReasonToDeleteFee)) {
        this.reason = this.newReasonToDeleteFee;
      } else {
        this.reasonId = this.selectedReasonToDeleteFee;
      }
      this.deleteFeeStep = 2;
    } else if (step === 2) {
      if (!this.formValidator.validateIsData(this.passwordToDeleteFee)) {
       const pleaseEnterYourLoginPasswordToProceedTranslation = await firstValueFrom(this.translate.get('pleaseEnterYourLoginPasswordToProceed')); 
       customToastr(pleaseEnterYourLoginPasswordToProceedTranslation, 'error');
        return;
      }
      $('body').find('#delete-fee-button').text('Please wait...');
      $('body').find('#delete-fee-button').attr('disabled', true);
      this.feeService.deleteCollectedFee(this.selectedFeeToDelete.pkFeesCollectionId, this.selectedFeeToDelete.fkStudentId,
        this.reasonId, this.reason, this.passwordToDeleteFee, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {
            $('body').find('#delete-fee-button').text('Delete');
            $('body').find('#delete-fee-button').attr('disabled', false);
            if (data.status) {
              if (this.changePopupState) {
                this.closeDeleteFee(this.changePopupState);
              }
              const feeSuccessfullyCanceledTranslation = await firstValueFrom(this.translate.get('feeSuccessfullyCanceled')); 
              customToastr(feeSuccessfullyCanceledTranslation, 'success');
              $('.close-delete-fee').trigger('click');
              this.selectedFeeToDelete = null;
              this.selectedReasonToDeleteFee = '0';
              this.newReasonToDeleteFee = '';
              this.passwordToDeleteFee = '';
              this.updateFeeReasonsList = [];
              this.deleteFeeStep = 1;
              this.reasonId = null;
              this.reason = null;
              this.getFeeCollectionHistory(this.studentFeeDashDetails.student.studentId, this.studentFeeDashDetails.student.classId,
                this.feeHistoryPageNumber);
              this.getFeeCollectionUpdateHistory(this.studentFeeDashDetails.student.studentId,
                this.studentFeeDashDetails.student.classId, this.feeHistoryPageNumber);
              this.fetchFeeCollectionInfo(this.lastSelectedStudent);
            } else if (data.errorcode === '10012') {
              const youEnteredAWrongPasswordTranslation = await firstValueFrom(this.translate.get('youEnteredAWrongPassword')); 
              customToastr(youEnteredAWrongPasswordTranslation, 'error');
            } else {
              const failedToCancelTheFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCancelTheFeePleaseTryAgain')); 
              customToastr(failedToCancelTheFeePleaseTryAgainTranslation, 'error');
            }
          },
          async error => {
            $('body').find('#delete-fee-button').text('Delete');
            $('body').find('#delete-fee-button').attr('disabled', false);
            const failedToCancelTheFeePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCancelTheFeePleaseTryAgain')); 
            customToastr(failedToCancelTheFeePleaseTryAgainTranslation, 'error');
          }
        );
    }
  }

  getSectionsListFromStudentsCategory(feeStructureId) {
    this.classSectionsInStudentCategory = [];
    const h = this;
    this.feeService.getSectionsListFromStudentsCategory(feeStructureId, this.academicInfo.current_academic)
      .subscribe(
        (data: any) => {
          if (data.errorcode) {
          } else {
            this.classSectionsInStudentCategory = data;
            if (!feeStructureId) {
              setTimeout(() => {
                $('#selectSectionId').val(h.classSectionsInStudentCategory[0].classId);
                h.searchStudentsForApplyDiscount();
              }, 20);

            }
          }
        },
        error => {
        }
      );
  }

  applySearchApplyDiscountStudentsList() {
    this.isProcessing = false;
    const token = this.authToken;
    const h = this;
    if (this.applyDiscountStudentsList === null) {
      this.translate.get([
          'dataTables.sEmptyTable',
          'dataTables.lengthMenu',
          
        ]).subscribe(translations => {
      this.applyDiscountStudentsList = $('#searchStudentApplyDiscountTable').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: translations['dataTables.sEmptyTable']
        },
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          },
          processing: '<h3 style=\'color: var(--brand-primary-color);font-size: 2em;font-weight: 100;\'>Please wait...</h3>'
        }
      });
    });
    }

  }

  closeDeleteFee(id) {
    if (id) {
      $('#appliedDiscountStudent_open').trigger('click');
      this.appliedStudentDiscount(this.selectedDiscount.pkSchoolDiscountId, this.selectedDiscount);
      this.changePopupState = null;
    }
  }


  /*edit student functions start*/
  
  openEditStudentFrom(studentId) {
    const h = this;
   this.editStudentPopupComponent.openEditStudentFrom(studentId, null, this.academicInfo.current_academic_state === 'RUNNING');
  }
  openEditStudentPopupFunction(studentId: string) {
    this.openEditStudentPopup = true;
    this.openEditStudentFrom(studentId);
  }

  /*edit student functions end*/
  async createNewFeeConfigurationGroup() {
    if (this.formValidator.validateIsData(this.newConfigurationGroupName)) {
      this.feeService.createFeeConfigurationGroup(this.newConfigurationGroupName, this.academicInfo.current_academic)
        .subscribe(
          async (data: any) => {

            if (!data.errorcode) {
              if (data.message === 'SUCCESS') {
                const configurationGroupCreatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('configurationGroupCreatedSuccessfully')); 
                customToastr(configurationGroupCreatedSuccessfullyTranslation, 'success');
              } else if (data.message === 'EXISTS') {
                const configurationGroupWithSameNameAlreadyExistsPleaseTryDifferentNameTranslation = await firstValueFrom(this.translate.get('configurationGroupWithSameNameAlreadyExistsPleaseTryDifferentName')); 
                customToastr(configurationGroupWithSameNameAlreadyExistsPleaseTryDifferentNameTranslation, 'error');
              }
            } else {
              const failedToCreateConfigurationGroupPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateConfigurationGroupPleaseTryAgain')); 
              customToastr(failedToCreateConfigurationGroupPleaseTryAgainTranslation, 'error');
            }
          },
          error => {

          }
        );
    } else {
      const pleaseEnterConfigurationGroupNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterConfigurationGroupName')); 
      customToastr(pleaseEnterConfigurationGroupNameTranslation, 'error');
    }
  }

  /* Other fee implementations */
  applyOtherFeesTable() {

    if (this.otherFeeTable === null) {
      this.translate.get([
          'dataTables.sEmptyTable',
          'dataTables.lengthMenu',
          
        ]).subscribe(translations => {
      this.otherFeeTable = $('#school-other-fee-list').DataTable({
        dom: 'lCfrtip',
        order: [],
        colVis: {
          buttonText: 'Columns',
          overlayFade: 0,
          align: 'right'
        },
        oLanguage: {
          sEmptyTable: translations['dataTables.sEmptyTable']
        },
        language: {
          lengthMenu: translations['dataTables.lengthMenu'],
          search: '<i class="fa fa-search"></i>',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>'
          }
        }
      });
    });
    }
  }

  toggleStudentStatus() {
    // Call the function with the appropriate parameter based on the toggle state
    if (this.isStudentDeactiveStatusChecked) {
      this.changeStudentStatus(false);
    } else {
      this.changeStudentStatus(true);
    }
  }


  changeStudentStatus(status: boolean) {
    this.isStudentDeactivated = status;
    this.isSearchActive = true;
    (document.getElementById('groupbutton10') as HTMLInputElement).value = '';
    this.studentList = [];
  }

  afterTransportOptionsSaved() {
    this.openStudentTransportOptionSettingsPopup = false;
    this.searchStudent("YES");
  }

  transportOptionsPopupClose() {
    this.openStudentTransportOptionSettingsPopup = false;
  }

  afterStudentBasicInfoSaved() {
    this.openStudentBasicInfoPopup = false;
  }

  studentBasicInfoPopupClose() {
    this.openStudentBasicInfoPopup = false;
  }

  afterStudentContactInfoSaved() {
    this.openStudentContactInfoPopup = false;
  }

  studentContactInfoPopupClose() {
    this.openStudentContactInfoPopup = false;
  }

  feeReceiptClosed() {
    if (this.feeReceiptOpenedFrom === "AFTER_PAYMENT") {
      this.totalSelectedAmount = 0;
      $("#groupbutton10").val("");
      this.searchStudent("NO");
    }
  }
  toggleDiscount() {
    this.isStudentActiveForDiscount = !this.isStudentActiveForDiscount;
    this.searchStudentsForApplyDiscount();
  }

  editStudentPopupClose() {
    this.openEditStudentPopup = false;
  }

  editStudentOptionSaved() {
    this.openStudentTransportOptionSettingsPopup = false;
  }
  excelExportPopUp = false;
  downloadPendingReport = false;
  pendingActiveFilter = true;
  pendingDeactiveFilter = false;
  showReceivedBalanceSelection = true;
  showActualFeesGrandTotal = true;
  // showActualFeesGrandTotal = true;

  openExportReportConfiguration (){
    this.excelExportPopUp = !this.excelExportPopUp;
  }
  showActualFees = false;
  showTotalCollected = true;
  showTotalPending = false;
  showRowLevelTotal = true;
  showColumnLevelTotal = true;
  showGrandTotal = true;
  showReceived = true;
  showBalance = true;
  standardOption = false;
  showOtherFeeCollected = true;
  showOtherFee = false;
  showOtherFeePending = false;

  onStandardOptionChange(newValue: boolean){
    if(newValue){
      this.showTotalCollected = false;
      this.showRowLevelTotal = false;
      this.showColumnLevelTotal = false;
      this.showReceived = false;
      this.showBalance = false;
      this.showGrandTotal = false;
      this.showTotalPending = false;
      this.showActualFees = false;
      this.showOtherFeeCollected = false;
      this.showOtherFee = false;
      this.showOtherFeePending = false;
    }
    else{
      this.showTotalCollected = true;
      this.showRowLevelTotal = true;
      this.showColumnLevelTotal = true;
      this.showReceived = true;
      this.showBalance = true;
       this.showGrandTotal = true;
       this.showOtherFeeCollected = true;
    }
  }

  onDownloadPendingReportChange(value: boolean) {
    if (value) {
      this.standardOption = false;
    }
  }

  // function for export report
async exportToExcel() {
  if (this.downloadPendingReport) {
    this.exportPendingFeesReportExcel();
    return;
  }
  if(this.standardOption){
    this.exportMonthlyPendingReport();
    return;
  }
  const isTotalCollected = this.showTotalCollected;
  const isTotalPending = this.showTotalPending;
  const showOtherFeeActual = this.showOtherFee;
  const showOtherFeePending = this.showOtherFeePending;
  const showOtherFeeCollected = this.showOtherFeeCollected;
  const feesExactAmount = this.showActualFees;
  const isRowLevelTotal = this.showRowLevelTotal;
  const isColumnLevelTotal = this.showColumnLevelTotal;
  const isGrandTotal = this.showGrandTotal;
  const isBalance = this.showBalance;
  const isRecived = this.showReceived;

  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo);
  const schoolName = parsedInfo.schoolName;
  const academicInfo = this.academicInfo;
  const className = this.selectedClass.classNumber +"-"+ this.selectedClass.classDivision;

  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));

  const feesData: any[] = [];
  const feeEarliestDateMap = new Map<string, Date>();
  const otherFeeEarliestDateMap = new Map<string, Date>();

  // Use literal "Roll No." for header
  const feeHeader = ["Roll No.", getTranslation.studentName, getTranslation.parentName];

  // Get earliest due date per fee
  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    for (const fee of student.fees) {
      const feeName = fee.FeeName;
      const dueDate = new Date(fee.DueDate);
      if (isNaN(dueDate.getTime())) continue;

      const isOtherFee = fee.feesId?.startsWith("other_fee");

      if(isOtherFee) {
      const existing = otherFeeEarliestDateMap.get(feeName);
        if (!existing || dueDate < existing) {
          otherFeeEarliestDateMap.set(feeName, dueDate);
        }
      } else {
      const existing = feeEarliestDateMap.get(feeName);
      if (!existing || dueDate < existing) {
        feeEarliestDateMap.set(feeName, dueDate);
      }
      }
    }
  }

  const sortedFeeNames = Array.from(feeEarliestDateMap.entries())
    .sort((a, b) => a[1].getTime() - b[1].getTime())
    .map(([name]) => name);

  const sortedOtherFeeNames = Array.from(otherFeeEarliestDateMap.entries())
    .sort((a, b) => a[1].getTime() - b[1].getTime())
    .map(([name]) => name);

  // Build fee headers
  const actualFeesLabel = getTranslation.actualFees || "Actual Fees";
  const pendingLabel = getTranslation.pending || "Pending";
  for (const feeName of sortedFeeNames) {
    const feeHeaderName = feesExactAmount ? `${feeName} ${actualFeesLabel}` : feeName;

    if (feesExactAmount) feeHeader.push(feeHeaderName); // Actual fees column
    if (isTotalCollected) feeHeader.push(feeName); // Collected column
    if (isTotalPending) feeHeader.push(`${feeName} ${pendingLabel}`); // Pending column
  }

  const otherActualLabel = getTranslation.actualOther || "actual fees";
  const otherCollectedLabel = getTranslation.otherCollected || "";
  const otherPendingLabel = getTranslation.otherPending || "Pending";

   for (const feeName of sortedOtherFeeNames) {
    if (showOtherFeeActual) feeHeader.push(`${feeName} ${otherActualLabel}`);
    if (showOtherFeeCollected) feeHeader.push(`${feeName} ${otherCollectedLabel}`);
    if (showOtherFeePending) feeHeader.push(`${feeName} ${otherPendingLabel}`);
  }


  // Bus fee columns follow the same condition
  if (feesExactAmount) feeHeader.push(getTranslation.busFee || "Bus Fee");
  if (isTotalCollected) feeHeader.push(getTranslation.busFeeCollected || "Bus Fee Collected");
  if (isTotalPending) feeHeader.push(getTranslation.busFeePending || "Bus Fee Pending");

  // Row-level totals (exclude Total Collected, also for bus fee)
  if (isRowLevelTotal) {
    if (feesExactAmount) feeHeader.push(getTranslation.total || "Total");
    // Removed Total Collected for both normal fees & bus fee
    if (isTotalPending) feeHeader.push(getTranslation.totalPending || "Total Pending");
  }

  // New columns
  if (isGrandTotal) feeHeader.push(getTranslation.grandTotal || "Grand Total");
  if (isRecived) feeHeader.push(getTranslation.received || "Received");
  if (isBalance) feeHeader.push(getTranslation.balance || "Balance");

  // Fill student data
  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    const row: any = {
      "Roll No.": student.rollNumber || "",
      [getTranslation.studentName]: student.studentName,
      [getTranslation.parentName]: student.parentName
    };

    // Initialize all fee columns with NA
    for (const feeName of sortedFeeNames) {
      if (feesExactAmount) row[`${feeName} ${actualFeesLabel}`] = getTranslation.na;
      if (isTotalCollected) row[feeName] = getTranslation.na;
      if (isTotalPending) row[`${feeName} ${pendingLabel}`] = getTranslation.na;
    }


    for (const feeName of sortedOtherFeeNames) {
      if (showOtherFeeActual) row[`${feeName} ${otherActualLabel}`] = getTranslation.na;
      if (showOtherFeeCollected) row[`${feeName} ${otherCollectedLabel}`] = getTranslation.na;
      if (showOtherFeePending) row[`${feeName} ${otherPendingLabel}`] = getTranslation.na;
    }

    if (feesExactAmount) row[getTranslation.busFee || "Bus Fee"] = getTranslation.na;
    if (isTotalCollected) row[getTranslation.busFeeCollected || "Bus Fee Collected"] = getTranslation.na;
    if (isTotalPending) row[getTranslation.busFeePending || "Bus Fee Pending"] = getTranslation.na;

    let totalAmount = 0;
    let collectedAmount = 0;
    let totalDiscount = 0;
    for (const fee of student.fees) {
      const feeName = fee.FeeName;
      const isOtherFee = fee.feesId?.startsWith("other_fee");

      const total = fee.TotalAmount || 0;  
      // CollectedAmount includes the discount (a waiver, not money received):
      //   received (net) = CollectedAmount - discount, pending = max(0, total - CollectedAmount).
      const entries = (this.studentCollectedAmount || []).filter(
        f => f.fkStudentId === student.studentId && f.FeesId === fee.feesId
      );
      const grossCollected = entries.reduce((acc, f) => acc + (Number(f.CollectedAmount) || 0), 0);
      const discountAmount = entries.reduce((acc, f) => acc + (Number(f.discountAmount) || 0), 0);
      const collected = Math.max(0, grossCollected - discountAmount);
      const displayCollected: number | string = (entries.length > 0 && discountAmount >= total && total > 0) ? 'D' : collected;
      const pending = Math.max(0, total - grossCollected);
      totalDiscount += discountAmount;

      if (isOtherFee) {
        if (sortedOtherFeeNames.includes(feeName)) {
          if (showOtherFeeActual) row[`${feeName} ${otherActualLabel}`] = total;
          if (showOtherFeeCollected) row[`${feeName} ${otherCollectedLabel}`] = displayCollected;
          if (showOtherFeePending) row[`${feeName} ${otherPendingLabel}`] = pending;
          totalAmount += total;
          collectedAmount += collected;
        }
      } else {
        if (sortedFeeNames.includes(feeName)) {
          if (feesExactAmount) row[`${feeName} ${actualFeesLabel}`] = total;
          if (isTotalCollected) row[feeName] = displayCollected;
          if (isTotalPending) row[`${feeName} ${pendingLabel}`] = pending;
          totalAmount += total;
          collectedAmount += collected;
        }
      }
    }

    // Bus fee (same logic as normal fees)
    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    const busCollected = this.studentBusFeeCollection?.find(
      b => b.fkStudentId === student.studentId
    );

    if (bus) {
      const total = bus.BusFare;
      const collected = busCollected?.CollectedAmount || 0;
      const pending = total - collected;

      if (feesExactAmount) row[getTranslation.busFee || "Bus Fee"] = total;
      if (isTotalCollected) row[getTranslation.busFeeCollected || "Bus Fee Collected"] = collected;
      if (isTotalPending) row[getTranslation.busFeePending || "Bus Fee Pending"] = pending;

      totalAmount += total;
      collectedAmount += collected;
    }

    const totalAfterDiscount = totalAmount - totalDiscount;

    // Row-level totals (exclude Total Collected, also for bus fee)
    if (isRowLevelTotal) {
      if (feesExactAmount) row[getTranslation.total || "Total"] = totalAfterDiscount;
      if (isTotalPending) row[getTranslation.totalPending || "Total Pending"] = totalAfterDiscount - collectedAmount;
    }

    // New columns per student
    if (isGrandTotal) row[getTranslation.grandTotal || "Grand Total"] = totalAfterDiscount;
    if (isRecived) row[getTranslation.received || "Received"] = collectedAmount;
    if (isBalance) row[getTranslation.balance || "Balance"] = totalAfterDiscount - collectedAmount;

    feesData.push(row);
  }

  // Column-level total
  if (isColumnLevelTotal) {
    const totalsRow: any = {};
    for (const header of feeHeader) {
      if (header === "Roll No.") {
        totalsRow[header] = "";
        continue;
      }
      if (header === getTranslation.studentName) {
        totalsRow[header] = getTranslation.total || "Total";
        continue;
      }
      if (header === getTranslation.parentName) {
        totalsRow[header] = "";
        continue;
      }

      let sum = 0;
      for (const row of feesData) {
        const val = row[header];
        if (typeof val === "number") sum += val;
      }
      totalsRow[header] = sum;
    }
    feesData.push(totalsRow);
  }

  // Excel sheet creation
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);


// Add to worksheet
XLSX.utils.sheet_add_aoa(worksheet, [[`${schoolName}\nSession: ${academicInfo.year}\n${className}`]], { origin: "A1" });


  worksheet["A1"].s = {
    font: { name: "Arial", sz: 22, bold: true },
    alignment: { horizontal: "center" ,vertical: "center", wrapText: true },
    
  };

  worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: feeHeader.length - 1 } }];
  worksheet["!rows"] = [{ hpt: 120 }];
  XLSX.utils.sheet_add_aoa(worksheet, [feeHeader], { origin: "A2" });
  const rows = feesData.map(obj => feeHeader.map(h => obj[h]));
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: "A3" });

  for (let col = 0; col < feeHeader.length; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        font: { bold: true, color: { rgb: "FF0000" } },
        alignment: { horizontal: "center" }
      };
    }
  }

  for (let rowIdx = 0; rowIdx < rows.length; rowIdx++) {
    for (let colIdx = 0; colIdx < feeHeader.length; colIdx++) {
      const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 2, c: colIdx });
      const cell = worksheet[cellRef];
      if (cell && (cell.v === 'D' || cell.v === 'd')) {
        cell.s = {
          font: { bold: true, color: { rgb: "FF0000" } },
          alignment: { horizontal: "center" }
        };
      }
    }
  }

  const workbook: XLSX.WorkBook = {
    Sheets: { [getTranslation.sheetName || "Data"]: worksheet },
    SheetNames: [getTranslation.sheetName || "Data"]
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob: Blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  FileSaver.saveAs(
    blob,
    this.selectedClass?.classNumber && this.selectedClass?.classDivision
      ? `${this.selectedClass.classNumber}${this.selectedClass.classDivision}-Student Report.xlsx`
      : "Student Report.xlsx"
  );
  this.openExportReportConfiguration();
}

// function for print report
async exportToPrint() {
  if (this.downloadPendingReport) {
    this.exportPendingFeesReportPrint();
    return;
  }
  if (this.standardOption) {
    this.printMonthlyPendingReport();
    return;
  }

  const isTotalCollected = this.showTotalCollected;
  const isTotalPending = this.showTotalPending;
  const showOtherFeeActual = this.showOtherFee;
  const showOtherFeePending = this.showOtherFeePending;
  const showOtherFeeCollected = this.showOtherFeeCollected;
  const feesExactAmount = this.showActualFees;
  const isRowLevelTotal = this.showRowLevelTotal;
  const isColumnLevelTotal = this.showColumnLevelTotal;
  const isGrandTotal = this.showGrandTotal;
  const isBalance = this.showBalance;
  const isRecived = this.showReceived;

  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo!);
  const schoolName = parsedInfo.schoolName;

  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));

  const feesData: any[] = [];
  const feeEarliestDateMap = new Map<string, Date>();
  const otherFeeEarliestDateMap = new Map<string, Date>();

  const feeHeader = ["Roll No.", getTranslation.studentName, getTranslation.parentName];

  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    for (const fee of student.fees) {
      const feeName = fee.FeeName;
      const dueDate = new Date(fee.DueDate);
      if (isNaN(dueDate.getTime())) continue;

      const isOtherFee = fee.feesId?.startsWith("other_fee");

      if (isOtherFee) {
        const existing = otherFeeEarliestDateMap.get(feeName);
        if (!existing || dueDate < existing) otherFeeEarliestDateMap.set(feeName, dueDate);
      } else {
        const existing = feeEarliestDateMap.get(feeName);
        if (!existing || dueDate < existing) feeEarliestDateMap.set(feeName, dueDate);
      }
    }
  }

  const sortedFeeNames = Array.from(feeEarliestDateMap.entries())
    .sort((a, b) => a[1].getTime() - b[1].getTime())
    .map(([name]) => name);

  const sortedOtherFeeNames = Array.from(otherFeeEarliestDateMap.entries())
    .sort((a, b) => a[1].getTime() - b[1].getTime())
    .map(([name]) => name);

  const actualFeesLabel = getTranslation.actualFees || "Actual Fees";
  const pendingLabel = getTranslation.pending || "Pending";

  for (const feeName of sortedFeeNames) {
    const feeHeaderName = feesExactAmount ? `${feeName} ${actualFeesLabel}` : feeName;
    if (feesExactAmount) feeHeader.push(feeHeaderName);
    if (isTotalCollected) feeHeader.push(feeName);
    if (isTotalPending) feeHeader.push(`${feeName} ${pendingLabel}`);
  }

  const otherActualLabel = getTranslation.actualOther || "actual fees";
  const otherCollectedLabel = getTranslation.otherCollected || "";
  const otherPendingLabel = getTranslation.otherPending || "Pending";

  for (const feeName of sortedOtherFeeNames) {
    if (showOtherFeeActual) feeHeader.push(`${feeName} ${otherActualLabel}`);
    if (showOtherFeeCollected) feeHeader.push(`${feeName} ${otherCollectedLabel}`);
    if (showOtherFeePending) feeHeader.push(`${feeName} ${otherPendingLabel}`);
  }

  if (feesExactAmount) feeHeader.push(getTranslation.busFee || "Bus Fee");
  if (isTotalCollected) feeHeader.push(getTranslation.busFeeCollected || "Bus Fee Collected");
  if (isTotalPending) feeHeader.push(getTranslation.busFeePending || "Bus Fee Pending");

  if (isRowLevelTotal) {
    if (feesExactAmount) feeHeader.push(getTranslation.total || "Total");
    if (isTotalPending) feeHeader.push(getTranslation.totalPending || "Total Pending");
  }

  if (isGrandTotal) feeHeader.push(getTranslation.grandTotal || "Grand Total");
  if (isRecived) feeHeader.push(getTranslation.received || "Received");
  if (isBalance) feeHeader.push(getTranslation.balance || "Balance");

  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    const row: any = {
      "Roll No.": student.rollNumber || "",
      [getTranslation.studentName]: student.studentName,
      [getTranslation.parentName]: student.parentName
    };

    for (const feeName of sortedFeeNames) {
      if (feesExactAmount) row[`${feeName} ${actualFeesLabel}`] = getTranslation.na;
      if (isTotalCollected) row[feeName] = getTranslation.na;
      if (isTotalPending) row[`${feeName} ${pendingLabel}`] = getTranslation.na;
    }

    for (const feeName of sortedOtherFeeNames) {
      if (showOtherFeeActual) row[`${feeName} ${otherActualLabel}`] = getTranslation.na;
      if (showOtherFeeCollected) row[`${feeName} ${otherCollectedLabel}`] = getTranslation.na;
      if (showOtherFeePending) row[`${feeName} ${otherPendingLabel}`] = getTranslation.na;
    }

    if (feesExactAmount) row[getTranslation.busFee || "Bus Fee"] = getTranslation.na;
    if (isTotalCollected) row[getTranslation.busFeeCollected || "Bus Fee Collected"] = getTranslation.na;
    if (isTotalPending) row[getTranslation.busFeePending || "Bus Fee Pending"] = getTranslation.na;

    let totalAmount = 0;
    let collectedAmount = 0;
    let totalDiscount = 0;

    for (const fee of student.fees) {
      const feeName = fee.FeeName;
      const isOtherFee = fee.feesId?.startsWith("other_fee");
      const total = fee.TotalAmount || 0;

      // CollectedAmount includes the discount (a waiver, not money received):
      //   received (net) = CollectedAmount - discount, pending = max(0, total - CollectedAmount).
      const entries = (this.studentCollectedAmount || []).filter(
        f => f.fkStudentId === student.studentId && f.FeesId === fee.feesId
      );
      const grossCollected = entries.reduce((acc, f) => acc + (Number(f.CollectedAmount) || 0), 0);
      const discountAmount = entries.reduce((acc, f) => acc + (Number(f.discountAmount) || 0), 0);
      const collected = Math.max(0, grossCollected - discountAmount);
      const displayCollected: number | string = (entries.length > 0 && discountAmount >= total && total > 0) ? 'D' : collected;
      const pending = Math.max(0, total - grossCollected);

      // accumulate totals
      totalAmount += total;
      collectedAmount += collected;
      totalDiscount += discountAmount;

      if (isOtherFee) {
        if (sortedOtherFeeNames.includes(feeName)) {
          if (showOtherFeeActual) row[`${feeName} ${otherActualLabel}`] = total;
          if (showOtherFeeCollected) row[`${feeName} ${otherCollectedLabel}`] = displayCollected;
          if (showOtherFeePending) row[`${feeName} ${otherPendingLabel}`] = pending;
        }
      } else {
        if (sortedFeeNames.includes(feeName)) {
          if (feesExactAmount) row[`${feeName} ${actualFeesLabel}`] = total;
          if (isTotalCollected) row[feeName] = displayCollected;
          if (isTotalPending) row[`${feeName} ${pendingLabel}`] = pending;
        }
      }
    }

    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    const busCollected = this.studentBusFeeCollection?.find(
      b => b.fkStudentId === student.studentId
    );

    if (bus) {
      const total = bus.BusFare;
      const collected = busCollected?.CollectedAmount || 0;
      const pending = total - collected;

      if (feesExactAmount) row[getTranslation.busFee || "Bus Fee"] = total;
      if (isTotalCollected) row[getTranslation.busFeeCollected || "Bus Fee Collected"] = collected;
      if (isTotalPending) row[getTranslation.busFeePending || "Bus Fee Pending"] = pending;

      totalAmount += total;
      collectedAmount += collected;
    }
    const totalAfterDiscount = totalAmount - totalDiscount;
    const balanceAfterDiscount = totalAfterDiscount - collectedAmount;

    if (isRowLevelTotal) {
      if (feesExactAmount) row[getTranslation.total || "Total"] = totalAfterDiscount;
      if (isTotalPending) row[getTranslation.totalPending || "Total Pending"] = balanceAfterDiscount;
    }

    if (isGrandTotal) row[getTranslation.grandTotal || "Grand Total"] = totalAfterDiscount ;
    if (isRecived) row[getTranslation.received || "Received"] = collectedAmount;
    if (isBalance) row[getTranslation.balance || "Balance"] = balanceAfterDiscount;

    feesData.push(row);
  }

  if (isColumnLevelTotal) {
    const totalsRow: any = {};
    for (const header of feeHeader) {
      if (header === "Roll No.") {
        totalsRow[header] = "";
        continue;
      }
      if (header === getTranslation.studentName) {
        totalsRow[header] = getTranslation.total || "Total";
        continue;
      }
      if (header === getTranslation.parentName) {
        totalsRow[header] = "";
        continue;
      }
      let sum = 0;
      for (const row of feesData) {
        const val = row[header];
        if (typeof val === "number") sum += val;
      }
      totalsRow[header] = sum;
    }
    feesData.push(totalsRow);
  }

  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);
  const titlePad = new Array(feeHeader.length - 1).fill("");
  XLSX.utils.sheet_add_aoa(worksheet, [[...titlePad]], { origin: "B1" });
  XLSX.utils.sheet_add_aoa(worksheet, [feeHeader], { origin: "A1" });

  const rows = feesData.map(obj => feeHeader.map(h => obj[h]));
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: "A2" });

  for (let col = 0; col < feeHeader.length; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        font: { bold: true, color: { rgb: "FF0000" } },
        alignment: { horizontal: "center" }
      };
    }
  }

  const html = XLSX.utils.sheet_to_html(worksheet, {
    id: 'fee-report-table',
    header: '',
    footer: '',
    editable: false
  });

  // Printed via the app's #pf-print-area (index.html + styles.css) rather
  // than a div appended directly under <body>. The global print rule
  // (`body > :not(#pf-print-area) { display: none !important }`,
  // introduced in styles.css for the parent portal's receipt printing)
  // hides any OTHER direct child of <body> during print, so this method's
  // own #fee-report div was being hidden along with the rest of the page
  // — producing a blank printed page, which was this method's actual bug.
  const host = document.getElementById('pf-print-area');
  if (!host) {
    window.print();
    return;
  }

  const titleHtml = `<div>
  <div class="report-title">${schoolName}</div>
  <div class="report-subtitle">${"Session : "} ${this.academicInfo.year ? this.academicInfo.year : ""}</div>
  <div class="report-subtitle">${this.selectedClass?.classNumber && this.selectedClass?.classDivision ? `${this.selectedClass.classNumber}${"-"}${this.selectedClass.classDivision}` : ''}</div>
  </div>`;

  host.innerHTML = titleHtml + html;

  const table = host.querySelector('#fee-report-table') as HTMLTableElement;
  if (table) {
    const rows = Array.from(table.rows);
    if (rows.length > 0) {
      const thead = document.createElement('thead');
      const headerRow = rows[0];
      thead.appendChild(headerRow);
      table.insertBefore(thead, table.firstChild);

      const tbody = document.createElement('tbody');
      rows.slice(1).forEach(r => tbody.appendChild(r));
      table.appendChild(tbody);
    }

    table.querySelectorAll('td').forEach(td => {
      const value = td.textContent?.trim();
      if (value === 'D') {
        td.classList.add('discount-cell');
      }
    });
  }

  let style = document.getElementById('fee-print-style') as HTMLStyleElement;
  if (!style) {
    style = document.createElement('style');
    style.id = 'fee-print-style';
    style.innerHTML = `
      @media print {
        .discount-cell {
          color: red !important;
          font-weight: bold !important;
          text-align: center !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  requestAnimationFrame(() => {
    // Clear only after printing finishes: Chrome builds the preview after print() returns,
    // so emptying the area straight away printed a blank page.
    window.addEventListener('afterprint', () => { host.innerHTML = ''; }, { once: true });
    window.print();
  });
}



// export monthlt fees as per table
async exportMonthlyPendingReport() {
  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));
  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo || '{}');
  const schoolName = parsedInfo.schoolName || '';

  const feesData: any[] = [];
  const pendingLabel = getTranslation.pending || "Pending";

  const sortedFeeNames = (this.headerFeeName || []).map(f => typeof f === 'string' ? f : f.FeeName);

  const feeHeader = ["Roll No.", getTranslation.studentName, getTranslation.parentName];
  sortedFeeNames.forEach(fee => feeHeader.push(`${fee} ${pendingLabel}`));

  if (this.busDetail && this.busDetail.length > 0 && !sortedFeeNames.includes("Bus Fee")) {
    sortedFeeNames.push("Bus Fee");
    feeHeader.push(`Bus Fee ${pendingLabel}`);
  }

  feeHeader.push(getTranslation.totalCollected || "Total Collected");
  feeHeader.push(getTranslation.totalPending || "Total Pending");
  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    const row: any = {
      "Roll No.": student.rollNumber || "",
      [getTranslation.studentName]: student.studentName,
      [getTranslation.parentName]: student.parentName
    };

    let totalCollected = 0;
    let totalPending = 0;

    const totalAmountMap: any = {}; 
    const collectedMap: any = {};   
    for (const fee of student.fees) {
      totalAmountMap[fee.FeeName] = fee.TotalAmount || 0;
    }

    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    if (bus) {
      totalAmountMap['Bus Fee'] = bus.BusFare || 0;
    }

    for (const coll of this.studentCollectedAmount || []) {
      if (coll.fkStudentId === student.studentId) {
        const feeObj = student.fees.find(f => f.feesId === coll.FeesId);
        if (feeObj) collectedMap[feeObj.FeeName] = coll.CollectedAmount;
      }
    }

    const busColl = this.studentBusFeeCollection?.find(bc => bc.fkStudentId === student.studentId);
    if (bus && busColl) {
      collectedMap['Bus Fee'] = busColl.CollectedAmount;
    }

    for (const feeName of sortedFeeNames) {
      const total = totalAmountMap[feeName];
      const collected = collectedMap[feeName];

      let pending: string | number;
      if (total === undefined) {
        pending = getTranslation.na; 
      } else if (total === 0) {
        pending = 0; // total zero
      } else {
        pending = (total || 0) - (collected || 0); 
      }

      row[`${feeName} ${pendingLabel}`] = pending;

      if (typeof pending === "number") {
        totalCollected += collected || 0;
        totalPending += pending;
      }
    }

    row[getTranslation.totalCollected || "Total Collected"] = totalCollected;
    row[getTranslation.totalPending || "Total Pending"] = totalPending;

    feesData.push(row);
  }
  const className = this.selectedClass.classNumber +"-"+ this.selectedClass.classDivision;
  const academicInfo = this.academicInfo;
  // Excel sheet creation
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);
  XLSX.utils.sheet_add_aoa(worksheet, [[`${schoolName}\nSession: ${academicInfo.year}\n${className}`]], { origin: "A1" });
  worksheet["A1"].s = {
    font: { name: "Arial", sz: 22, bold: true },
    alignment: { horizontal: "center" ,vertical: "center", wrapText: true },
    
  };
  worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: feeHeader.length - 1 } }];
  worksheet["!rows"] = [{ hpt: 120 }];
  XLSX.utils.sheet_add_aoa(worksheet, [feeHeader], { origin: "A2" });

  const rows = feesData.map(obj => feeHeader.map(h => obj[h]));
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: "A3" });

  // Style header
  for (let col = 0; col < feeHeader.length; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = { font: { bold: true, color: { rgb: "FF0000" } }, alignment: { horizontal: "center" } };
    }
  }

  const workbook: XLSX.WorkBook = {
    Sheets: { [getTranslation.sheetName || "Data"]: worksheet },
    SheetNames: [getTranslation.sheetName || "Data"]
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob: Blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  FileSaver.saveAs(
    blob,
    this.selectedClass?.classNumber && this.selectedClass?.classDivision
      ? `${this.selectedClass.classNumber}${this.selectedClass.classDivision}-Pending Report.xlsx`
      : "Pending Report.xlsx"
  );

  this.openExportReportConfiguration();
}
async printMonthlyPendingReport() {
  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));
  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo || '{}');
  const schoolName = parsedInfo.schoolName || '';

  const feesData: any[] = [];
  const pendingLabel = getTranslation.pending || "Pending";

  const sortedFeeNames = (this.headerFeeName || []).map(f => typeof f === 'string' ? f : f.FeeName);

  const feeHeader = ["Roll No.", getTranslation.studentName, getTranslation.parentName];
  sortedFeeNames.forEach(fee => feeHeader.push(`${fee} ${pendingLabel}`));

  if (this.busDetail && this.busDetail.length > 0 && !sortedFeeNames.includes("Bus Fee")) {
    sortedFeeNames.push("Bus Fee");
    feeHeader.push(`Bus Fee ${pendingLabel}`);
  }

  feeHeader.push(getTranslation.totalCollected || "Total Collected");
  feeHeader.push(getTranslation.totalPending || "Total Pending");

  for (const student of this.allStudentAllFee) {
    if (student.isBlocked === 1) continue;

    const row: any = {
      "Roll No.": student.rollNumber || "",
      [getTranslation.studentName]: student.studentName,
      [getTranslation.parentName]: student.parentName
    };

    let totalCollected = 0;
    let totalPending = 0;
    const totalAmountMap: any = {};
    const collectedMap: any = {};

    for (const fee of student.fees) totalAmountMap[fee.FeeName] = fee.TotalAmount || 0;

    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    if (bus) totalAmountMap['Bus Fee'] = bus.BusFare || 0;

    for (const coll of this.studentCollectedAmount || []) {
      if (coll.fkStudentId === student.studentId) {
        const feeObj = student.fees.find(f => f.feesId === coll.FeesId);
        if (feeObj) collectedMap[feeObj.FeeName] = coll.CollectedAmount;
      }
    }

    const busColl = this.studentBusFeeCollection?.find(bc => bc.fkStudentId === student.studentId);
    if (bus && busColl) collectedMap['Bus Fee'] = busColl.CollectedAmount;

    for (const feeName of sortedFeeNames) {
      const total = totalAmountMap[feeName];
      const collected = collectedMap[feeName];
      let pending: string | number;

      if (total === undefined) pending = getTranslation.na;
      else if (total === 0) pending = 0;
      else pending = (total || 0) - (collected || 0);

      row[`${feeName} ${pendingLabel}`] = pending;

      if (typeof pending === "number") {
        totalCollected += collected || 0;
        totalPending += pending;
      }
    }

    row[getTranslation.totalCollected || "Total Collected"] = totalCollected;
    row[getTranslation.totalPending || "Total Pending"] = totalPending;
    feesData.push(row);
  }

  // === Generate printable HTML ===
  let html = `
    <html>
      <head>
        <title>${schoolName} - ${getTranslation.pendingReportTitle || "Pending Report"}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h2 { text-align: center; margin-bottom: 20px; }
          table { border-collapse: collapse; width: 100%; font-size: 12px; }
          th, td { border: 1px solid #000; padding: 6px; text-align: center; }
          th { background: #f2f2f2; font-weight: bold; }
          @media print {
            @page { size: landscape; }
          }
        </style>
      </head>
      <body>
      <div>
  <div class="report-title">${schoolName}</div>
      <div class="report-subtitle">${"Session : "} ${this.academicInfo.year ? this.academicInfo.year : ""}</div>
  <div class="report-subtitle">${this.selectedClass?.classNumber && this.selectedClass?.classDivision ? `${this.selectedClass.classNumber}${"-"}${this.selectedClass.classDivision}` : ''}</div>
  </div>
        <table>
          <thead>
            <tr>${feeHeader.map(h => `<th>${h}</th>`).join('')}</tr>
          </thead>
          <tbody>
            ${feesData.map(row =>
              `<tr>${feeHeader.map(h => `<td>${row[h] !== undefined ? row[h] : ''}</td>`).join('')}</tr>`
            ).join('')}
          </tbody>
        </table>
      </body>
    </html>
  `;

  // Printed via the app's #pf-print-area (index.html + styles.css) rather
  // than a div appended directly under <body>. The global print rule
  // (`body > :not(#pf-print-area) { display: none !important }`,
  // introduced in styles.css for the parent portal's receipt printing)
  // hides any OTHER direct child of <body> during print, so a sibling
  // #fee-report div is hidden along with the rest of the page, producing
  // a blank print — that was this method's actual bug. Also, assigning a
  // FULL "<html><head>...<body>...</body></html>" string to a <div>'s
  // innerHTML is invalid: browsers silently drop the <html>/<head>/<body>
  // wrapper tags (and the <style> block inside <head> along with them),
  // so the inline styles above were never actually applied either — fixed
  // by inlining the print-relevant styles via a real <style> element
  // appended alongside the content instead of inside a discarded <head>.
  const printArea = document.getElementById('pf-print-area');
  if (!printArea) {
    window.print();
    return;
  }

  const bodyMatch = html.match(/<body>([\s\S]*)<\/body>/);
  const styleMatch = html.match(/<style>([\s\S]*?)<\/style>/);
  printArea.innerHTML = `<style>${styleMatch ? styleMatch[1] : ''}</style>${bodyMatch ? bodyMatch[1] : html}`;

  requestAnimationFrame(() => {
    // Clear only after printing finishes: Chrome builds the preview after print() returns,
    // so emptying the area straight away printed a blank page.
    window.addEventListener('afterprint', () => { printArea.innerHTML = ''; }, { once: true });
    window.print();
  });
}




async exportPendingFeesReportExcel() {
  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));
  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo || '{}');
  const schoolName = parsedInfo.schoolName || '';

  const showAll = !this.pendingActiveFilter && !this.pendingDeactiveFilter;
  const filteredStudents = this.allStudentAllFee.filter(s => {
    if (showAll || (this.pendingActiveFilter && this.pendingDeactiveFilter)) return true;
    if (this.pendingActiveFilter) return s.isBlocked === 0;
    if (this.pendingDeactiveFilter) return s.isBlocked === 1;
    return true;
  });

  const pendingLabel = getTranslation.pending || 'Pending';
  const sortedFeeNames = (this.headerFeeName || []).map(f => typeof f === 'string' ? f : f.FeeName);

  const feeHeader = ['Roll No.', getTranslation.studentName || 'Student Name', getTranslation.parentName || 'Parent Name'];
  sortedFeeNames.forEach(fee => feeHeader.push(`${fee} ${pendingLabel}`));

  if (this.busDetail && this.busDetail.length > 0 && !sortedFeeNames.includes('Bus Fee')) {
    sortedFeeNames.push('Bus Fee');
    feeHeader.push(`Bus Fee ${pendingLabel}`);
  }

  feeHeader.push(getTranslation.totalCollected || 'Total Collected');
  feeHeader.push(getTranslation.totalPending || 'Total Pending');

  const feesData: any[] = [];
  let grandExpected = 0;
  let grandCollected = 0;
  let grandDiscount = 0;

  for (const student of filteredStudents) {
    const row: any = {
      'Roll No.': student.rollNumber || '',
      [getTranslation.studentName || 'Student Name']: student.studentName,
      [getTranslation.parentName || 'Parent Name']: student.parentName
    };

    let totalCollected = 0;
    let totalPending = 0;
    const totalAmountMap: any = {};
    const collectedMap: any = {};
    const discountMap: any = {};

    for (const fee of student.fees) totalAmountMap[fee.FeeName] = fee.TotalAmount || 0;

    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    if (bus) totalAmountMap['Bus Fee'] = bus.BusFare || 0;

    for (const coll of this.studentCollectedAmount || []) {
      if (coll.fkStudentId === student.studentId) {
        const feeObj = student.fees.find(f => f.feesId === coll.FeesId);
        if (feeObj) {
          collectedMap[feeObj.FeeName] = coll.CollectedAmount || 0;
          discountMap[feeObj.FeeName] = coll.discountAmount || 0;
        }
      }
    }

    const busColl = this.studentBusFeeCollection?.find(bc => bc.fkStudentId === student.studentId);
    if (bus && busColl) collectedMap['Bus Fee'] = busColl.CollectedAmount || 0;

    for (const feeName of sortedFeeNames) {
      const total = totalAmountMap[feeName];
      const collected = collectedMap[feeName] || 0;
      const discount = discountMap[feeName] || 0;
      let pending: string | number;

      if (total === undefined) {
        pending = getTranslation.na || 'N/A';
      } else if (total === 0) {
        pending = 0;
        grandExpected += 0;
        totalCollected += collected;
        grandCollected += collected;
      } else if (discount >= total) {
        pending = 'D';
        grandExpected += total;
        grandDiscount += discount;
      } else {
        pending = Math.max(0, total - collected - discount);
        totalCollected += collected;
        totalPending += pending;
        grandExpected += total;
        grandCollected += collected;
        grandDiscount += discount;
      }

      row[`${feeName} ${pendingLabel}`] = pending;
    }

    row[getTranslation.totalCollected || 'Total Collected'] = totalCollected;
    row[getTranslation.totalPending || 'Total Pending'] = totalPending;
    feesData.push(row);
  }

  const grandPending = grandExpected - grandCollected - grandDiscount;
  const className = `${this.selectedClass.classNumber}-${this.selectedClass.classDivision}`;
  const academicInfo = this.academicInfo;

  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);

  // Row 1: School name, session, class
  XLSX.utils.sheet_add_aoa(worksheet, [[`${schoolName}\nSession: ${academicInfo.year}\n${className}`]], { origin: 'A1' });
  worksheet['A1'].s = {
    font: { name: 'Arial', sz: 22, bold: true },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
  };
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: feeHeader.length - 1 } }];
  worksheet['!rows'] = [{ hpt: 120 }, { hpt: 40 }];

  // Row 2: Stats
  const statsRow = [
    `${getTranslation.expectedCollection || 'Expected Collection'}: ${grandExpected}`,
    `${getTranslation.feesCollected || 'Fees Collected'}: ${grandCollected}`,
    `${getTranslation.feePending || 'Fee Pending'}: ${grandPending}`,
    `${getTranslation.discountMade || 'Discount Made'}: ${grandDiscount}`
  ];
  XLSX.utils.sheet_add_aoa(worksheet, [statsRow], { origin: 'A2' });
  for (let col = 0; col < 4; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = { font: { bold: true, sz: 16 }, alignment: { horizontal: 'center' } };
    }
  }

  // Row 3: Headers
  XLSX.utils.sheet_add_aoa(worksheet, [feeHeader], { origin: 'A3' });
  for (let col = 0; col < feeHeader.length; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 2, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = { font: { bold: true, color: { rgb: 'FF0000' } }, alignment: { horizontal: 'center' } };
    }
  }

  // Row 4+: Data
  const rows = feesData.map(obj => feeHeader.map(h => obj[h]));
  XLSX.utils.sheet_add_aoa(worksheet, rows, { origin: 'A4' });

  // Style 'D' cells red
  for (let rowIdx = 0; rowIdx < rows.length; rowIdx++) {
    for (let colIdx = 0; colIdx < feeHeader.length; colIdx++) {
      const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 3, c: colIdx });
      const cell = worksheet[cellRef];
      if (cell && (cell.v === 'D' || cell.v === 'd')) {
        cell.s = { font: { bold: true, color: { rgb: 'FF0000' } }, alignment: { horizontal: 'center' } };
      }
    }
  }

  const workbook: XLSX.WorkBook = {
    Sheets: { [getTranslation.sheetName || 'Data']: worksheet },
    SheetNames: [getTranslation.sheetName || 'Data']
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(
    blob,
    this.selectedClass?.classNumber && this.selectedClass?.classDivision
      ? `${this.selectedClass.classNumber}${this.selectedClass.classDivision}-${getTranslation.pendingFeesReportTitle || 'Pending Fees Report'}.xlsx`
      : `${getTranslation.pendingFeesReportTitle || 'Pending Fees Report'}.xlsx`
  );
  this.openExportReportConfiguration();
}

async exportPendingFeesReportPrint() {
  const getTranslation = await firstValueFrom(this.translate.get('feeCollectionData'));
  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo || '{}');
  const schoolName = parsedInfo.schoolName || '';

  const showAll = !this.pendingActiveFilter && !this.pendingDeactiveFilter;
  const filteredStudents = this.allStudentAllFee.filter(s => {
    if (showAll || (this.pendingActiveFilter && this.pendingDeactiveFilter)) return true;
    if (this.pendingActiveFilter) return s.isBlocked === 0;
    if (this.pendingDeactiveFilter) return s.isBlocked === 1;
    return true;
  });

  const pendingLabel = getTranslation.pending || 'Pending';
  const sortedFeeNames = (this.headerFeeName || []).map(f => typeof f === 'string' ? f : f.FeeName);

  const feeHeader = ['Roll No.', getTranslation.studentName || 'Student Name', getTranslation.parentName || 'Parent Name'];
  sortedFeeNames.forEach(fee => feeHeader.push(`${fee} ${pendingLabel}`));

  if (this.busDetail && this.busDetail.length > 0 && !sortedFeeNames.includes('Bus Fee')) {
    sortedFeeNames.push('Bus Fee');
    feeHeader.push(`Bus Fee ${pendingLabel}`);
  }

  feeHeader.push(getTranslation.totalCollected || 'Total Collected');
  feeHeader.push(getTranslation.totalPending || 'Total Pending');

  const feesData: any[] = [];
  let grandExpected = 0;
  let grandCollected = 0;
  let grandDiscount = 0;

  for (const student of filteredStudents) {
    const row: any = {
      'Roll No.': student.rollNumber || '',
      [getTranslation.studentName || 'Student Name']: student.studentName,
      [getTranslation.parentName || 'Parent Name']: student.parentName
    };

    let totalCollected = 0;
    let totalPending = 0;
    const totalAmountMap: any = {};
    const collectedMap: any = {};
    const discountMap: any = {};

    for (const fee of student.fees) totalAmountMap[fee.FeeName] = fee.TotalAmount || 0;

    const bus = this.busDetail?.find(b => b.studentId === student.studentId);
    if (bus) totalAmountMap['Bus Fee'] = bus.BusFare || 0;

    for (const coll of this.studentCollectedAmount || []) {
      if (coll.fkStudentId === student.studentId) {
        const feeObj = student.fees.find(f => f.feesId === coll.FeesId);
        if (feeObj) {
          collectedMap[feeObj.FeeName] = coll.CollectedAmount || 0;
          discountMap[feeObj.FeeName] = coll.discountAmount || 0;
        }
      }
    }

    const busColl = this.studentBusFeeCollection?.find(bc => bc.fkStudentId === student.studentId);
    if (bus && busColl) collectedMap['Bus Fee'] = busColl.CollectedAmount || 0;

    for (const feeName of sortedFeeNames) {
      const total = totalAmountMap[feeName];
      const collected = collectedMap[feeName] || 0;
      const discount = discountMap[feeName] || 0;
      let pending: string | number;

      if (total === undefined) {
        pending = getTranslation.na || 'N/A';
      } else if (total === 0) {
        pending = 0;
        grandExpected += 0;
        totalCollected += collected;
        grandCollected += collected;
      } else if (discount >= total) {
        pending = 'D';
        grandExpected += total;
        grandDiscount += discount;
      } else {
        pending = Math.max(0, total - collected - discount);
        totalCollected += collected;
        totalPending += pending;
        grandExpected += total;
        grandCollected += collected;
        grandDiscount += discount;
      }

      row[`${feeName} ${pendingLabel}`] = pending;
    }

    row[getTranslation.totalCollected || 'Total Collected'] = totalCollected;
    row[getTranslation.totalPending || 'Total Pending'] = totalPending;
    feesData.push(row);
  }

  const grandPending = grandExpected - grandCollected - grandDiscount;
  const className = `${this.selectedClass?.classNumber}-${this.selectedClass?.classDivision}`;

  const html = `
    <html>
      <head>
        <title>${schoolName} - ${getTranslation.pendingFeesReportTitle || 'Pending Fees Report'}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .report-header { text-align: center; margin-bottom: 15px; }
          .report-header h2 { margin: 0; font-size: 20px; }
          .report-header p { margin: 2px 0; font-size: 14px; }
          .stats-section { display: flex; justify-content: space-around; margin: 15px 0; border: 1px solid #ddd; padding: 12px; background: #f5f5f5; border-radius: 4px; }
          .stat-item { text-align: center; }
          .stat-label { font-size: 15px; color: #555; margin-bottom: 6px; }
          .stat-value { font-size: 22px; font-weight: bold; color: #333; }
          table { border-collapse: collapse; width: 100%; font-size: 11px; margin-top: 10px; }
          th, td { border: 1px solid #000; padding: 5px; text-align: center; }
          th { background: #f2f2f2; font-weight: bold; }
          .discount-cell { color: red; font-weight: bold; }
          @media print { @page { size: landscape; } }
        </style>
      </head>
      <body>
        <div class="report-header">
          <h2>${schoolName}</h2>
          <p>${getTranslation.sessionLabel || 'Session'}: ${this.academicInfo.year || ''}</p>
          <p>${className}</p>
        </div>
        <div class="stats-section">
          <div class="stat-item">
            <div class="stat-label">${getTranslation.expectedCollection || 'Expected Collection'}</div>
            <div class="stat-value">${grandExpected}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">${getTranslation.feesCollected || 'Fees Collected'}</div>
            <div class="stat-value">${grandCollected}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">${getTranslation.feePending || 'Fee Pending'}</div>
            <div class="stat-value">${grandPending}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">${getTranslation.discountMade || 'Discount Made'}</div>
            <div class="stat-value">${grandDiscount}</div>
          </div>
        </div>
        <table>
          <thead>
            <tr>${feeHeader.map(h => `<th>${h}</th>`).join('')}</tr>
          </thead>
          <tbody>
            ${feesData.map(row =>
              `<tr>${feeHeader.map(h => {
                const val = row[h] !== undefined ? row[h] : '';
                return (val === 'D' || val === 'd')
                  ? `<td class="discount-cell">${val}</td>`
                  : `<td>${val}</td>`;
              }).join('')}</tr>`
            ).join('')}
          </tbody>
        </table>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (!printWindow) return;
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  // Close only after the print dialog finishes: closing right after print() can leave a blank preview.
  printWindow.onafterprint = () => printWindow.close();
  setTimeout(() => { printWindow.focus(); printWindow.print(); }, 500);
}

// function for export report with language support
async exportHeadwiseToExcel(name) {
const getPaymentTranslations = await firstValueFrom(
  this.translate.get('feesData')
);
console.log("getPaymentTranslations",getPaymentTranslations)
const fileName =getPaymentTranslations['totalLateFees'];
console.log(fileName);

  const schoolInfo = localStorage.getItem('schoolAllInfo');
  const parsedInfo = JSON.parse(schoolInfo);
  const schoolName = name;

  const dataRows = [];
  const headerRow = [];

  // Dynamic headers based on feeReportType
  if (this.feeReportType !== 'ACADEMIC_WISE') {
    headerRow.push('Date');
  } else {
    headerRow.push('Academic Year');
  }

  if (this.feeReportType === 'ALL_ACADEMICS') {
    headerRow.push('Academic');
  }

  for (const name of this.adminCollectedFees.allFeeNames) {
    headerRow.push(name);
  }

  headerRow.push(
  `${getPaymentTranslations.totalCashValue} (${this.currType})`,
  `${getPaymentTranslations.totalCardValue} (${this.currType})`,
  `${getPaymentTranslations.totalQRCode} (${this.currType})`,
  `${getPaymentTranslations.totalBankTransfer} (${this.currType})`,
  `${getPaymentTranslations.totalDD} (${this.currType})`,
  `${getPaymentTranslations.totalCheque} (${this.currType})`,
  `${getPaymentTranslations.totalOnline} (${this.currType})`,
  `${getPaymentTranslations.totalFeeValue} (${this.currType})`,
  `${getPaymentTranslations.totalLateFees} (${this.currType})`
);


  for (const f of this.adminCollectedFees.data) {
    const row = [];

    row.push(f.date || f.year);

    if (this.feeReportType === 'ALL_ACADEMICS') {
      row.push((f.academics || []).join(', '));
    }

    for (const feeName of this.adminCollectedFees.allFeeNames) {
      row.push(f[feeName] || 0);
    }

    row.push(
      f.totalCash || 0,
      f.totalCard || 0,
      f.collectedAsQRCode || 0,
      f.collectedAsBankTransfer || 0,
      f.collectedAsDD || 0,
      f.collectedAsCheque || 0,
      f.collectedAsOnline || 0,
      f.totalFee || 0,
      f.lateFees || 0
    );

    dataRows.push(row);
  }

  // Sheet Creation
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);
  XLSX.utils.sheet_add_aoa(worksheet, [[schoolName]], { origin: 'A1' });

  worksheet['A1'].s = {
    font: { name: 'Arial', sz: 22, bold: true },
    alignment: { horizontal: 'center' }
  };
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headerRow.length - 1 } }];

  XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A2' });
  XLSX.utils.sheet_add_aoa(worksheet, dataRows, { origin: 'A3' });

  // Style header
  for (let col = 0; col < headerRow.length; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: 1, c: col });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        font: { bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: 'center' }
      };
    }
  }

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Fee Collection Headwise': worksheet },
    SheetNames: ['Fee Collection Headwise']
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, getPaymentTranslations.feesHeadWiseReport+'.xlsx');
}
  

blockInvalidKeys(event: KeyboardEvent) {
  const invalidKeys = ['e', 'E', '+', '-'];
  if (invalidKeys.includes(event.key)) {
    event.preventDefault();
  }
}

  // function to allow number only in fees amount in late fee
  sanitizeAmountInput(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    this.lateFeesAmount = event.target.value;
  }
  // function to allow number only in fees days in late fee
  sanitizeDaysInput(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    this.lateFeesDays = event.target.value;
  }
  // function to open pop up to create late fees
  openCreateLateFee(data) {
    if (data) {
      this.selectedLateFeesId = data.pkLateFeesId;
      this.lateFeesDays = data.lateDays;
      this.lateFeesAmount = data.lateFees;
      this.showLateFeeAddComponent = !this.showLateFeeAddComponent;
      this.getLateFeeInfo();
    }
    else {
      this.selectedLateFeesId = "";
      this.lateFeesDays = "";
      this.lateFeesAmount = "";
      this.showLateFeeAddComponent = !this.showLateFeeAddComponent;
      this.selectAllFees = false; 
      this.selectAllTermFees = false;
      this.selectAllTypeFees = false;
      this.selectAllTransportFees = false;
      this.getAllFeesComponent();
    }
  }


  // api call to get all fees compoent
  async getAllFeesComponent() {
    try {
      this.isLoadingLateFees = true;
      const payload = {
        academicId: this.academicInfo.current_academic,
        lang: "en"
      }
      const response: any = await firstValueFrom(this.feeService.getAllFeesComponent(payload))
      if (response.status && response.body) {
        this.termFeeList = response.body.typeFeeList;
        this.feesList = response.body.feesTerms;
        this.transportList = response.body.busTermList;


      this.includeLateFeeInTransportFee = response.body.includeLateFeeInTransportFee;

      this.expandedItems = this.feesList.map((key) => key.isFeeSelected = false)

      this.selectAllFees = false;
      // this.selectAllTermFees = false;
      // this.selectAllTypeFees = false;
      // this.selectAllTransportFees = false;
      }
      this.isLoadingLateFees = false;
    }
    catch (error) {
      this.isLoadingLateFees = false;
    }
  }

  // functoin to expand fees list item
  expandItem(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }



  // function to update term fee array
  onFeeTermChange(fee: any, term: any) {
    const target = this.feesList.find((f) => f.feeTypeId === fee.feeTypeId);
    if (target) {
      const t = target.termList.find((tt: any) => tt.feeTermId === term.feeTermId);
      if (t) t.isFeeSelected = !!term.isFeeSelected;
      target.isFeeSelected = target.termList.every((tt: any) => tt.isFeeSelected);
    }
  }


  // function to get selected term fees
  getSelectedTermsFees() {
    return this.feesList
      .filter(key => key.isFeeSelected)
      .map(key => key.feeTermId);
  }

  // function to get type fees array
  getSelectedTypeFees() {
    return this.termFeeList
      .filter(key => key.isFeeSelected)
      .map(key => key.feeTypeId);
  }

  // fucntion for get array of bus term
  getBusTermIds() {
    return this.transportList
      .filter((key) => key.isFeeSelected)
      .map((key) => key.busStopTermId);
  }

  // function for update transport fee
  onFeeTransportFeeChange(id) {
    this.transportList = this.transportList.map((item) => {
      if (item.busStopTermId === id) {
        return {
          ...item,
          isFeeSelected: item.isFeeSelected === undefined ? true : !!item.isFeeSelected
        };
      }
      return item;
    });
  }

  // function call for update term array
  onFeeTermListChange(id) {
    this.termFeeList = this.termFeeList.map((item) => {
      if (item.feeTypeId === id) {
        return {
          ...item,
          isFeeSelected: item.isFeeSelected === undefined ? true : !!item.isFeeSelected
        };
      }
      return item;
    });

  }

  // api call for add late fees
  async addLateFees() {
    try {
      this.isAddingLateFees = true;
      const body = {
        lang: "en",
        lateDays: this.lateFeesDays,
        lateFee: this.lateFeesAmount,
        academicId: this.academicInfo.current_academic,
        busFeeTerms: this.getBusTermIds(),
        typeFees: this.getSelectedTypeFees(),
        feesTerms: this.getSelectedTermsFees(),
      }
      const response: any = await firstValueFrom(this.feeService.addLateFeesData(body))
      if (response.status && response.body) {
        this.openLateFeeTab()
        this.messageService.add({
          key: 'global',
          severity: 'success',
          summary: 'Success',
          detail: response.body.message
        });
        this.showLateFeeAddComponent = false;
        this.lateFeesAmount = "";
        this.lateFeesDays = "";
      }
      this.isAddingLateFees = false;
    }
    catch (error) {
      this.isAddingLateFees = false;
      this.messageService.add({
        key: 'global',
        severity: 'error',
        summary: 'Error',
        detail: error.error.message
      });
    }
  }

  // api call for update late fees
  async updateLateFees() {
    try {
      this.isAddingLateFees = true;
      const body = {
        lang: "en",
        lateDays: this.lateFeesDays ? (this.lateFeesDays).toString() : null,
        lateFee: this.lateFeesAmount ? (this.lateFeesAmount).toString() : null,
        academicId: this.academicInfo.current_academic,
        busFeeTerms: this.getBusTermIds(),
        typeFees: this.getSelectedTypeFees(),
        feesTerms: this.getSelectedTermsFees(),
        lateFeeId: this.selectedLateFeesId,
      }
      const response: any = await firstValueFrom(this.feeService.updtaeLateFeesData(body))
      if (response.status && response.body) {
        this.openLateFeeTab()
        this.messageService.add({
          key: 'global',
          severity: 'success',
          summary: 'Success',
          detail: response.body.message
        });
        this.showLateFeeAddComponent = false;
        this.lateFeesAmount = "";
        this.lateFeesDays = "";
      }
      this.isAddingLateFees = false;
    }
    catch (error) {
      this.isAddingLateFees = false;
      this.messageService.add({
        key: 'global',
        severity: 'error',
        summary: 'Error',
        detail: error.error.message
      });
    }
  }

  // function to get particular fees info
  async getLateFeeInfo() {
    try {
      this.isLoadingLateFees = true;
      const payload = {
        lang: "en",
        academicId: this.academicInfo.current_academic,
        lateFeeId: this.selectedLateFeesId
      }
      const response: any = await firstValueFrom(this.feeService.getLateFeesComponent(payload))
      if (response && response.body) {
        this.termFeeList = response.body.typeFeeList;
        this.feesList = response.body.feesTerms;
        this.transportList = response.body.busTermList;

        this.includeLateFeeInTransportFee = response.body.includeLateFeeInTransportFee || 0;
      
        // Call this to reset transport fees if disabled
        this.onIncludeLateFeeInTransportFeeChange(this.includeLateFeeInTransportFee);
        
        this.checkSelectAllStatus();
      }
      this.isLoadingLateFees = false;
    }
    catch (error) {
      this.isLoadingLateFees = false;
    }
  }
}